import { Fragment, useState, useRef, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, doc, onSnapshot, setDoc, deleteDoc, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { aiService } from '../services/aiService';
import applyRecipe, { slugifySource, petaSlug, targetKey, semuaSumber, kumpulNilai, cariPenanda, bersihJawapan, kiraSetBabak, medanPerBabak, templatMedan, jangkaanSumber, cariKotakKod, SUMBER_KOTAK } from '../utils/agentRecipe';
/* Rupa Langkah 4 v3.9 — komponen paparan sahaja, tiada logik. */
import ProStudioKonfigurV39 from './ProStudioKonfigurV39';
import { useT, useLang, cari } from '../i18n';
/* ⭐ KERJA B — blok binaan prototaip, dipakai HANYA apabila v39.
   Guna komponen SEBENAR (bukan salinan) supaya rupa hidup dan lakaran
   tidak boleh terpesong: satu takrifan, satu rupa. Rupa lama tidak
   menyentuhnya langsung. */
import { Kad as KadV39 } from './prostudioUI';
import { Btn as BtnV39 } from '../design/ui';
/* Susunan agent pilihan pelanggan. Pembanding + tulisan hidup di satu
   tempat sahaja — senarai ini, panel My Agent pada hub, dan pemilih agent
   di Workspace mesti menyusun dengan peraturan yang SAMA. */
import { alihItem, bandingAgent, bolehTarikTetikus, simpanSusunanAgent, sisipItem, susunanBaru } from '../utils/susunAgent';
/* ⛔ Pembina blok DATA PRODUK dikongsi dengan laluan larian pukal
   (WorkspaceView). Satu takrifan sahaja — lihat nota dalam fail itu. */
import { blokDataAgent, gabungArahanAgent } from '../services/productReadyService';
/* ★ Gambar daripada jawapan agent (2026-09-11) — satu takrifan untuk KEDUA-DUA
   laluan yang menghantar tugasan agent (Configure di sini + larian pukal Workspace). */
import { MAKS_GAMBAR_TAMBAHAN, normGambarAgent, imageTurnsDaripadaAgent, bilanganGambarDitanda, ringkasGambarProduk, hadMasaPusinganGambar } from '../utils/agentGambar';
import { adalahRalatSambungan, cubaSemulaSambungan } from '../utils/ralatExtension';
/* ★ Pemilih Gemini baharu (2026-10-11): tahap Low/Medium/High + akaun satu-model — satu
   takrifan untuk Configure di sini dan larian pukal Workspace. */
import { normTahapGemini, semakTahapGemini, modelTunggalGemini } from '../utils/geminiPemilih';
/* ★ Gambar TAMBAHAN item My Products (2026-09-13) — dihantar bersama gambar utama ke agent. */
import { senaraiTambahan } from '../utils/gambarTambahan';

// ============================================================
// "Agent Saya" — seksyen dalam PRO Studio (module SMART)
//
// Untuk segmen pelanggan yang BELI custom GPT / Gem daripada
// seller lain, dan mahu automate guna SESAAT.
//
// ── STATUS LOGIC (2026-07-27) ──
//   ✅ SEBENAR : simpan/muat agent ke Firestore
//                users/{uid}/chatgptTemplates/{id}  (agentV: 2)
//                — collection SEDIA ADA, rules sudah benarkan
//                  owner CRUD, jadi TIADA perubahan rules.
//   ⏳ BELUM   : ujian Configure sebenar (extension bridge +
//                AI padan). Butang Configure masih memainkan
//                CONTOH — lihat notis kuning dalam Langkah 4.
//                Padanan yang disimpan tetap disimpan sungguh.
//
// ⚠️ agentV:2 — penanda pembeza daripada template lama Smart
//    Custom yang berkongsi collection yang sama. Bila bar
//    Workspace disambung nanti, tapis guna penanda ini.
//
// ── Rangka 4 langkah (divalidasi user 2026-07-27) ──
//   1 Agent Anda        nama + platform + URL custom GPT
//   2 Hasil Yang Anda Mahu   ← TETAPKAN DULU (set, babak, gambar/
//                              video, gabung, gambar produk, avatar)
//   3 Borang Output          borang IKUT keputusan Langkah 2
//   4 Configure              uji 1 produk → AI padan → sahkan
//
//   Susunan ini SENGAJA: pelanggan tetapkan HASIL dahulu, barulah
//   borang mengikut. Kalau borang didahulukan, medan Prompt Video
//   terpaksa "kelabu ke belakang" bila pelanggan pilih Gambar
//   sahaja di langkah kemudian — membingungkan.
//
// ── Sempadan yang UI kena tunjuk dengan jujur ──
//   • 2 field ENJIN (prompt gambar + prompt video) — automation
//     Flow baca dua ini. Boleh rename, tak boleh buang.
//   • Set: 1-3 (keputusan user 2026-07-27).
//   • Babak: 1-8 — padan had sebenar enjin FLOWNITY
//     (flow-automation-flownity.js: clamp Math.min(8, sceneCount)).
//   • ChatGPT dulu; Gemini (Gems) dikunci — automation Gem
//     memang BELUM PERNAH dibina.
//
// ── Nota grounding (apa enjin sedia ada dah boleh buat) ──
//   sceneCount 1-8      ✅ ada (product.sceneCount)
//   avatar              ✅ ada (product.avatarImageUrl, Step 9b)
//   gambar sahaja       ✅ flag ada (isImageOnly) — kini dipaku false
//   gambar produk       ⚠️ ada, tapi DIPAKU pada babak TERAKHIR
//                          (isRefScene = s === _sceneCount)
//   gabung SceneBuilder ✅ ada (laluan FLOWNITY / AI16SAAT) — SENTIASA ikut
//                          sceneCount; suis "gabung" agent DIBUANG 2026-09-12
//                          (tidak pernah diwayar ke mana-mana larian = kawalan palsu)
// ============================================================

/* ⛔ HAD BILANGAN AGENT DIBUANG (arahan user 2026-08-16).
   Dahulunya `MAX_AGENTS = 5`, ditulis semasa seksyen ini dibina pada
   27 Julai. Ia dibuang kerana tiga sebab, bukan kerana 5 terlalu kecil:

     1. Ia TIDAK PERNAH dikuatkuasakan. firestore.rules memberi pemilik
        CRUD penuh pada users/{uid}/chatgptTemplates tanpa had bilangan,
        dan tiada Cloud Function yang mengiranya. Ia menghalang butang,
        bukan data.
     2. Ia tidak mengikut pakej. Setiap kuota lain dalam produk membaca
        `licenses.maxProfiles` (Premium 3 · Fighter 6), jadi 5 menghadkan
        Fighter DI BAWAH pakejnya sendiri dan memberi Premium lebih.
     3. Dua pemalar di bawah ini ada asasnya — MAX_SETS daripada
        keputusan user, MAX_SCENES juga daripada keputusan user (had 5
        babak untuk Smart/ProStudio; enjin FLOWNITY sendiri boleh 8, tapi
        produk ini sengaja dikunci 5). MAX_AGENTS tiada asas begitu.

   ⚠️ Kalau had dikembalikan kelak, ia mesti dibaca daripada lesen dan
      dikuatkuasakan di sisi server — bukan sebagai nombor dalam fail
      UI, kerana itu tidak menghalang apa-apa. */
const MAX_SETS = 3;
const MAX_SCENES = 5;   // keputusan user 2026-08-18: Smart/ProStudio had 5 babak (enjin FLOWNITY boleh 8, produk ini dikunci 5)

/* ⭐ Berapa babak yang BETUL-BETUL boleh dijalankan oleh extension yang ada
   di tangan pelanggan HARI INI.

   1-2 babak berjalan atas enjin yang sudah didaftar dalam extension sekarang
   (1 babak = AI8SAAT, 2 babak = AI16SAAT), jadi ia sampai kepada pelanggan
   melalui deploy webapp sahaja.

   3-5 babak memerlukan enjin DINAMIK, dan enjin itu hanya wujud selepas
   keluaran extension v3.9. Sehingga itu, pilihan 3-5 DIKUNCI — kalau dibuka
   awal, pelanggan menekan Run dan tiada apa berlaku: larian jatuh ke skrip
   satu-babak dan menghasilkan SIFAR video, tanpa sebarang ralat.

   ⛔ NAIKKAN nilai ini kepada MAX_SCENES HANYA selepas extension v3.9 betul-
      betul tersebar kepada pelanggan — bukan sebaik kod enjin siap. */
const BABAK_SIAP_MAX = 2;
// Had balasan berturutan — SELARI dengan slice(0,5) dalam content.ts executeChatGPTTask.
const MAX_REPLIES = 5;

/* ⭐ Pemalar aras-modul TIDAK boleh memanggil useT(), jadi setiap ayat
   disimpan sebagai [kunci, ayatLalai]. `ayatLalai` ialah teks Melayu
   ASAL huruf demi huruf — ia yang menjaga rupa LAMA kekal Melayu (lihat
   nota `T` dalam komponen). Corak sama seperti MEDAN dalam
   ProStudioV39View. */
const RUN_STEPS = [
  ['prostudio.wizard.run1', 'Menyemak sambungan extension...'],
  ['prostudio.wizard.run2', 'Menghantar produk & menunggu jawapan agent...'],
  ['prostudio.wizard.run3', 'AI SESAAT memadankan output...'],
];

// Had masa satu larian Configure (buka tab GPT → hantar → tunggu jawapan).
// Asas 3 minit + 90 saat bagi setiap balasan berturutan (setiap balasan =
// satu pusingan hantar + tunggu tambahan di dalam extension).
// (diselaraskan dengan sendChatGPTTaskToExtension di WorkspaceView — 2026-08-05:
//  90s/balasan terlalu ketat, agent boleh berfikir lama sebelum menulis)
const TASK_TIMEOUT_BASE_MS = 240000;
const TASK_TIMEOUT_PER_REPLY_MS = 300000;

// ── Jambatan ke extension (postMessage) ──
// Salinan minimum daripada corak WorkspaceView. SENGAJA tidak mengimport
// daripada WorkspaceView supaya page ini tidak bergantung pada komponen
// besar itu (dan tidak berisiko mengubah kod hidup).
const pingExtension = () => new Promise((resolve) => {
  let done = false;
  const finish = (v) => { if (!done) { done = true; window.removeEventListener('message', onMsg); resolve(v); } };
  const onMsg = (e) => { if (e.data?.type === 'SESAAT_PONG') finish(true); };
  window.addEventListener('message', onMsg);
  window.postMessage({ type: 'SESAAT_PING' }, '*');
  setTimeout(() => finish(false), 2500);
});

const sendAgentTask = (payload) => new Promise((resolve) => {
  const replyCount = Array.isArray(payload.replies) ? payload.replies.length : 0;
  /* Setiap pusingan bergambar menunggu gambar siap dijana (ChatGPT ≈ 60s, jaring
     extension 5 min) — jaring di sini ikut sama, kalau tidak larian yang elok
     dibatalkan di tengah jalan. */
  const imgCount = Array.isArray(payload.imageTurns) ? payload.imageTurns.length : 0;
  /* Gambar produk TAMBAHAN (2026-09-13) — dimuat turun + dilampirkan + ditunggu siap
     di extension; jaring terburuk ~1.5 minit setiap gambar. */
  const extraCount = Array.isArray(payload.extraImageUrls) ? payload.extraImageUrls.length : 0;
  /* hadMasaPusinganGambar = 5 min + ruang 3 cuba semula (2026-09-13 — extension kini
     menghantar semula bila agent menjawab tanpa gambar). */
  const timeoutMs = TASK_TIMEOUT_BASE_MS + (replyCount * TASK_TIMEOUT_PER_REPLY_MS) + hadMasaPusinganGambar(imgCount) + (extraCount * 90000);
  const requestId = `cfg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const onMsg = (e) => {
    if (e.data?.type === 'SESAAT_DIRECT_CHATGPT_TASK_RESULT' && e.data.requestId === requestId) {
      window.removeEventListener('message', onMsg);
      resolve(e.data.response || { success: false, error: 'Tiada jawapan daripada extension.' });
    }
  };
  window.addEventListener('message', onMsg);
  setTimeout(() => {
    window.removeEventListener('message', onMsg);
    resolve({ success: false, error: `Tamat masa menunggu jawapan agent (${Math.round(timeoutMs / 60000)} minit).` });
  }, timeoutMs);
  window.postMessage({ type: 'SESAAT_DIRECT_CHATGPT_TASK', requestId, ...payload }, '*');
});

/* ★ Baca senarai model akaun Gemini TANPA menjalankan agent (2026-08-20).
   Extension buka Gem, salin senarai model, tutup tab. Tiada produk dihantar,
   tiada kuota terpakai — jadi ia selamat ditekan bila-bila masa.
   Tempoh tunggu 90 saat: ia hanya perlu membuka halaman dan satu menu. */
const MODEL_LIST_TIMEOUT_MS = 90000;
const mintaSenaraiModel = (gemUrl) => new Promise((resolve) => {
  const requestId = `mdl_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const onMsg = (e) => {
    if (e.data?.type === 'SESAAT_GEMINI_MODEL_LIST_RESULT' && e.data.requestId === requestId) {
      window.removeEventListener('message', onMsg);
      resolve(e.data.response || { success: false, error: 'Tiada jawapan daripada extension.' });
    }
  };
  window.addEventListener('message', onMsg);
  setTimeout(() => {
    window.removeEventListener('message', onMsg);
    resolve({ success: false, error: 'Tamat masa menunggu senarai model.' });
  }, MODEL_LIST_TIMEOUT_MS);
  window.postMessage({ type: 'SESAAT_GEMINI_MODEL_LIST', requestId, gemUrl }, '*');
});

/* Pautan perbualan agent datang dari halaman luar (extension) → terima https
   chatgpt.com / gemini.google.com sahaja; lain = kosong (tiada pautan dipapar). */
function pautanPerbualanSah(u) {
  const s = String(u || '').trim();
  if (!s || s.length > 300) return '';
  try {
    const url = new URL(s);
    return url.protocol === 'https:' && /^(chatgpt\.com|gemini\.google\.com)$/.test(url.hostname) ? url.href : '';
  } catch { return ''; }
}

/* ★ Kerja ringan ChatGPT (2026-09-26) — cth 'bacaPilihan': extension buka GPT, skrip
   REMOTE baca pilihan Thinking + pakej akaun, tutup tab. Tiada prompt → tiada kuota. */
const mintaKerjaChatGPT = (gptUrl, kerja) => new Promise((resolve) => {
  const requestId = `cgk_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const onMsg = (e) => {
    if (e.data?.type === 'SESAAT_CHATGPT_KERJA_RESULT' && e.data.requestId === requestId) {
      window.removeEventListener('message', onMsg);
      resolve(e.data.response || { success: false, error: 'Tiada jawapan daripada extension.' });
    }
  };
  window.addEventListener('message', onMsg);
  setTimeout(() => {
    window.removeEventListener('message', onMsg);
    resolve({ success: false, error: 'Tamat masa menunggu ChatGPT.' });
  }, MODEL_LIST_TIMEOUT_MS);
  window.postMessage({ type: 'SESAAT_CHATGPT_KERJA', requestId, gptUrl, kerja }, '*');
});

const mkField = (label, role, source = null) => ({
  id: `f_${Math.random().toString(36).slice(2, 8)}`,
  label, role, source,
});

/* ── Composer template (Fasa 1) — token @slug rujuk blok output Gem ──
   deriveTemplate: nilai yang composer papar. `typeof template === 'string'`
   (walau '') = user sudah menyusun sendiri → guna terus. Tiada template
   (null/undefined) → warisi blok yang dipadan AI (@slug daripada source), jadi
   agent lama nampak seperti biasa. fieldIsMapped: field ada sekurang-kurangnya
   satu token yang padan dengan blok yang dikesan (untuk lencana ok/amaran).
   ⛔ slugifySource dikongsi dengan enjin resipi — satu formula, jangan pisah. */
/* ⚠️ `kod` = peta teks-blok → kod @ daripada petaSlug(). Ia WAJIB dihantar bila
   senarai blok ada di tangan: dua blok yang serupa ("HOOK:" lawan "Hook:")
   berkongsi slug asas, dan petaSlug yang menomborkan salah satunya. Tanpa peta,
   medan boleh terpampang kod yang menuding kepada blok yang SALAH. */
const deriveTemplate = (f, kod) =>
  (f && typeof f.template === 'string')
    ? f.template
    : (f && f.source ? '@' + ((kod && kod[f.source]) || slugifySource(f.source)) : '');
const fieldIsMapped = (f, sources) => {
  const { kodBagiSumber, sumberBagiKod } = petaSlug(sources || []);
  const toks = [...deriveTemplate(f, kodBagiSumber).matchAll(/@([a-zA-Z0-9_]+)/g)].map(m => m[1].toLowerCase());
  if (!toks.length) return false;
  return toks.some(t => sumberBagiKod[t] !== undefined);
};

/* Label PAPARAN untuk medan TETAP — diterjemah ikut bahasa UI. ⛔ Bukan `label`
   TERSIMPAN: itu kekal Melayu kerana matcher AI + targetKey bergantung pada
   'caption'/'hook'/'script' di dalamnya. Di sini kita cuma tukar apa yang MATA
   nampak. T pilihan → tanpa T bagi ayat lalai (rupa lama). */
const fieldLabel = (f, T) => {
  const S = T || ((_k, lalai) => lalai);
  if (f?.role === 'image') return S('prostudio.wizard.fieldImage', 'Prompt Gambar');
  if (f?.role === 'video') return S('prostudio.wizard.fieldVideo', 'Prompt Video');
  const l = String(f?.label || '').toLowerCase();
  if (l.includes('caption')) return S('prostudio.wizard.fieldCaption', 'Caption TikTok');
  if (l.includes('hook')) return S('prostudio.wizard.fieldHook', 'Hook Text');
  if (l.includes('script') || l.includes('skrip')) return S('prostudio.wizard.fieldScript', 'Video Script');
  return f?.label || '';
};

/* ══════════════════════════════════════════════════════════════════
   TURUTAN + WARNA MEDAN — untuk rupa v3.9 Langkah 4 sahaja
   ══════════════════════════════════════════════════════════════════
   Lima medan dipapar sebagai SATU senarai mengikut turutan kad produk
   Workspace: Hook Text · Prompt Gambar · Video Script · Prompt Video ·
   Caption TikTok. Turutan itu bukan abjad dan bukan "enjin dahulu" —
   ia turutan kerja sebenar, jadi senarai ini dibaca sama seperti kad
   dibaca (arahan user 2026-08-19: "satu kan saja dlm 1 section").

   ⚠️ `warna` DISALIN daripada kad produk sebenar (WorkspaceView: hook
   amber-500, image blue-500, script emerald-500, video purple-500,
   caption rose-500). Ia nilai TETAP, bukan token: kad sebenar memakai
   kelas Tailwind yang sama pada tema terang DAN gelap, jadi pratonton
   yang memakai token akan berhenti kelihatan seperti kad yang ia tiru.

   ⛔ Medan yang TIDAK dikenali (agent lama dengan medan teks sendiri)
   TIDAK dibuang — ia jatuh ke hujung senarai dengan warna neutral.
   Membuangnya bermakna pelanggan hilang padanan yang dia sudah set. */
const KAD_MEDAN = [
  { kunci: 'hook', warna: '#F59E0B', ikon: 'teks' },
  { kunci: 'image', warna: '#3B82F6', ikon: 'gambar' },
  { kunci: 'script', warna: '#10B981', ikon: 'teks' },
  { kunci: 'video', warna: '#A855F7', ikon: 'video' },
  { kunci: 'caption', warna: '#F43F5E', ikon: 'teks' },
];
/* Padanan ikut perkataan dalam label TERSIMPAN — sengaja sama seperti
   `fieldLabel` dan `ensureCanonicalFields`, kerana label itulah satu-satunya
   penanda yang membezakan tiga medan ber-role 'text'. */
const kadKunci = (f) => {
  if (f?.role === 'image') return 'image';
  if (f?.role === 'video') return 'video';
  const l = String(f?.label || '').toLowerCase();
  if (l.includes('hook')) return 'hook';
  if (l.includes('script') || l.includes('skrip')) return 'script';
  if (l.includes('caption')) return 'caption';
  return '';
};
const kadMeta = (f) => KAD_MEDAN.find(m => m.kunci === kadKunci(f)) || null;

// role: 'image' | 'video' = ENJIN (Flow guna) · 'text' = dibawa ke kad sahaja.
// 5 medan TETAP, padan dgn 5 kotak kad workspace: Hook Text, Prompt Gambar,
// Video Script, Prompt Video, Caption. Hook = per SET; Video Script = per babak.
const defaultSceneFields = () => [
  mkField('Prompt Gambar', 'image'),
  mkField('Prompt Video', 'video'),
  mkField('Video Script', 'text'),
];
const defaultSetFields = () => [
  mkField('Hook Text', 'text'),
  mkField('Caption TikTok', 'text'),
];

/* Pastikan agent LAMA (dibuat sebelum 5-medan) turut dapat Video Script + Hook
   Text — kalau tidak kotak itu kekal kosong di kad. Tambah yang hilang sahaja;
   `template`/`source` sedia ada tak diusik. Padanan ikut perkataan dalam label. */
const ensureCanonicalFields = (sceneFields, setFields) => {
  const hasWord = (arr, w) => arr.some(f => f.role === 'text' && String(f.label || '').toLowerCase().includes(w));
  const scene = hasWord(sceneFields, 'script') || hasWord(sceneFields, 'skrip')
    ? sceneFields : [...sceneFields, mkField('Video Script', 'text')];
  const set = hasWord(setFields, 'hook')
    ? setFields : [mkField('Hook Text', 'text'), ...setFields];
  return { scene, set };
};

const AGENT_V = 2;              // penanda agent format baru (bezakan dari template Smart Custom lama)
const AGENT_COL = 'chatgptTemplates';

const makeDefaultAgent = (name) => ({
  name, url: '', platform: 'chatgpt',
  // Model Gemini: '' = ikut tetapan Gemini (SESAAT tidak sentuh menu model).
  // geminiModels = senarai yang DIBACA daripada akaun pelanggan semasa Configure —
  // bukan senarai tetap dalam kod, kerana akaun Ultra dan percuma berbeza.
  geminiModel: '', geminiModels: [],
  /* ChatGPT: cip "Extended" pada kotak karang. TIGA keadaan, bukan boolean —
     '' bermakna pelanggan BELUM memilih, dan larian disekat sehingga dia memilih
     (arahan user 2026-08-20: "wajib pilih"). Boolean lalai-mati akan membuat
     pilihan itu secara senyap bagi pihaknya, iaitu perangkap yang sama seperti
     "ikut tetapan Gemini".
       ''      belum dipilih
       'kekal' biar seperti yang ChatGPT tetapkan
       'mati'  buang cip sebelum menaip
     ⛔ ChatGPT TIADA pemilih model (disahkan pada halaman sebenar) — cip ini
     satu-satunya kawalan larian di sana. */
  chatgptExtended: '',
  /* ★ ChatGPT tahap Thinking (2026-09-26, keputusan user: "Lakaran A", tanpa huraian).
     ChatGPT rupa baharu tiada cip — tahap = gelangsar akaun (Plus: Instant/Medium/High;
     Go: Instant/Think). Pilihan DIBACA dari akaun pelanggan (butang "Baca pilihan
     Thinking", corak senarai model Gemini) → `chatgptTahapPilihan`; pilihan agent →
     `chatgptTahap` (label ChatGPT). `chatgptAkaun` = pakej akaun ChatGPT yang dibaca.
     `chatgptExtended` lama kekal untuk agent yang belum dikonfigurasi semula. */
  chatgptTahap: '',
  chatgptTahapPilihan: [],
  chatgptAkaun: '',
  /* (2026-09-27) true = akaun ChatGPT memang TIADA kawalan Thinking (cth pakej Go pada
     halaman GPT) → Configure dibenarkan tanpa memilih tahap; robot tidak sentuh apa-apa. */
  chatgptTahapTiada: false,
  /* Gemini: TAHAP Thinking — BEBAS daripada model. '' belum pilih (larian disekat) ·
     'low' · 'medium' · 'high'. ★ 2026-10-11: Gemini 3 menggantikan suis "Extended
     thinking" (hidup/mati) dengan tiga tahap ini. ⛔ Nama medan KEKAL `geminiExtended`
     (tersimpan pada agent pelanggan + 4 tempat payload); nilai lama 'on'/'off' dibaca
     sebagai high/low oleh `normTahapGemini` (utils/geminiPemilih.js). */
  geminiExtended: '',
  // Perbualan: ayat arahan tambahan (ditampal di hujung mesej pertama) +
  // balasan berturutan untuk agent yang bertanya soalan dahulu.
  extraInstruction: '',
  replies: [],
  /* ★ Gambar daripada jawapan (2026-09-11): pusingan mana yang gambarnya
     disimpan ke kad. `replyImages` sejajar dengan `replies` (satu bendera
     setiap balasan); `firstImage` = jawapan pertama. Lihat utils/agentGambar.js. */
  firstImage: false,
  replyImages: [],
  // Pusingan perbualan mana menjadi output (0 = jawapan pertama,
  // 1 = selepas Balasan 1, dan seterusnya).
  outputTurn: 0,
  setCount: 1, sceneCount: 1,
  output: 'imagevideo',      // 'image' | 'imagevideo'
  productPhoto: 'all',       // 'none' | 'all' | nombor babak
  avatar: 'none',            // 'none' | 'all' | nombor babak
  sceneFields: defaultSceneFields(),
  setFields: defaultSetFields(),
  // sources = tajuk yang dikesan dalam jawapan agent semasa Configure.
  // Disimpan supaya dropdown pembetulan masih berfungsi selepas reload.
  sources: [],
  /* Blok yang pelanggan BUAT SENDIRI daripada jawapan agent. Disimpan
     BERASINGAN daripada sources kerana setiap larian Configure mengganti
     sources sepenuhnya — lihat nota pada semuaSumber() dalam agentRecipe. */
  customSources: [],
  configured: false, configuredAt: null, configuredAtTs: null, setsDetected: 0, scenesDetected: 0,
  /* ★ (2026-09-27) Masa larian Configure TERAKHIR + pautan perbualan agent — supaya bar
     status menunjukkan jawapan BAHARU (bukan tarikh Configure pertama) dan pelanggan
     boleh membuka perbualan asal untuk membandingkan. Simpan → configuredAtTs = runAtTs. */
  runAtTs: null, chatUrl: '',
  /* Jawapan mentah larian Configure TERAKHIR (turn terpilih SAHAJA) — disimpan
     supaya kad pratonton + edit blok terus hidup bila agent dibuka semula, tanpa
     perlu scrape semula (aduan user 2026-08-20). Turun terpilih sahaja, bukan
     semua pusingan, untuk kekalkan doc agent kecil — ia dibaca pada 3 senarai. */
  lastRaw: '',
});

/* ⭐ Sisip elemen React (biasanya <b>) ke dalam ayat kamus pada penanda
   {b}, {b1}, {b2}.

   Kenapa begini dan bukan memecah ayat jadi tiga serpihan dalam JSX:
   serpihan mengunci SUSUNAN PERKATAAN kepada tatabahasa Melayu. Ayat
   English yang meletakkan perkataan tebal di tempat lain akan keluar
   terbalik, dan penterjemah tidak dapat mengalihkannya. Dengan penanda,
   kamus memegang ayat PENUH dan bebas meletakkan {b} di mana-mana. */
function sisip(ayat, ...nodes) {
  return String(ayat || '').split(/(\{b\d?\})/g).map((bhg, i) => {
    const m = bhg.match(/^\{b(\d?)\}$/);
    if (!m) return bhg;
    return <Fragment key={i}>{nodes[m[1] ? Number(m[1]) - 1 : 0]}</Fragment>;
  });
}

const clampInt = (v, lo, hi, dflt) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.max(lo, Math.min(hi, Math.round(n))) : dflt;
};

// Pilihan babak: 'none' | 'all' | nombor (dikepit pada bilangan babak semasa)
const normScenePick = (v, sceneCount) => {
  if (v === 'none' || v === 'all') return v;
  const n = Number(v);
  if (!Number.isFinite(n)) return 'none';
  return Math.max(1, Math.min(sceneCount, Math.round(n)));
};

const normFields = (arr, fallback) => {
  if (!Array.isArray(arr) || arr.length === 0) return fallback();
  return arr
    .filter(f => f && typeof f === 'object')
    .map(f => ({
      id: String(f.id || `f_${Math.random().toString(36).slice(2, 8)}`),
      label: String(f.label || 'Field'),
      role: f.role === 'image' || f.role === 'video' ? f.role : 'text',
      source: f.source ? String(f.source) : null,
      // template composer (Fasa 1). null = belum disusun → warisi source (cara lama).
      template: typeof f.template === 'string' ? f.template.slice(0, 4000) : null,
      /* Susunan KHAS setiap babak (index 0 = babak 1). null pada satu babak =
         warisi babak 1. Ditambah 2026-08-26 supaya babak 2 boleh menuding ke
         TAJUK JAWAPAN yang berlainan daripada babak 1 — tanpa ini setiap set
         menerima video babak 1 dua kali. Agent lama tiada medan ini langsung,
         jadi ia kekal null dan berkelakuan sama seperti sebelum ini. */
      scenes: Array.isArray(f.scenes)
        ? f.scenes.slice(0, MAX_SCENES).map(v => (typeof v === 'string' ? v.slice(0, 4000) : null))
        : null,
    }));
};

// Firestore doc → bentuk yang UI guna (dengan nilai lalai untuk medan yang hilang)
const fromDoc = (id, d) => {
  const sceneCount = clampInt(d.sceneCount, 1, MAX_SCENES, 1);
  const canon = ensureCanonicalFields(
    normFields(d.sceneFields, defaultSceneFields),
    normFields(d.setFields, defaultSetFields),
  );
  return {
    id,
    /* Bacaan SAHAJA. Susunan ditulis hanya oleh laluan susun (lihat
       utils/susunAgent.js) — sebab itu ia tiada dalam toDoc. */
    order: Number.isFinite(Number(d.order)) ? Number(d.order) : null,
    name: String(d.name || 'Agent tanpa nama'),
    url: String(d.gptUrl || ''),
    platform: d.platform === 'gemini' ? 'gemini' : 'chatgpt',
    geminiModel: String(d.geminiModel || ''),
    geminiExtended: normTahapGemini(d.geminiExtended),   // 'on'/'off' lama → high/low
    /* Terima medan boolean LAMA (dipakai beberapa jam pada 2026-08-20 sebelum
       ia bertukar kepada tiga keadaan) supaya agent yang sempat disimpan tidak
       kehilangan pilihannya. */
    chatgptExtended: (d.chatgptExtended === 'mati' || d.chatgptExtended === 'kekal')
      ? d.chatgptExtended
      : (d.chatgptExtendedOff ? 'mati' : ''),
    chatgptTahap: String(d.chatgptTahap || '').slice(0, 40),
    chatgptTahapPilihan: Array.isArray(d.chatgptTahapPilihan) ? d.chatgptTahapPilihan.map(String).filter(Boolean).slice(0, 8) : [],
    chatgptAkaun: String(d.chatgptAkaun || '').slice(0, 20),
    chatgptTahapTiada: d.chatgptTahapTiada === true,
    geminiModels: Array.isArray(d.geminiModels) ? d.geminiModels.map(String).slice(0, 12) : [],
    extraInstruction: String(d.extraInstruction || ''),
    outputTurn: clampInt(d.outputTurn, 0, MAX_REPLIES, 0),
    replies: Array.isArray(d.replies)
      ? d.replies.map(r => String(r || '')).slice(0, MAX_REPLIES)
      : [],
    /* firstImage + replyImages — sejajar dengan `replies` yang dinormalisasi di atas. */
    ...normGambarAgent(d, Array.isArray(d.replies) ? d.replies.slice(0, MAX_REPLIES) : []),
    setCount: clampInt(d.setCount, 1, MAX_SETS, 1),
    sceneCount,
    output: d.output === 'image' ? 'image' : 'imagevideo',
    productPhoto: normScenePick(d.productPhoto ?? 'all', sceneCount),
    avatar: normScenePick(d.avatar ?? 'none', sceneCount),
    sceneFields: canon.scene,
    setFields: canon.set,
    sources: Array.isArray(d.sources) ? d.sources.map(String).filter(Boolean).slice(0, 40) : [],
    customSources: Array.isArray(d.customSources) ? d.customSources.map(String).filter(Boolean).slice(0, 20) : [],
    configured: !!d.configured,
    configuredAt: d.configuredAt || null,
    configuredAtTs: Number(d.configuredAtTs) || null,
    runAtTs: Number(d.configuredAtTs) || null,
    chatUrl: pautanPerbualanSah(d.lastChatUrl),
    setsDetected: clampInt(d.setsDetected, 0, MAX_SETS, 0),
    scenesDetected: clampInt(d.scenesDetected, 0, MAX_SCENES, 0),
    lastRaw: String(d.lastRaw || ''),
  };
};

// Bentuk UI → payload Firestore. `gptUrl` + `name` dikekalkan supaya
// kod sedia ada yang membaca collection ini tidak tersalah baca.
const toDoc = (a) => ({
  agentV: AGENT_V,
  platform: a.platform === 'gemini' ? 'gemini' : 'chatgpt',
  geminiModel: String(a.geminiModel || ''),
  geminiExtended: normTahapGemini(a.geminiExtended),   // hanya 'low'|'medium'|'high'|'' ditulis
  chatgptExtended: (a.chatgptExtended === 'mati' || a.chatgptExtended === 'kekal') ? a.chatgptExtended : '',
  chatgptTahap: String(a.chatgptTahap || '').trim().slice(0, 40),
  chatgptTahapPilihan: Array.isArray(a.chatgptTahapPilihan) ? a.chatgptTahapPilihan.map(String).filter(Boolean).slice(0, 8) : [],
  chatgptAkaun: String(a.chatgptAkaun || '').trim().slice(0, 20),
  chatgptTahapTiada: a.chatgptTahapTiada === true,
  geminiModels: Array.isArray(a.geminiModels) ? a.geminiModels.map(String).slice(0, 12) : [],
  name: a.name.trim() || 'Agent tanpa nama',
  gptUrl: a.url.trim(),
  extraInstruction: (a.extraInstruction || '').trim(),
  outputTurn: a.outputTurn || 0,
  /* ★ `replyImages` WAJIB ditapis BERSAMA `replies` — balasan kosong dibuang di
     sini, jadi bendera gambarnya mesti gugur sekali; kalau tidak ia melekat pada
     balasan yang salah dan gambar diambil daripada pusingan yang tidak dimaksudkan. */
  ...(() => {
    const pasangan = (Array.isArray(a.replies) ? a.replies : [])
      .map((r, i) => ({ r: String(r || '').trim(), g: !!(Array.isArray(a.replyImages) ? a.replyImages[i] : false) }))
      .filter(x => x.r)
      .slice(0, MAX_REPLIES);
    return {
      replies: pasangan.map(x => x.r),
      replyImages: pasangan.map(x => x.g),
      firstImage: !!a.firstImage,
    };
  })(),
  setCount: a.setCount,
  sceneCount: a.sceneCount,
  output: a.output,
  productPhoto: a.productPhoto,
  avatar: a.avatar,
  sceneFields: a.sceneFields,
  setFields: a.setFields,
  sources: Array.isArray(a.sources) ? a.sources.slice(0, 40) : [],
  customSources: Array.isArray(a.customSources) ? a.customSources.slice(0, 20) : [],
  configured: !!a.configured,
  configuredAt: a.configuredAt || null,
  configuredAtTs: a.configuredAtTs || null,
  lastChatUrl: pautanPerbualanSah(a.chatUrl),
  setsDetected: a.setsDetected || 0,
  scenesDetected: a.scenesDetected || 0,
  /* Had 24KB: jawapan sebenar diperhati ~9KB, jadi ini melindungi doc daripada
     membengkak tanpa memotong jawapan biasa. Kalau terpotong, pratonton jadi
     separa — pelanggan boleh Configure semula. */
  lastRaw: String(a.lastRaw || '').slice(0, 24000),
  updatedAt: serverTimestamp(),
});

/* `label` = ayat lalai (rupa lama) · `labelKey` = kunci kamus (rupa v3.9).
   Lihat nota [kunci, ayatLalai] di atas. */
const ROLE_META = {
  image: { label: 'ENJIN · GAMBAR', labelKey: 'prostudio.wizard.tagImage', color: 'var(--ps-accent-deep)', bg: 'var(--ps-accent-soft-3)', border: 'var(--ps-accent-line)', icon: 'image' },
  video: { label: 'ENJIN · VIDEO', labelKey: 'prostudio.wizard.tagVideo', color: 'var(--ps-accent-deep)', bg: 'var(--ps-accent-soft-3)', border: 'var(--ps-accent-line)', icon: 'movie' },
  text: { label: 'TEKS', labelKey: 'prostudio.agentsec.fieldText', color: 'var(--ps-ink-2)', bg: 'var(--ps-fill)', border: 'var(--ps-line)', icon: 'notes' },
};

/* ══════════════════════════════════════════════════════════════════
   PALET — satu lapisan penyesuai antara seksyen ini dan dua rupa app
   ══════════════════════════════════════════════════════════════════
   Seluruh fail ini menulis warnanya sebagai `var(--ps-*)`. Nilai
   sebenar dipasang pada div paling luar seksyen, dipilih oleh prop
   `v39`:

     v39 = false  →  PALET_LAMA — warna ASAL fail ini, huruf demi huruf.
                     Halaman /prostudio dengan suis v3.9 mati tidak
                     berubah walau satu piksel.
     v39 = true   →  PALET_V39  — setiap nilai dipetakan kepada token
                     --s-*, jadi seksyen ini mengikut tema gelap/terang
                     bersama-sama halaman v3.9 yang membungkusnya.

   ⚠️ Menambah warna baharu dalam fail ini bermakna menambah satu
      pemboleh ubah di KEDUA-DUA jadual. Warna keras yang tertinggal
      akan kekal warna terang di tengah halaman gelap — punca yang
      sama seperti token tertinggal dalam tokens.css.

   ⛔ JANGAN tukar PALET_LAMA. Ia bukan pilihan reka bentuk, ia rekod
      rupa asal — satu-satunya sebab kita boleh yakin halaman lama
      tidak tersentuh oleh kerja ini.

   Nota pemetaan v3.9 yang bukan 1-ke-1, dan sebabnya:
     · accent (indigo) → --s-select. Tema v3.9 tidak memakai warna
       jenama pada kawalan; keadaan "dipilih" ialah putih/hitam.
     · gpt (hijau ChatGPT) → --s-select juga. Butang platform yang
       aktif ialah kawalan, bukan logo.
     · grad (gradient ungu) → satu warna rata. v3.9 tiada gradien.
     · fill-2 (trek suis mati + butang lumpuh) → --s-line-strong,
       bukan --s-fill: --s-fill terlalu senyap untuk menahan bulatan
       suis, dan suis itu jadi tidak kelihatan pada keadaan mati.
   ══════════════════════════════════════════════════════════════════ */
const PALET_LAMA = {
    '--ps-card': '#ffffff', '--ps-fill': '#f8fafc', '--ps-fill-2': '#e2e8f0',
    '--ps-fill-3': '#fcfdfe', '--ps-fill-4': '#fbfbff',
    '--ps-line': '#e2e8f0', '--ps-line-2': '#e8edf4', '--ps-line-soft': '#f1f5f9', '--ps-line-strong': '#cbd5e1',
    '--ps-ink': '#1e293b', '--ps-ink-deep': '#0f172a', '--ps-ink-strong': '#334155', '--ps-ink-2': '#64748b',
    '--ps-ink-3': '#94a3b8', '--ps-ink-4': '#cbd5e1', '--ps-ink-5': '#e2e8f0',
    '--ps-accent': '#6366f1', '--ps-accent-2': '#8b5cf6', '--ps-accent-deep': '#4338ca',
    '--ps-accent-ink': '#6366f1', '--ps-accent-soft': '#f5f3ff', '--ps-accent-soft-2': '#e0e7ff',
    '--ps-accent-soft-3': '#eef2ff', '--ps-accent-line': '#c7d2fe', '--ps-on-accent': '#ffffff',
    '--ps-warn': '#f59e0b', '--ps-warn-ink': '#b45309', '--ps-warn-ink-2': '#92600a',
    '--ps-warn-soft': '#fffbeb', '--ps-warn-soft-2': '#fffdf5',
    '--ps-warn-line': '#fde68a', '--ps-warn-line-2': '#f2d38b',
    '--ps-ok': '#10b981', '--ps-ok-deep': '#047857', '--ps-ok-soft': '#ecfdf5', '--ps-ok-line': '#a7f3d0',
    '--ps-gpt': '#10a37f', '--ps-gpt-ink': '#10a37f',
    '--ps-stop': '#ef4444', '--ps-stop-ink': '#b91c1c', '--ps-stop-soft': '#fef2f2',
    '--ps-stop-line': '#fecaca', '--ps-stop-line-2': '#fee2e2',
    '--ps-grad': 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    '--ps-knob': '#ffffff',
};

const PALET_V39 = {
    '--ps-card': 'var(--s-card)', '--ps-fill': 'var(--s-fill)', '--ps-fill-2': 'var(--s-line-strong)',
    '--ps-fill-3': 'var(--s-fill)', '--ps-fill-4': 'var(--s-fill)',
    '--ps-line': 'var(--s-line)', '--ps-line-2': 'var(--s-line)', '--ps-line-soft': 'var(--s-line)',
    '--ps-line-strong': 'var(--s-line-strong)',
    '--ps-ink': 'var(--s-ink)', '--ps-ink-deep': 'var(--s-ink)', '--ps-ink-strong': 'var(--s-ink)', '--ps-ink-2': 'var(--s-ink-2)',
    '--ps-ink-3': 'var(--s-ink-3)', '--ps-ink-4': 'var(--s-ink-3)', '--ps-ink-5': 'var(--s-ink-3)',
    '--ps-accent': 'var(--s-select)', '--ps-accent-2': 'var(--s-select)', '--ps-accent-deep': 'var(--s-ink)',
    '--ps-accent-ink': 'var(--s-ink)', '--ps-accent-soft': 'var(--s-fill)', '--ps-accent-soft-2': 'var(--s-fill)',
    '--ps-accent-soft-3': 'var(--s-fill)', '--ps-accent-line': 'var(--s-line-strong)',
    '--ps-on-accent': 'var(--s-select-ink)',
    '--ps-warn': 'var(--s-warn)', '--ps-warn-ink': 'var(--s-warn)', '--ps-warn-ink-2': 'var(--s-warn)',
    '--ps-warn-soft': 'var(--s-warn-soft)', '--ps-warn-soft-2': 'var(--s-warn-soft)',
    '--ps-warn-line': 'var(--s-warn-soft)', '--ps-warn-line-2': 'var(--s-warn-soft)',
    '--ps-ok': 'var(--s-ok)', '--ps-ok-deep': 'var(--s-ok)', '--ps-ok-soft': 'var(--s-ok-soft)',
    '--ps-ok-line': 'var(--s-ok-soft)',
    '--ps-gpt': 'var(--s-select)', '--ps-gpt-ink': 'var(--s-ink)',
    '--ps-stop': 'var(--s-stop)', '--ps-stop-ink': 'var(--s-stop)', '--ps-stop-soft': 'var(--s-stop-soft)',
    '--ps-stop-line': 'var(--s-stop-soft)', '--ps-stop-line-2': 'var(--s-stop-soft)',
    '--ps-grad': 'var(--s-select)',
    '--ps-knob': 'var(--s-panel)',
};

/* ── gaya kongsi — FUNGSI bagi `v39`, bukan objek tetap ───────────────
   Rupa v3.9 bukan sekadar warna lain, ia BENTUK lain. Palet --ps-* di
   bawah sudah menguruskan warna untuk kedua-dua rupa, jadi yang tinggal
   di sini hanyalah SAIZ dan BENTUK:

     rupa lama  — label HURUF BESAR 10px, kotak isian padat 11.5px
     rupa v3.9  — label ayat biasa 12.5px, kotak isian tinggi 36px / 14px

   ⛔ Nilai v3.9 disalin daripada prostudioUI.jsx (blok binaan prototaip).
      Kalau prototaip berubah, salin semula ke sini — kalau tidak halaman
      HIDUP dan LAKARAN mula terpesong tanpa sesiapa perasan.
   ⚠️ Saiz teks terkecil v3.9 = 11px (peraturan halaman v3.9). Rupa lama
      turun sampai 7.5px; jangan bawa nilai itu masuk ke cabang v39. */
const card = (v39) => (v39
  ? { background: 'var(--ps-card)', border: '1px solid var(--ps-line)', borderRadius: 12, padding: 16 }
  : { background: 'var(--ps-card)', border: '1px solid var(--ps-line-2)', borderRadius: 12, padding: 14 });

const lbl = (v39) => (v39
  ? { fontSize: 12.5, color: 'var(--ps-ink-3)', display: 'block', marginBottom: 6 }
  : { fontSize: v39 ? 12.5 : 10, fontWeight: 800, color: 'var(--ps-ink-2)', letterSpacing: '0.05em', textTransform: 'uppercase', display: 'block', marginBottom: 6 });

const inp = (v39) => (v39
  ? { width: '100%', height: 36, borderRadius: 8, boxSizing: 'border-box', border: '1px solid var(--ps-line-strong)', background: 'transparent', color: 'var(--ps-ink)', padding: '0 11px', fontSize: 14, fontFamily: 'inherit', outline: 'none' }
  : { width: '100%', padding: '8px 10px', fontSize: v39 ? 13 : 11.5, fontWeight: 600, background: 'var(--ps-card)', border: '1px solid var(--ps-line)', borderRadius: 8, color: 'var(--ps-ink)', outline: 'none', boxSizing: 'border-box' });

/* Kotak teks panjang. ⛔ JANGAN sebar `inp(v39)` untuk textarea — cabang
   v39 membawa `height: 36`, yang memampatkan kotak tiga baris jadi satu. */
const ta = (v39) => (v39
  ? { width: '100%', minHeight: 60, resize: 'vertical', boxSizing: 'border-box', border: '1px solid var(--ps-line-strong)', borderRadius: 8, background: 'transparent', color: 'var(--ps-ink)', padding: '9px 11px', fontSize: 13.5, lineHeight: 1.55, fontFamily: 'inherit', outline: 'none' }
  : { ...inp(false), resize: 'vertical', lineHeight: 1.6, fontWeight: 500 });

const sel = (v39) => (v39
  ? { width: '100%', height: 36, borderRadius: 8, boxSizing: 'border-box', border: '1px solid var(--ps-line-strong)', background: 'var(--ps-fill)', color: 'var(--ps-ink)', padding: '0 10px', fontSize: 13.5, fontFamily: 'inherit', outline: 'none', cursor: 'pointer' }
  : { ...inp(false), cursor: 'pointer' });

const hint = (v39) => (v39
  ? { fontSize: 12.5, color: 'var(--ps-ink-3)', marginTop: 6, lineHeight: 1.55 }
  : { fontSize: v39 ? 12.5 : 9.5, color: 'var(--ps-ink-3)', fontWeight: 500, marginTop: 4, lineHeight: 1.5 });

/* ══ Pemilih produk ujian ══════════════════════════════════════════════
   Dropdown SENDIRI, bukan `<select>` browser (aduan user 2026-08-21 dengan
   gambar: senarai penuh menutup seluruh skrin). Tiga sebab ia dibina sendiri:
   · `<select>` browser tidak boleh dihadkan tingginya — 34 nama produk yang
     panjang bermakna panel setinggi skrin, menutup pratonton yang sepatutnya
     dilihat serentak.
   · Nama produk TikTok panjang dan banyak yang hampir serupa; gambar kecil
     ialah cara terpantas pelanggan mengenal produknya.
   · Tanpa carian, mencari satu produk antara berpuluh bermakna menatal.
   ⛔ Senarai yang masuk ke sini SUDAH ditapis READY sahaja (lihat effect muat
      produk) — jangan tambah tapisan kedua di dalam komponen ini. */
function PemilihProduk({ v39, T, produk, nilai, onPilih, memuat }) {
  const [buka, setBuka] = useState(false);
  const [cari, setCari] = useState('');
  const bekasRef = useRef(null);

  // Klik di luar / Esc menutup panel — tanpa ini panel tersangkut terbuka dan
  // menutup pratonton, iaitu masalah yang sama seperti dropdown asal.
  useEffect(() => {
    if (!buka) return;
    const luar = (e) => { if (bekasRef.current && !bekasRef.current.contains(e.target)) setBuka(false); };
    const esc = (e) => { if (e.key === 'Escape') setBuka(false); };
    document.addEventListener('mousedown', luar);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', luar); document.removeEventListener('keydown', esc); };
  }, [buka]);

  const dipilih = produk.find(p => p.id === nilai) || null;
  const q = cari.trim().toLowerCase();
  const ditapis = q ? produk.filter(p => p.name.toLowerCase().includes(q)) : produk;

  const gambar = (p, saiz) => (p?.image
    ? <img src={p.image} alt="" style={{ width: saiz, height: saiz, borderRadius: 6, objectFit: 'cover', flex: 'none', background: 'var(--ps-fill)' }} />
    : <span className="material-symbols-outlined" style={{ fontSize: saiz - 4, width: saiz, color: 'var(--ps-ink-4)', flex: 'none' }}>inventory_2</span>);

  const satuBaris = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 };

  if (!memuat && produk.length === 0) {
    return (
      <div style={{ ...hint(v39), marginTop: 0, color: 'var(--ps-warn-ink, var(--ps-ink-2))' }}>
        {T('prostudio.agentsec.produkReadyKosong', 'Tiada produk READY dalam My Products. Lengkapkan data sekurang-kurangnya satu produk di halaman Products sebelum menjalankan Configure.')}
      </div>
    );
  }

  return (
    <div ref={bekasRef} style={{ position: 'relative' }}>
      <button
        type="button"
        disabled={memuat}
        onClick={() => setBuka(v => !v)}
        style={{
          ...sel(v39), display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left',
          height: 'auto', minHeight: 36, padding: '6px 10px', fontFamily: 'inherit',
          cursor: memuat ? 'wait' : 'pointer',
        }}
      >
        {memuat
          ? <span style={{ ...satuBaris, flex: 1, color: 'var(--ps-ink-3)' }}>{T('prostudio.agentsec.productsLoading', 'Memuatkan produk...')}</span>
          : (<>
            {gambar(dipilih, 24)}
            <span style={{ ...satuBaris, flex: 1 }}>{dipilih?.name || T('prostudio.agentsec.produkPilih', 'Pilih produk')}</span>
          </>)}
        <span className="material-symbols-outlined" style={{ fontSize: 18, color: 'var(--ps-ink-3)', flex: 'none' }}>
          {buka ? 'expand_less' : 'expand_more'}
        </span>
      </button>

      {buka && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 30,
          background: 'var(--ps-card)', border: '1px solid var(--ps-line-strong, var(--ps-line))',
          borderRadius: 10, boxShadow: '0 10px 28px rgba(0,0,0,.18)', overflow: 'hidden',
        }}>
          <div style={{ padding: 8, borderBottom: '1px solid var(--ps-line-soft, var(--ps-line))' }}>
            <input
              autoFocus
              value={cari}
              onChange={(e) => setCari(e.target.value)}
              placeholder={T('prostudio.agentsec.produkCari', 'Cari nama produk…')}
              style={{ ...inp(v39), height: 32, fontSize: v39 ? 13 : 12 }}
            />
          </div>
          {/* Tinggi TETAP berskrol — inilah pembetulan utama berbanding
              `<select>` browser yang membuka setinggi senarai. */}
          <div style={{ maxHeight: 240, overflowY: 'auto' }}>
            {ditapis.length === 0 && (
              <div style={{ ...hint(v39), margin: 0, padding: '12px 10px' }}>
                {T('prostudio.agentsec.produkTiadaPadan', 'Tiada produk sepadan.')}
              </div>
            )}
            {ditapis.map(p => {
              const aktif = p.id === nilai;
              return (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => { onPilih(p.id); setBuka(false); setCari(''); }}
                  title={p.name}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left',
                    padding: '7px 10px', border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                    fontSize: v39 ? 12.5 : 11.5, lineHeight: 1.35,
                    background: aktif ? 'var(--ps-accent-soft-2)' : 'transparent',
                    color: aktif ? 'var(--ps-accent-deep)' : 'var(--ps-ink)',
                    fontWeight: aktif ? 700 : 500,
                  }}
                >
                  {gambar(p, 26)}
                  <span style={satuBaris}>{p.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

/* Ayat ringkasan — terjemah semua tetapan Langkah 3 jadi bahasa manusia.
   ⚠️ `T` ialah parameter PILIHAN, mengikut peraturan komponen dikongsi
   dua rupa: tanpa `T` ia memulangkan ayat Melayu asal (rupa lama), dengan
   `T` ia membaca kamus (rupa v3.9). Pemanggil MESTI ingat menghantarnya —
   modal Schedule pernah diterjemah penuh tetapi tidak menerima `t`, jadi
   ~50 kunci jadi kod mati. */
function buildSummary(a, T) {
  const S = T || ((_k, lalai) => lalai);
  const out = [];
  out.push(a.setCount > 1
    ? S('prostudio.agentsec.sumSetMany', `Setiap produk menghasilkan ${a.setCount} set — bermakna ${a.setCount} hasil berasingan.`, { n: a.setCount })
    : S('prostudio.agentsec.sumSetOne', `Setiap produk menghasilkan ${a.setCount} set.`, { n: a.setCount }));
  out.push(a.sceneCount > 1
    ? S('prostudio.agentsec.sumSceneMany', `Setiap set mengandungi ${a.sceneCount} babak.`, { n: a.sceneCount })
    : S('prostudio.agentsec.sumSceneOne', 'Setiap set mengandungi 1 babak sahaja.'));

  const n = a.sceneCount;
  if (a.output === 'image') {
    out.push(S('prostudio.agentsec.sumImageOnly', `SESAAT menjana ${n} gambar sahaja — tiada video.`, { n }));
  } else {
    out.push(S('prostudio.agentsec.sumImageVideo', `SESAAT menjana ${n} gambar, kemudian ${n} video daripada gambar tersebut.`, { n }));
  }

  if (a.productPhoto === 'none') out.push(S('prostudio.agentsec.sumPhotoNone', 'Gambar produk tidak dimasukkan.'));
  else if (a.productPhoto === 'all') out.push(S('prostudio.agentsec.sumPhotoAll', 'Gambar produk dimasukkan pada setiap babak.'));
  else out.push(S('prostudio.agentsec.sumPhotoOne', `Gambar produk dimasukkan pada babak ${a.productPhoto} sahaja.`, { n: a.productPhoto }));

  if (a.avatar === 'none') out.push(S('prostudio.agentsec.sumAvatarNone', 'Avatar tidak digunakan.'));
  else if (a.avatar === 'all') out.push(S('prostudio.agentsec.sumAvatarAll', 'Avatar digunakan pada setiap babak.'));
  else out.push(S('prostudio.agentsec.sumAvatarOne', `Avatar digunakan pada babak ${a.avatar} sahaja.`, { n: a.avatar }));

  /* ★ Gambar daripada jawapan agent (Langkah 2) — disebut di sini supaya ringkasan
     memang menceritakan SEMUA yang larian akan buat. */
  const nGambar = bilanganGambarDitanda(a);
  if (nGambar === 1) out.push(S('prostudio.agentsec.sumImgOne', 'SESAAT juga menyimpan 1 gambar daripada jawapan agent ke dalam kad.'));
  else if (nGambar > 1) out.push(S('prostudio.agentsec.sumImgMany', `SESAAT juga menyimpan ${nGambar} gambar daripada jawapan agent ke dalam kad.`, { n: nGambar }));

  return out.join(' ');
}

/* ── SKRIN BERKUNCI ────────────────────────────────────────────────
   Dipapar kepada pelanggan yang lesennya TIDAK mengandungi module
   SMART. Ia menggantikan seluruh seksyen, bukan sekadar melumpuhkan
   butang: pelanggan yang tidak boleh menggunakannya langsung tidak
   patut menghabiskan lima langkah sebelum tahu.

   Ia memakai palet --ps-* yang sama, jadi ia betul pada rupa lama
   MAHUPUN rupa v3.9 tanpa dua salinan.                              */
function AgentTerkunci({ onNaikTaraf, v39 = false }) {
  /* Skrin ini dirender dalam KEDUA-DUA rupa (lihat nota di atas), jadi
     terjemahan dipagar: rupa lama membaca kamus Melayu terus supaya
     pelanggan hari ini tidak tiba-tiba dibaca skrin jualan English. */
  const tAktif = useT();
  const t = (kunci, vars) => (v39 ? tAktif(kunci, vars) : cari('ms', kunci, vars));
  return (
    <div style={{
      ...card(v39), padding: '28px 24px', textAlign: 'center',
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
    }}>
      <span style={{
        width: 44, height: 44, borderRadius: 999, display: 'grid', placeItems: 'center',
        background: 'var(--ps-fill)', color: 'var(--ps-ink-3)',
      }}>
        <span className="material-symbols-outlined" style={{ fontSize: 22 }}>lock</span>
      </span>

      {/* ⚠️ Teks DITERJEMAH. Ini skrin yang dilihat pelanggan yang belum
          membeli — ia juga saat jualan, jadi ia tidak boleh keluar dalam
          bahasa yang salah. (Sebab-kunci daripada computeFormulaAccess
          sengaja TIDAK dipapar: ayat itu wujud dalam Melayu sahaja, dan ia
          akan terselit dalam halaman English.) */}
      <div style={{ fontSize: 14, fontWeight: 800, color: 'var(--ps-ink)' }}>
        {t('prostudio.agentLock.title')}
      </div>

      <div style={{ fontSize: v39 ? 13 : 11.5, color: 'var(--ps-ink-2)', lineHeight: 1.7, maxWidth: 420 }}>
        {t('prostudio.agentLock.body')}
      </div>

      {onNaikTaraf && (
        <button
          type="button"
          onClick={onNaikTaraf}
          style={{
            marginTop: 4, padding: '9px 18px', borderRadius: 9, border: 'none',
            fontSize: v39 ? 13 : 11.5, fontWeight: 800, cursor: 'pointer',
            background: 'var(--ps-accent)', color: 'var(--ps-on-accent)',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 15 }}>workspace_premium</span>
          {t('prostudio.agentLock.cta')}
        </button>
      )}
    </div>
  );
}

/* `aksesSmart` — pelanggan ini ada module SMART dalam lesennya?
   Dikira di App.jsx dengan `computeFormulaAccess`, iaitu penjaga yang
   SAMA seperti Rak Formula. ⛔ Jangan kira semula di sini: dua salinan
   peraturan lesen bermakna satu daripadanya akan terlupa dikemas kini,
   dan module berbayar terdedah percuma. */
/* `agentId` — datang daripada alamat (/prostudio/agent/<id> atau
   /agent/baharu). Ia membenarkan hub melompat terus kepada satu agent,
   atau terus membuka agent baharu, tanpa singgah di senarai.
   `onAlamatAgent` menulis semula alamat selepas agent baharu dicipta —
   tanpa itu, muat semula halaman di /baharu akan mencipta agent LAGI. */
export default function ProStudioAgentSection({ v39 = false, aksesSmart = true, onNaikTaraf, agentId, onAlamatAgent }) {
  /* ⭐⭐ SEKSYEN INI DIKONGSI DUA RUPA — jangan panggil `t()` terus.
     Rupa LAMA (ProStudioView, v39=false) ialah laluan pelanggan sebenar
     hari ini dan ia 100% Melayu. Bahasa lalai app pula English, jadi
     `t()` tanpa syarat akan menukar halaman pelanggan kepada English
     tanpa sesiapa memilihnya. Corak wajib (sama seperti LibraryView):
        T(kunci, ayatMelayuAsal)  →  v39 ? kamus : ayat asal
     ⚠️ `ayatMelayuAsal` MESTI sama tepat dengan ayat asal — ia yang
     menjaga rupa lama. */
  const { t, lang } = useLang();
  const T = (kunci, lalai, vars) => (v39 ? t(kunci, vars) : lalai);

  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [saving, setSaving] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  /* Langkah yang sedang dipapar (1–5). Rangka stepper: satu langkah
     satu skrin. Logik setiap langkah TIDAK berubah — hanya bila ia
     dirender. */
  const [langkah, setLangkah] = useState(1);
  /* Skrin senarai vs skrin langkah.
     ⚠️ TIDAK boleh guna `selectedId = ''` untuk kembali ke senarai:
        ada penjaga lama yang memilih semula agent pertama sebaik
        pilihan dikosongkan, jadi skrin melantun balik ke borang. */
  const [lihatSenarai, setLihatSenarai] = useState(false);
  const [products, setProducts] = useState([]);        // produk sebenar user (untuk ujian)
  const [productsLoading, setProductsLoading] = useState(true);
  const [testProductId, setTestProductId] = useState('');
  const [runState, setRunState] = useState('idle');    // idle | running | done
  const [runStep, setRunStep] = useState(0);
  const [runElapsed, setRunElapsed] = useState(0);     // saat berlalu semasa Configure (bagi rasa "hidup")
  const [previewSet, setPreviewSet] = useState(1);     // set mana dipapar dalam kad pratonton
  const [runError, setRunError] = useState('');
  // Modal "Extension Terputus Sambungan" — dipapar bila ping extension gagal
  // semasa Configure (ganti amaran merah inline). Rupa SAMA dengan Workspace Run Flow.
  const [extDisconnected, setExtDisconnected] = useState(false);
  /* Baca senarai model Gemini — tugasan ringkas, berasingan daripada larian
     Configure. Ia tidak pernah berjalan serentak dengan larian. */
  const [bacaModel, setBacaModel] = useState(false);
  const [modelError, setModelError] = useState('');
  const [rawTurns, setRawTurns] = useState([]);        // teks setiap pusingan larian terakhir (tidak disimpan)
  /* ★ Gambar yang extension pulangkan pada larian Configure terakhir — PRATONTON
     sahaja (keputusan user 2026-09-11): Configure berjalan atas produk My Products,
     bukan kad, jadi tiada tempat untuk menyimpannya. Tidak disimpan ke Firestore. */
  const [gambarLarian, setGambarLarian] = useState([]);
  /* ★ Laporan gambar PRODUK yang extension hantar kepada agent pada larian Configure
     terakhir (2026-09-13) — hasil `ringkasGambarProduk`; null = produk ujian tiada
     gambar tambahan / belum dijalankan. Tidak disimpan. */
  const [gambarProdukLarian, setGambarProdukLarian] = useState(null);
  /* ★ Tetapan larian yang TIDAK menjadi pada larian Configure terakhir (2026-09-13) —
     [{ kunci, vars }] untuk skrin hasil: ChatGPT "Matikan Thinking" · Gemini Extended
     thinking / model. Milik larian, tidak disimpan. */
  const [amaranTetapanLarian, setAmaranTetapanLarian] = useState([]);
  const [matching, setMatching] = useState(false);     // sedang padan semula selepas tukar pusingan
  const [savedFlash, setSavedFlash] = useState(false);
  /* Lihat nota pada larianV39. Ditetapkan semula setiap kali agent bertukar —
     kalau tidak, agent seterusnya dibuka terus dalam mod persediaan walaupun
     ia sudah READY. */
  const [ubahTetapan, setUbahTetapan] = useState(false);
  const [dirtyIds, setDirtyIds] = useState({});
  /* Susunan senarai: baris yang sedang ditarik, dan celah tempat ia mendarat.
     Keadaan PAPARAN sahaja — susunan sebenar duduk pada doc agent. */
  const [tarikId, setTarikId] = useState(null);
  const [sasar, setSasar] = useState(null);        // { id, bawah }
  /* Sifat peranti, disemak sekali. Tarik-lepas tidak berfungsi pada skrin
     sentuh, jadi pemegang tarik tidak dirender di sana — anak panah naik/turun
     yang menjadi laluan susun pada telefon. */
  const [adaTetikus] = useState(() => bolehTarikTetikus());
  const timers = useRef([]);
  // Cermin `dirtyIds` untuk dibaca dalam callback onSnapshot (elak closure basi).
  const dirtyRef = useRef({});
  useEffect(() => { dirtyRef.current = dirtyIds; }, [dirtyIds]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  const uid = auth.currentUser?.uid || null;

  // ── Muat agent dari Firestore (langsung/live) ──
  // Agent yang SEDANG diedit (dirty) TIDAK ditimpa oleh snapshot —
  // kalau tidak, taipan pengguna hilang setiap kali doc lain berubah.
  useEffect(() => {
    if (!uid) { setLoading(false); return; }
    const ref = collection(db, 'users', uid, AGENT_COL);
    const unsub = onSnapshot(ref, (snap) => {
      const items = snap.docs
        .map(d => ({ id: d.id, data: d.data() || {} }))
        .filter(x => Number(x.data.agentV) === AGENT_V)   // abai template Smart Custom lama
        /* Disusun pada doc MENTAH, sebelum pemetaan — pembanding yang sama
           dipakai oleh hub dan Workspace, yang bentuk datanya berbeza. */
        .sort((a, b) => bandingAgent(a.data, b.data))
        .map(x => fromDoc(x.id, x.data));

      setAgents(prev => items.map(it => (dirtyRef.current[it.id]
        ? (prev.find(p => p.id === it.id) || it)          // kekalkan salinan tempatan
        : it)));
      setLoading(false);
      setLoadError('');
    }, (err) => {
      console.error('[ProStudioAgent] load gagal:', err);
      setLoadError(err.message || 'Gagal memuatkan senarai agent.');
      setLoading(false);
    });
    return () => unsub();
  }, [uid]);

  /* ── Perenggan DATA PRODUK bagi produk ujian yang dipilih ──────────
     Kebanyakan item My Products membawa teksnya terus dalam senarai (medan
     `teksData` di atas) — jadi tiada bacaan langsung diperlukan. Skema v2
     memindahkan sebahagiannya ke subdoc `payload/data`; hanya kes ITU dibaca,
     satu-satu, hanya untuk produk yang sedang dipilih. Hasil disimpan dalam
     peta supaya bertukar-tukar produk tidak membaca berulang kali.
     Kegagalan dibiarkan senyap: pratonton jatuh kepada ayat "belum ada data",
     dan larian sebenar di Workspace tetap membaca datanya sendiri. */
  const [dataProduk, setDataProduk] = useState({});   // { [itemId]: teks|null }
  useEffect(() => {
    if (!testProductId || dataProduk[testProductId] !== undefined) return;
    const p = products.find(x => x.id === testProductId);
    if (!p) return;
    if (p.teksData) { setDataProduk(prev => ({ ...prev, [testProductId]: p.teksData })); return; }
    let alive = true;
    (async () => {
      try {
        const { loadLibraryPayload } = await import('../services/libraryPayloadService');
        const payload = await loadLibraryPayload('product', testProductId);
        const teks = String(payload?.intelligenceJson?.imageAnalysis || '');
        if (alive) setDataProduk(prev => ({ ...prev, [testProductId]: teks || null }));
      } catch (e) {
        console.warn('[ProStudioAgent] data produk tak dapat dimuat:', e?.message);
        if (alive) setDataProduk(prev => ({ ...prev, [testProductId]: null }));
      }
    })();
    return () => { alive = false; };
  }, [testProductId, products, dataProduk]);

  /* Produk + perenggan datanya, digabung ke dalam bentuk yang SAMA seperti kad
     Workspace (`intelligenceData.imageAnalysis`) — supaya `blokDataAgent`
     kekal satu takrifan untuk kedua-dua laluan. SATU helper dipakai oleh
     pratonton DAN larian Configure; kalau dua tempat menggabungkannya sendiri,
     pratonton boleh menunjukkan sesuatu yang tidak pernah dihantar. */
  const produkDenganData = (p) => (p
    ? { ...p, intelligenceData: { imageAnalysis: dataProduk[p.id] || p.teksData || '' } }
    : null);

  /* ── Muat produk untuk pemilih "Produk untuk ujian" ─────────────────
     ⛔ SUMBER = MY PRODUCTS (`library/product/items`), BUKAN kad Workspace
        (arahan user 2026-08-21: *"Product to test with ini hanya utk my
        products je"*). Sebabnya bukan gaya:
        · Kad Workspace ialah SALINAN — pelanggan boleh ada 6 kad untuk produk
          yang sama, jadi senarai penuh nama berulang yang mustahil dibezakan.
        · Status READY/PENDING hidup pada doc My Products, jadi menapis produk
          tanpa data adalah PERCUMA. Pada kad Workspace ia memerlukan bacaan
          simpanan teks bagi SETIAP kad (~1MB sekali buka) — kos yang kita
          memang sedang cuba kurangkan.
        · Borang "Edit Data Produk" menulis ke sinilah juga, jadi apa yang
          pelanggan sunting ialah apa yang agent nampak.

     ⚠️ HANYA READY dipaparkan (arahan user: *"munculkan yg ada status ready
        je"*). Produk PENDING memang tiada data — mengkalibrasi agent atasnya
        sama sahaja seperti agent tidak nampak data langsung.

     ⚠️ Satu `where` sahaja, tapisan lain di klien — corak SAMA seperti
        LibraryView, sengaja mengelak composite index baharu. */
  useEffect(() => {
    const email = auth.currentUser?.email || '';
    if (!uid || !email) { setProductsLoading(false); return; }
    let alive = true;
    (async () => {
      try {
        const snap = await getDocs(query(
          collection(db, 'library', 'product', 'items'),
          where('addedBy', '==', email),
        ));
        if (!alive) return;
        const list = snap.docs.map(d => {
          const p = d.data() || {};
          return {
            id: d.id,
            group: p.group || '',
            ready: p.hasIntelligence === true,
            name: String(p.name || 'Tanpa nama'),
            link: String(p.link || p.sourceUrl || ''),
            image: p.imageUrl || p.rawImageUrl || '',
            /* ★ Gambar TAMBAHAN (maks 4, pautan sahaja) — dihantar bersama gambar utama
               semasa Configure, sama seperti larian kad di Workspace (2026-09-13). */
            extraImages: senaraiTambahan(p),
            price: String(p.price || ''),
            originalPrice: String(p.originalPrice || ''),
            discount: String(p.discount || ''),
            /* Teks data selalunya duduk pada doc ini sendiri (disahkan: 18/20
               item READY) — jadi ia datang PERCUMA bersama senarai. Yang
               tinggal dibaca satu-satu daripada subdoc payload bila dipilih. */
            teksData: String(p.intelligenceJson?.imageAnalysis || ''),
          };
        }).filter(p => p.name && p.group === 'own' && p.ready);
        setProducts(list);
        setTestProductId(prev => (prev && list.some(p => p.id === prev)) ? prev : (list[0]?.id || ''));
      } catch (e) {
        console.error('[ProStudioAgent] muat produk gagal:', e);
      } finally {
        if (alive) setProductsLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [uid]);

  // Pemasa Configure — detik saat semasa 'running' supaya progres nampak HIDUP
  // (ikon berpusing sahaja tidak cukup meyakinkan untuk tunggu 1–2 minit).
  // Date.now() dipakai supaya kiraan tepat walau setInterval drift.
  useEffect(() => {
    if (runState !== 'running') { setRunElapsed(0); return; }
    const t0 = Date.now();
    setRunElapsed(0);
    const id = setInterval(() => setRunElapsed(Math.floor((Date.now() - t0) / 1000)), 500);
    return () => clearInterval(id);
  }, [runState]);

  // Pastikan sentiasa ada agent terpilih yang sah
  useEffect(() => {
    if (loading) return;
    if (!agents.length) { if (selectedId) setSelectedId(''); return; }
    if (!agents.some(a => a.id === selectedId)) setSelectedId(agents[0].id);
  }, [agents, selectedId, loading]);

  /* Bila agent dipilih atau dimuat semula, pulangkan jawapan mentah TERAKHIR
     yang tersimpan (lastRaw) → kad pratonton + senarai padanan + edit blok terus
     hidup TANPA perlu Configure (scrape) semula.
     ⛔ Dikunci pada [selectedId, loading] SAHAJA. Ia SENGAJA tidak re-fire semasa
        Configure — larian hanya menukar ISI agent, bukan id/loading — jadi rawTurns
        LANGSUNG larian (berbilang pusingan) tidak ditimpa oleh salinan tersimpan. */
  useEffect(() => {
    const a = agents.find(x => x.id === selectedId);
    setRawTurns(a?.lastRaw ? [a.lastRaw] : []);
    setGambarLarian([]);   // gambar pratonton milik larian, bukan agent — kosongkan bila agent bertukar
    setGambarProdukLarian(null);
    setAmaranTetapanLarian([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId, loading]);

  const agent = agents.find(a => a.id === selectedId) || null;
  const isDirty = !!dirtyIds[selectedId];
  const paparEditor = !!agent && !lihatSenarai;

  /* Alamat → skrin. Dijalankan SEKALI bagi setiap nilai alamat
     (`alamatDibuatRef`), supaya snapshot Firestore yang tiba kemudian
     tidak mencetuskannya semula. */
  const alamatDibuatRef = useRef(null);
  useEffect(() => {
    /* ⛔ Pagar akses DAHULU. Tanpa ini, pelanggan tanpa SMART yang
       menekan "Add agent" akan MENCIPTA agent dalam Firestore sebelum
       dia sempat nampak skrin berkunci. */
    if (!aksesSmart) return;
    if (!agentId || loading || alamatDibuatRef.current === agentId) return;
    alamatDibuatRef.current = agentId;
    if (agentId === 'baharu') { newAgent(); return; }
    if (agents.some((a) => a.id === agentId)) {
      // Pulih langkah selepas "Refresh Tab Sekarang" (modal extension terputus).
      // Disimpan dalam sessionStorage (ingatan browser) — SEKALI guna, dibuang
      // sebaik dibaca. TIADA kos Firebase: langsung tidak menyentuh Firestore.
      let mulaLangkah = 1;
      try {
        const raw = sessionStorage.getItem('sesaat_prostudio_resume_step');
        if (raw) {
          sessionStorage.removeItem('sesaat_prostudio_resume_step');
          const simpan = JSON.parse(raw);
          if (simpan && simpan.agentId === agentId && Number.isInteger(simpan.langkah) && simpan.langkah >= 1 && simpan.langkah <= 4) {
            mulaLangkah = simpan.langkah;
          }
        }
      } catch { /* sessionStorage tak tersedia (cth mod privasi) — abaikan, mula di 1 */ }
      selectAgent(agentId, mulaLangkah);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentId, loading, agents]);
  const wantsVideo = agent?.output === 'imagevideo';

  const patchAgent = (patch) => {
    setAgents(prev => prev.map(a => (a.id === selectedId ? { ...a, ...patch } : a)));
    setDirtyIds(prev => ({ ...prev, [selectedId]: true }));
  };

  /* ── Susun semula senarai agent ──────────────────────────────────────
     Dipanggil dengan senarai id dalam susunan BAHARU. Senarai tempatan
     digerakkan dahulu supaya baris melekat di bawah kursor, kemudian susunan
     ditulis; snapshot akan memapar susunan yang sama sebentar kemudian.
     Kalau tulisan gagal, snapshot itulah yang memulangkan susunan lama. */
  const susunSemula = async (idsBaru) => {
    if (!uid) return;
    setAgents(prev => idsBaru.map(id => prev.find(a => a.id === id)).filter(Boolean));
    try {
      await simpanSusunanAgent(uid, idsBaru);
    } catch (e) {
      console.error('[ProStudioAgent] simpan susunan gagal:', e);
      alert(T('prostudio.wizard.orderFail', 'Gagal menyimpan susunan baharu: ') + (e.message || e));
    }
  };

  const naikTurunAgent = (dari, ke) => {
    if (ke < 0 || ke >= agents.length) return;
    susunSemula(alihItem(agents.map(a => a.id), dari, ke));
  };

  const lepasAgent = (idSasar, bawah) => {
    const ids = agents.map(a => a.id);
    const dari = ids.indexOf(tarikId);
    const atas = ids.indexOf(idSasar);
    setTarikId(null);
    setSasar(null);
    if (dari < 0 || atas < 0) return;
    susunSemula(sisipItem(ids, dari, bawah ? atas + 1 : atas));
  };

  const selectAgent = (id, mulaLangkah = 1) => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
    setUbahTetapan(false);
    setSelectedId(id);
    setLihatSenarai(false);
    setLangkah(mulaLangkah);   // biasanya 1; tapi boleh pulih langkah selepas refresh
    setRunState('idle');
    setRunStep(0);
  };

  // Agent baru terus ditulis ke Firestore supaya ia ada id sebenar —
  // barulah semua suntingan seterusnya menulis ke doc yang sama.
  const newAgent = async () => {
    if (!uid || saving) return;
    let n = 1;
    while (agents.some(a => a.name === `Agent Baru ${n}`)) n++;
    const id = `agt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const fresh = { id, ...makeDefaultAgent(`Agent Baru ${n}`) };
    setSaving(true);
    try {
      /* Susunan diberi HANYA bila senarai memang sudah bersusun. Memberi 0
         kepada agent baharu ketika tiada satu pun agent lain membawa susunan
         akan melantiknya ke ATAS senarai — bukan ke bawah, tempat pelanggan
         menjangka barang baharu muncul. */
      const susunan = susunanBaru(agents);
      await setDoc(doc(db, 'users', uid, AGENT_COL, id), {
        ...toDoc(fresh),
        ...(susunan === null ? {} : { order: susunan }),
        createdAt: serverTimestamp(),
      });
      selectAgent(id);
      /* Alamat ditulis semula daripada /agent/baharu kepada agent yang
         baru dicipta. Tanpa ini, muat semula halaman mencipta agent LAGI
         setiap kali. */
      onAlamatAgent?.(id);
    } catch (e) {
      console.error('[ProStudioAgent] cipta gagal:', e);
      alert(T('prostudio.agentsec.errCreate', 'Gagal mencipta agent baharu: ') + (e.message || e));
    } finally {
      setSaving(false);
    }
  };

  const deleteAgent = async (id) => {
    if (!uid) return;
    const target = agents.find(a => a.id === id);
    if (target && !window.confirm(T(
      'prostudio.agentsec.confirmDelete',
      `Padam agent "${target.name}"? Tindakan ini tidak boleh dibatalkan.`,
      { nama: target.name },
    ))) return;
    try {
      await deleteDoc(doc(db, 'users', uid, AGENT_COL, id));
      setDirtyIds(prev => { const n = { ...prev }; delete n[id]; return n; });
    } catch (e) {
      console.error('[ProStudioAgent] padam gagal:', e);
      alert(T('prostudio.agentsec.errDelete', 'Gagal memadam agent: ') + (e.message || e));
    }
  };

  // ── Field (dua kumpulan: 'sceneFields' per babak, 'setFields' per set) ──
  const setField = (group, fid, patch) =>
    patchAgent({ [group]: agent[group].map(f => (f.id === fid ? { ...f, ...patch } : f)) });

  // Field TETAP 3 (Prompt Gambar · Prompt Video · Caption TikTok) — langkah "Borang
  // Output" dibuang 2026-08-19 (arahan user: pelanggan keliru). Tiada tambah/buang
  // field lagi; `setField` KEKAL kerana composer di Configure menulis `template`
  // melaluinya.

  // ── Balasan berturutan ──
  const setReply = (i, v) =>
    patchAgent({ replies: agent.replies.map((r, idx) => (idx === i ? v : r)) });
  const addReply = () => {
    if (agent.replies.length >= MAX_REPLIES) return;
    patchAgent({ replies: [...agent.replies, ''], replyImages: [...(agent.replyImages || []), false] });
  };
  const removeReply = (i) =>
    patchAgent({
      replies: agent.replies.filter((_, idx) => idx !== i),
      replyImages: (agent.replyImages || []).filter((_, idx) => idx !== i),
    });

  /* ★ Gambar daripada jawapan (2026-09-11) — satu suis setiap pusingan. Had =
     MAKS_GAMBAR_TAMBAHAN pusingan bertanda (kad muat 5 gambar termasuk gambar
     utama). Suis ke-5 tidak boleh dihidupkan — dan ayat di skrin menerangkan
     sebabnya, bukan suis yang mati senyap. Kiraan di sini mengira SEMUA bendera
     (termasuk balasan yang masih kosong) supaya had kelihatan konsisten ketika
     pelanggan sedang menaip. */
  /* ⛔ `agent` boleh NULL semasa render (laluan /prostudio/agent/baharu sebelum agent
     dicipta, atau tiada agent dipilih) — baca medannya TANPA pagar = seluruh halaman
     crash ke skrin "Ralat berlaku" (ditangkap user 2026-09-11). Corak sama seperti
     `previewSetCount`/`jangkaV39` di bawah: pagar `agent ?` dahulu. */
  const jumlahGambarDitanda = agent ? (agent.firstImage ? 1 : 0) + (agent.replyImages || []).filter(Boolean).length : 0;
  const gambarPenuh = jumlahGambarDitanda >= MAKS_GAMBAR_TAMBAHAN;
  const toggleFirstImage = () => {
    if (!agent) return;
    if (!agent.firstImage && gambarPenuh) return;
    patchAgent({ firstImage: !agent.firstImage });
  };
  const toggleReplyImage = (i) => {
    if (!agent) return;
    const kini = !!(agent.replyImages || [])[i];
    if (!kini && gambarPenuh) return;
    patchAgent({ replyImages: agent.replies.map((_, idx) => (idx === i ? !kini : !!(agent.replyImages || [])[idx])) });
  };

  // Bila babak dikurangkan, pilihan "babak N" yang dah tak wujud kena dilaraskan
  const changeSceneCount = (n) => {
    const fix = (v) => (typeof v === 'number' && v > n ? n : v);
    patchAgent({ sceneCount: n, productPhoto: fix(agent.productPhoto), avatar: fix(agent.avatar) });
  };

  // Padankan SATU pusingan perbualan dengan borang. Diasingkan supaya menukar
  // pilihan "Output diambil daripada" boleh padan semula TANPA menjalankan
  // semula keseluruhan larian (jimat masa + tiada tab ChatGPT dibuka semula).
  const applyMatch = async (turns, idx) => {
    const answer = String(turns[idx] || '').trim();
    if (answer.length < 40) {
      setRunError(T('prostudio.agentsec.errTurnEmpty', 'Pusingan yang dipilih tidak mengandungi jawapan yang boleh dipadankan. Pilih pusingan lain.'));
      return false;
    }
    const payloadFields = [
      ...agent.sceneFields
        .filter(f => !(f.role === 'video' && agent.output === 'image'))
        .map(f => ({ id: f.id, label: f.label, role: f.role, scope: 'scene' })),
      ...agent.setFields.map(f => ({ id: f.id, label: f.label, role: f.role, scope: 'set' })),
    ];

    const out = await aiService.matchAgentOutput({
      rawText: answer,
      fields: payloadFields,
      setCount: agent.setCount,
      sceneCount: agent.sceneCount,
    });

    const map = out?.mapping || {};
    const sumberBaru = Array.isArray(out?.sources) ? out.sources : [];

    /* ⭐ AUTO-PETAKAN BABAK 2 KE ATAS — 2026-08-26.
       Pemadan AI memulangkan SATU blok bagi setiap medan. Untuk agent berbilang
       babak itu tidak mencukupi: jawapan lazimnya membawa satu TAJUK BERASINGAN
       bagi setiap babak ("… (SCENE 1)" dan "… (SCENE 2)"). Tanpa langkah ini
       babak 2 mewarisi blok babak 1, jadi setiap set menerima video babak 1 dua
       kali dan pelanggan terpaksa membetulkannya sendiri.

       ⛔ Ia hanya bertindak apabila blok babak 1 SENDIRI menyebut nombor babak,
       dan hanya memilih tajuk yang SAMA BENTUK dengan nombornya bertukar. Kalau
       tiada calon yang jelas ia berdiam diri: tekaan yang salah lebih buruk
       daripada tiada tekaan, kerana pelanggan tidak akan menyemaknya semula. */
    const polaBabak = /(scene|babak|part|bahagian)\s*[-:#. ]?\s*(\d+)/i;
    const rangkaTajuk = (x) => String(x || '').toLowerCase()
      .replace(/(scene|babak|part|bahagian)\s*[-:#. ]?\s*\d+/gi, '#')
      .replace(/[^a-z0-9#]+/g, '');
    const kodSumberBaru = petaSlug([...new Set([...sumberBaru, ...(agent.customSources || [])])]).kodBagiSumber;
    const babakAuto = (f, src) => {
      const n = Math.max(1, agent.sceneCount || 1);
      if (n < 2 || !src || !medanPerBabak(f, n) || !polaBabak.test(src)) return null;
      const bentuk = rangkaTajuk(src);
      const scenes = Array.from({ length: n }, () => null);
      let ada = false;
      for (let s = 2; s <= n; s += 1) {
        const calon = sumberBaru.find((x) => {
          const m = String(x).match(polaBabak);
          return m && Number(m[2]) === s && rangkaTajuk(x) === bentuk;
        });
        if (calon && kodSumberBaru[calon]) { scenes[s - 1] = '@' + kodSumberBaru[calon]; ada = true; }
      }
      return ada ? scenes : null;
    };
    const apply = (f) => {
      const asas = { ...f, source: map[f.id] || null };
      /* Pilihan yang pelanggan SUDAH buat sendiri tidak pernah ditimpa. */
      if (Array.isArray(f.scenes) && f.scenes.some(v => typeof v === 'string')) return asas;
      const auto = babakAuto(asas, asas.source);
      return auto ? { ...asas, scenes: auto } : asas;
    };

    setAgents(prev => prev.map(a => a.id === selectedId
      ? {
        ...a,
        outputTurn: idx,
        sceneFields: a.sceneFields.map(apply),
        setFields: a.setFields.map(apply),
        sources: sumberBaru,
        setsDetected: out?.setsDetected || 0,
        scenesDetected: out?.scenesDetected || 0,
      }
      : a));
    setDirtyIds(prev => ({ ...prev, [selectedId]: true }));
    setRunError('');
    return true;
  };

  // Tukar pusingan output → padan semula guna teks pusingan itu.
  const changeOutputTurn = async (idx) => {
    if (matching || !rawTurns.length) { patchAgent({ outputTurn: idx }); return; }
    setMatching(true);
    try {
      await applyMatch(rawTurns, idx);
    } catch (e) {
      console.error('[ProStudioAgent] padan semula gagal:', e);
      setRunError(e?.message || T('prostudio.agentsec.errRematch', 'Gagal memadankan semula. Sila cuba lagi.'));
    } finally {
      setMatching(false);
    }
  };

  // ── Configure: larian SEBENAR ──
  //   1) ping extension  2) hantar SATU produk ke custom GPT pelanggan lalu
  //   ambil jawapan MENTAH  3) hantar jawapan itu ke pemadan AI (Cloud Function)
  //   lalu isikan jadual padanan.
  // ⚠️ TIADA gateBlock dihantar — blok kod lesen SESAAT hanya untuk GPT rasmi
  //    kita; menghantarnya ke GPT milik penjual lain hanya mengelirukan jawapan.
  const runConfigure = async () => {
    if (!agent?.url?.trim() || runState === 'running') return;
    const prod = products.find(p => p.id === testProductId);
    if (!prod) { setRunError(T('prostudio.agentsec.errNoProduct', 'Sila pilih produk untuk ujian terlebih dahulu.')); return; }

    setRunError('');
    setRawTurns([]);
    setGambarLarian([]);
    setGambarProdukLarian(null);
    setAmaranTetapanLarian([]);
    setRunState('running');
    setRunStep(0);
    /* Larian bermula — skrin persediaan sudah tamat tugasnya. Tanpa baris ini
       hasil larian tidak akan dipapar; pelanggan kembali ke borang yang sama. */
    setUbahTetapan(false);

    try {
      // 1) Extension hidup?
      const alive = await pingExtension();
      if (!alive) {
        setRunState('idle');
        // Ganti amaran merah inline → modal "Extension Terputus Sambungan"
        // (rupa + butang SAMA seperti Workspace Run Flow).
        setExtDisconnected(true);
        return;
      }

      // 2) Hantar produk → tunggu jawapan agent
      setRunStep(1);
      const res = await sendAgentTask({
        gptUrl: agent.url.trim(),
        productName: prod.name,
        productLink: prod.link,
        imageBase64: prod.image,
        masterPrompt: '',          // custom GPT pelanggan bawa arahannya sendiri
        // agentMode → extension TIDAK menampal ayat "Keluarkan output dalam format
        // JSON yang diminta." GPT penjual lain tidak semestinya direka untuk JSON,
        // dan pemadan AI kita memang boleh membaca markdown / teks biasa.
        agentMode: true,
        moduleLabel: 'Smart Custom',   // tajuk overlay dalam tab ChatGPT

        // Kalibrasi WAJIB guna perbualan yang SAMA seperti larian sebenar —
        // kalau tidak, format yang dipadankan di sini tidak sepadan dengan
        // apa yang agent keluarkan semasa larian betul.
        /* ★ DATA PRODUK ditampal melalui `extraInstruction` (2026-08-21).
           Sengaja BUKAN medan baharu: extension menampal `extraInstruction`
           di HUJUNG mesej pertama, tepat selepas nama + link — iaitu kedudukan
           yang dikehendaki. `masterPrompt` pula ditampal di ATAS mesej dan
           membawa pembalut "--- INPUT:" sendiri, jadi data akan mendahului
           nama produk. Kesan sampingan yang paling penting: TIADA perubahan
           extension diperlukan, jadi ciri ini sampai kepada pelanggan dengan
           deploy webapp sahaja.
           ⛔ Nilai TERSIMPAN tidak disentuh — gabungan dibuat masa hantar. */
        extraInstruction: gabungArahanAgent(produkDenganData(prod), agent),
        replies: Array.isArray(agent.replies)
          ? agent.replies.map(r => String(r || '').trim()).filter(Boolean)
          : [],
        /* ★ Pusingan yang gambarnya disimpan (2026-09-11). Peraturan EMPAT tempat:
           payload di sini · payload Workspace · jambatan content.ts · background.ts. */
        imageTurns: imageTurnsDaripadaAgent(agent),
        /* ★ Gambar TAMBAHAN produk ujian (2026-09-13) — sehingga 5 gambar sampai kepada
           agent, SAMA seperti larian kad di Workspace (kalibrasi mesti atas bentuk yang
           sama). Peraturan EMPAT tempat: di sini · payload Workspace · jambatan
           content.ts · background.ts. */
        extraImageUrls: prod.extraImages || [],
        platform: agent.platform === 'gemini' ? 'gemini' : 'chatgpt',
        geminiModel: agent.platform === 'gemini' ? (agent.geminiModel || '') : '',
        // Tahap baharu (chatgptTahap) menang; medan lama hanya bila agent belum pilih tahap.
        chatgptExtendedOff: agent.platform === 'gemini' ? false : (!agent.chatgptTahap && agent.chatgptExtended === 'mati'),
        /* ★ Tahap Thinking ChatGPT (2026-09-26). Peraturan EMPAT tempat: di sini · payload
           Workspace (WorkspaceView) · jambatan content.ts · background.ts. */
        chatgptTahap: agent.platform === 'gemini' ? '' : (agent.chatgptTahap || ''),
        // ★ Gemini sahaja — 'low'/'medium'/'high' = pastikan tahap Thinking; '' = jangan sentuh.
        //   (Nama medan kekal "Extended"; robot juga faham nilai lama 'on'/'off'.)
        geminiExtended: agent.platform === 'gemini' ? normTahapGemini(agent.geminiExtended) : '',
        // Configure ialah SATU-SATUNYA larian yang meminta senarai model. Larian
        // pukal tidak — membuka menu model pada setiap produk menambah titik
        // kegagalan tanpa faedah.
        wantModelList: agent.platform === 'gemini',
        taskCurrent: 1,
        taskTotal: 1,
        // ★ Configure = ujian sekali. Lepas siap, extension tukar fokus BALIK ke
        //   tab Pro Studio ini (bukan tinggal di tab Gemini/ChatGPT). Flag ini
        //   dihantar HANYA dari Configure — larian pukal Workspace tidak menghantarnya.
        returnToOrigin: true,
      });

      if (!res?.success) {
        setRunState('idle');
        // Larian agent TIDAK dicuba semula sendiri (boleh hantar produk dua kali) — mesej sahaja.
        setRunError(adalahRalatSambungan(res?.error) ? T('ext.ralatSambungan', 'SESAAT tidak dapat connect dengan extension. Tekan "Reload" di manage extension, kemudian cuba lagi.')
          : (res?.error || T('prostudio.agentsec.errNoAnswer', 'Agent tidak memberikan jawapan.')));
        return;
      }

      // rawTurns = teks setiap pusingan. Extension lama hanya pulangkan rawText /
      // rawJson — dibalut jadi satu pusingan supaya laluan lama tetap berfungsi.
      const fallback = String(
        res.data?.rawText
        || (res.data?.rawJson ? JSON.stringify(res.data.rawJson, null, 2) : '')
      ).trim();
      const turns = (Array.isArray(res.data?.rawTurns) && res.data.rawTurns.length
        ? res.data.rawTurns.map(t => String(t || '').trim())
        : [fallback]).filter((t, i, arr) => t || i < arr.length);

      if (!turns.some(t => t.length >= 40)) {
        setRunState('idle');
        setRunError(T('prostudio.agentsec.errShort', 'Jawapan daripada agent kosong atau terlalu pendek. Pastikan GPT tersebut benar-benar membalas, kemudian cuba semula.'));
        return;
      }
      setRawTurns(turns);
      /* Gambar daripada pusingan bertanda — pratonton pada skrin hasil. Extension
         lama tidak memulangkan `images` langsung → senarai kosong, dan skrin hasil
         menyatakannya (bukan berdiam diri). */
      setGambarLarian(Array.isArray(res.data?.images)
        ? res.data.images.filter(g => g && typeof g.dataUrl === 'string' && g.dataUrl.startsWith('data:image/'))
        : []);
      /* Gambar produk yang BETUL-BETUL sampai kepada agent — kekurangan dipapar pada
         skrin hasil (bukan senyap). null bila produk ujian tiada gambar tambahan. */
      setGambarProdukLarian(ringkasGambarProduk((prod.extraImages || []).length, res.data?.gambarProduk));
      /* ★ Tetapan larian yang tidak menjadi → amaran pada skrin hasil (2026-09-13).
         Nilai undefined (extension lama tidak memulangkannya) = tiada amaran. */
      const _amaran = [];
      if (agent.platform === 'gemini') {
        /* ★ 2026-10-11: tahap Thinking (Low/Medium/High) menggantikan Extended hidup/mati.
           Perbandingan dibuat oleh SATU util (KEMBAR laluan Workspace) — ia juga membaca
           jawapan gaya lama 'on'/'off' daripada skrip yang belum dikemas kini. */
        const _tahap = semakTahapGemini(agent.geminiExtended, res.data);
        if (_tahap) {
          _amaran.push(_tahap.guna
            ? { kunci: 'prostudio.cfg.geminiTahapGagal', vars: { mahu: _tahap.mahu, guna: _tahap.guna } }
            : { kunci: 'prostudio.cfg.geminiTahapGagalUmum', vars: { mahu: _tahap.mahu } });
        }
        if (res.data?.geminiModelSepadan === false) {
          _amaran.push({ kunci: 'prostudio.cfg.geminiModelGagal', vars: { mahu: agent.geminiModel || '', guna: res.data?.geminiModelUsed || '—' } });
        }
      } else {
        // 'on' daripada extension lama pun bermakna cip Thinking tidak dibuang.
        const _thinkingKeadaan = res.data?.chatgptExtendedUsed;
        if (agent.chatgptTahap) {
          // Skrip lama tidak memulangkan chatgptTahapKeadaan → juga dikira gagal (bising, bukan senyap).
          if (res.data?.chatgptTahapKeadaan !== 'ok') {
            _amaran.push({ kunci: 'prostudio.cfg.tahapGagal', vars: { mahu: agent.chatgptTahap, nota: res.data?.chatgptTahapNota || '—' } });
          }
        } else if (agent.chatgptExtended === 'mati' && typeof _thinkingKeadaan === 'string' && _thinkingKeadaan !== 'off') {
          _amaran.push({ kunci: 'prostudio.cfg.thinkingGagal' });
        }
        const _akaun = String(res.data?.chatgptAkaun || '').trim();
        if (_akaun && _akaun !== agent.chatgptAkaun) patchAgent({ chatgptAkaun: _akaun });
      }
      setAmaranTetapanLarian(_amaran);

      // Senarai model akaun yang dibaca semasa larian tadi. Kosong bermakna menu
      // model enggan render — kekalkan senarai lama, JANGAN kosongkan pilihan
      // yang pelanggan sudah buat.
      const modelDibaca = Array.isArray(res.data?.geminiModels) ? res.data.geminiModels.filter(Boolean) : [];
      if (modelDibaca.length) {
        /* ★ 2026-10-11: akaun yang kini hanya ada SATU model (Gemini 3 "Auto") — larian tadi
           memang memakai model itu, jadi pilihan agent diselaraskan (dahulu tiada butang
           yang menyala dan amaran model keluar pada setiap Configure). */
        const _tunggal = modelTunggalGemini(modelDibaca, agent.geminiModel);
        patchAgent(_tunggal ? { geminiModels: modelDibaca, geminiModel: _tunggal } : { geminiModels: modelDibaca });
      }

      // Pusingan mana jadi output: hormati pilihan tersimpan, tapi kepit pada
      // bilangan pusingan yang benar-benar berlaku. Default = pusingan TERAKHIR.
      const savedTurn = Number.isFinite(agent.outputTurn) ? agent.outputTurn : turns.length - 1;
      const idx = Math.max(0, Math.min(turns.length - 1, savedTurn));

      /* Simpan turn terpilih → kad pratonton + edit blok terus hidup bila agent
         dibuka semula. Perlu tekan Simpan untuk kekal merentas muat semula. */
      patchAgent({ lastRaw: turns[idx] || '', runAtTs: Date.now(), chatUrl: pautanPerbualanSah(res.data?.chatInstructionUrl) });

      // 3) Padan guna AI
      setRunStep(2);
      await applyMatch(turns, idx);
      setRunState('done');
    } catch (e) {
      console.error('[ProStudioAgent] Configure gagal:', e);
      setRunState('idle');
      setRunError(e?.message || T('prostudio.agentsec.errRun', 'Configure gagal. Sila cuba semula.'));
    }
  };

  /* ★ Baca senarai model akaun Gemini SEBELUM larian (arahan user 2026-08-20:
     "user boleh pilih dulu"). Sebelum ini senarai hanya terisi sebagai kesan
     sampingan larian Configure penuh — bermakna pelanggan terpaksa menjalankan
     agent DAHULU sebelum boleh memilih model, sedangkan model itulah yang
     menentukan bentuk jawapan yang dikalibrasi.
     Senarai disimpan pada agent (`patchAgent`), jadi ia menjadikan borang
     "belum disimpan" — memang betul, ia sebahagian tetapan agent. */
  const bacaSenaraiModel = async () => {
    if (!agent || bacaModel) return;
    const url = String(agent.url || '').trim();
    if (!url) { setModelError(T('prostudio.cfg.modelNeedUrl', 'Tampal pautan Gem di Langkah 1 terlebih dahulu.')); return; }
    setModelError('');
    setBacaModel(true);
    try {
      const hidup = await pingExtension();
      if (!hidup) { setExtDisconnected(true); return; }
      const res = await cubaSemulaSambungan(() => mintaSenaraiModel(url));
      if (!res?.success) {
        setModelError(adalahRalatSambungan(res?.error) ? T('ext.ralatSambungan', 'SESAAT tidak dapat connect dengan extension. Tekan "Reload" di manage extension, kemudian cuba lagi.')
          : (res?.error || T('prostudio.cfg.modelFail', 'Senarai model tidak dapat dibaca. Sila cuba lagi.')));
        return;
      }
      const senarai = Array.isArray(res.data?.models) ? res.data.models.filter(Boolean) : [];
      if (!senarai.length) {
        setModelError(T('prostudio.cfg.modelNone', 'Tiada senarai model dijumpai pada Gem itu. Pastikan anda sudah log masuk ke Gemini.'));
        return;
      }
      // Akaun satu-model → pilih model itu terus (tiada pilihan lain untuk dibuat). Status
      // Configured SENGAJA tidak dipadam: model lama memang sudah tiada pada akaun itu.
      const _tunggal = modelTunggalGemini(senarai, agent.geminiModel);
      patchAgent(_tunggal ? { geminiModels: senarai, geminiModel: _tunggal } : { geminiModels: senarai });
    } catch (e) {
      setModelError(e?.message || String(e));
    } finally {
      setBacaModel(false);
    }
  };

  /* ★ Baca pilihan Thinking akaun ChatGPT (2026-09-26) — corak SAMA bacaSenaraiModel;
     keadaan sibuk/ralat dikongsi (agent hanya satu platform). Pilihan yang dibaca
     menggantikan senarai lama; pilihan agent yang tiada lagi dalam senarai dikosongkan
     supaya pelanggan memilih semula (bukan jalan dengan tahap yang tidak wujud). */
  const bacaPilihanThinking = async () => {
    if (!agent || bacaModel) return;
    const url = String(agent.url || '').trim();
    if (!url) { setModelError(T('prostudio.cfg.tahapNeedUrl', 'Tampal pautan GPT di Langkah 1 terlebih dahulu.')); return; }
    setModelError('');
    setBacaModel(true);
    try {
      const hidup = await pingExtension();
      if (!hidup) { setExtDisconnected(true); return; }
      const res = await cubaSemulaSambungan(() => mintaKerjaChatGPT(url, 'bacaPilihan'));
      if (!res?.success) {
        setModelError(adalahRalatSambungan(res?.error) ? T('ext.ralatSambungan', 'SESAAT tidak dapat connect dengan extension. Tekan "Reload" di manage extension, kemudian cuba lagi.')
          : (res?.error || T('prostudio.cfg.tahapFail', 'Pilihan Thinking tidak dapat dibaca. Sila cuba lagi.')));
        return;
      }
      const d = res.data || {};
      const pilihan = Array.isArray(d.pilihan) ? d.pilihan.map(String).map(s => s.trim()).filter(Boolean).slice(0, 8) : [];
      if (!pilihan.length) {
        /* (2026-09-27) Akaun yang memang TIADA kawalan Thinking (dilapor pelanggan pakej Go):
           dahulu Configure terkunci selamanya. Kini dibenarkan — robot ikut tetapan ChatGPT
           (chatgptExtended 'kekal' = jangan sentuh). Jawapan tanpa `jenis` = skrip lama/ralat. */
        if (d.jenis === 'tiada') {
          patchAgent({
            chatgptTahapPilihan: [], chatgptTahap: '', chatgptTahapTiada: true, chatgptExtended: 'kekal',
            chatgptAkaun: String(d.akaun || '').trim().slice(0, 20), configured: false,
          });
          return;
        }
        setModelError(T('prostudio.cfg.tahapNone', 'Tiada pilihan Thinking dijumpai pada ChatGPT itu. Pastikan anda sudah log masuk ke ChatGPT.'));
        return;
      }
      const masihAda = pilihan.some(p => p.toLowerCase() === String(agent.chatgptTahap || '').toLowerCase());
      patchAgent({
        chatgptTahapPilihan: pilihan,
        chatgptTahapTiada: false,
        chatgptAkaun: String(d.akaun || '').trim().slice(0, 20),
        ...(masihAda ? {} : { chatgptTahap: '', configured: false }),
      });
    } catch (e) {
      setModelError(e?.message || String(e));
    } finally {
      setBacaModel(false);
    }
  };

  // Satu butang Simpan untuk SEMUA langkah. Status READY hanya diberi bila
  // ada padanan sebenar — simpan borang kosong = draf, kekal NOT CONFIGURED.
  const saveAgent = async () => {
    if (!agent || !uid || saving) return;
    const hasMatch = [...agent.sceneFields, ...agent.setFields].some(f => !!f.source || (typeof f.template === 'string' && f.template.trim()));
    const stamped = hasMatch
      ? {
        ...agent, configured: true,
        /* Teks Melayu KEKAL ditulis — ia yang dipapar pada rupa lama, dan
           pada agent yang dibuka oleh versi kod terdahulu. */
        /* (2026-09-27) Tarikh = larian Configure TERAKHIR, bukan yang pertama —
           dahulu `configuredAt || sekarang` membeku tarikh Configure pertama selamanya. */
        configuredAt: new Date(agent.runAtTs || agent.configuredAtTs || Date.now())
          .toLocaleDateString('ms-MY', { day: 'numeric', month: 'long', year: 'numeric' }),
        configuredAtTs: agent.runAtTs || agent.configuredAtTs || Date.now(),
      }
      : agent;

    setSaving(true);
    try {
      await setDoc(doc(db, 'users', uid, AGENT_COL, agent.id), toDoc(stamped), { merge: true });
      setAgents(prev => prev.map(a => (a.id === selectedId ? stamped : a)));
      setDirtyIds(prev => { const n = { ...prev }; delete n[selectedId]; return n; });
      setSavedFlash(true);
      setTimeout(() => setSavedFlash(false), 1600);
    } catch (e) {
      console.error('[ProStudioAgent] simpan gagal:', e);
      alert(T('prostudio.agentsec.errSave', 'Gagal menyimpan agent: ') + (e.message || e));
    } finally {
      setSaving(false);
    }
  };

  // Field enjin yang aktif (video diabaikan bila mod Gambar sahaja)
  const activeSceneFields = agent
    ? agent.sceneFields.filter(f => !(f.role === 'video' && !wantsVideo))
    : [];
  /* ⛔ SEMUA semakan padanan mesti guna senarai GABUNGAN (dikesan AI + buatan
     pelanggan). Membaca `agent.sources` terus akan melaporkan "tiada sumber"
     pada medan yang sebenarnya berpadan dengan blok buatan sendiri. */
  const sumberSemua = semuaSumber(agent);
  const engineMissing = activeSceneFields.filter(f => f.role !== 'text' && !fieldIsMapped(f, sumberSemua));
  /* ══════════════════════════════════════════════════════════════════
     SATU BARIS BAGI SETIAP (MEDAN × BABAK) — 2026-08-26
     ══════════════════════════════════════════════════════════════════
     Skrin dahulu memapar SATU baris bagi setiap medan walaupun agent dijalankan
     2 babak. Akibatnya pelanggan langsung tiada tempat untuk memberitahu SESAAT
     bahawa babak 2 mengambil TAJUK JAWAPAN YANG BERLAINAN — bentuk paling biasa
     ialah "VIDEO DESCRIPTION (SCENE 1)" dan "(SCENE 2)", satu tajuk bagi setiap
     babak (aduan user 2026-08-26).

     ⛔ Hanya medan yang benar-benar berubah ikut babak yang dipecahkan (video +
        video script). Gambar, hook dan caption kekal SATU baris kerana kad
        produk memang hanya menyimpan satu bagi setiap set — lihat medanPerBabak()
        dalam agentRecipe. Memecahkan gambar akan memberi pelanggan kawalan yang
        tidak mengubah apa-apa. */
  const barisBagiMedan = (f, kump) => {
    const per = medanPerBabak(f, agent?.sceneCount || 1);
    const bilBabak = per ? Math.max(1, agent?.sceneCount || 1) : 1;
    return Array.from({ length: bilBabak }, (_, i) => {
      const babak = i + 1;
      return {
        ...f,
        /* id UNIK bagi setiap baris (kunci React + kunci peta padanan).
           `_fid` membawa id medan SEBENAR untuk tulis balik. */
        id: per ? `${f.id}__b${babak}` : f.id,
        template: templatMedan(f, babak),
        _fid: f.id, _kump: kump, _babak: babak, _perBabak: per,
        namaPapar: fieldLabel(f, T) + (per
          ? ' · ' + T('prostudio.cfg.babakKe', `Babak ${babak}`, { n: babak })
          : ''),
        kunci: targetKey(f, babak, per ? (agent?.sceneCount || 1) : 1),
      };
    });
  };
  const barisMedanSemua = agent
    ? [
      ...activeSceneFields.flatMap(f => barisBagiMedan(f, 'sceneFields')),
      ...(agent.setFields || []).flatMap(f => barisBagiMedan(f, 'setFields')),
    ]
      /* Medan tak dikenali → 99 (hujung senarai); `asal` mengekalkan turutan
         asalnya supaya babak 1 dan babak 2 medan yang sama kekal bersebelahan. */
      .map((e, i) => {
        const idx = KAD_MEDAN.findIndex(m => m.kunci === kadKunci(e));
        return { ...e, urut: idx < 0 ? 99 : idx, asal: i };
      })
      .sort((a, b) => (a.urut - b.urut) || (a.asal - b.asal))
    : [];

  /* Tulis susunan blok bagi SATU baris.
     Baris per-babak menulis ke `field.scenes[babak-1]`; baris biasa menulis ke
     `field.template` seperti dahulu. Babak 1 menulis KEDUA-DUANYA supaya babak
     yang belum dipilih terus mewarisinya (dan agent lama kekal serasi). */
  const tulisPadanan = (barisId, tpl) => {
    const b = barisMedanSemua.find(x => x.id === barisId);
    if (!b) return;
    if (!b._perBabak) { setField(b._kump, b._fid, { template: tpl }); return; }
    const n = Math.max(1, agent?.sceneCount || 1);
    const f = (agent[b._kump] || []).find(x => x.id === b._fid) || {};
    const asal = Array.isArray(f.scenes) ? f.scenes : [];
    const scenes = Array.from({ length: n }, (_, i) => (typeof asal[i] === 'string' ? asal[i] : null));
    scenes[b._babak - 1] = tpl;
    setField(b._kump, b._fid, b._babak === 1 ? { template: tpl, scenes } : { scenes });
  };

  // Teks pusingan yang sedang dipilih (untuk paparan 'Lihat jawapan penuh')
  /* bersihJawapan: jawapan JSON tak sah simpan `\n` sebagai teks literal — tukar
     kepada baris SEBENAR supaya kotak jawapan senang dibaca/diserlah DAN nilai
     pratonton keluar bersih. Serlahan + kiraan blok pakai shownRaw yang SAMA,
     jadi kedudukan sentiasa sepadan dengan apa yang dipapar. */
  const shownRaw = bersihJawapan(rawTurns[Math.min(agent?.outputTurn || 0, Math.max(0, rawTurns.length - 1))] || '');
  const showMatch = runState === 'done' || (agent?.configured && runState === 'idle');
  // ── Kad pratonton — rupa kad workspace + teks SEBENAR dari output Gem masa
  //    Configure, dicantum ikut composer. Consts biasa (bukan hook) → dikira
  //    semula setiap render, jadi ia update serta-merta bila composer diedit.
  const previewRecipe = (showMatch && shownRaw && agent) ? applyRecipe(shownRaw, agent) : null;
  /* Bilangan set yang enjin BENAR-BENAR isi — formula SAMA seperti enjin.
     ⛔ Dahulu ia dipaksa 1 untuk agent berbilang babak. Itu menyorokkan set 2
        dan set 3 daripada pratonton — iaitu tepat set yang paling kerap tersasar
        (aduan user 2026-08-26). Pratonton nampak elok sedangkan dua set lagi
        rosak, dan tiada apa pun pada skrin yang memberitahu. */
  const previewSetCount = agent ? kiraSetBabak(agent).setCount : 1;
  const curPreviewSet = Math.min(Math.max(1, previewSet), previewSetCount);
  const previewProduct = products.find(p => p.id === testProductId) || null;
  const previewRows = previewRecipe
    ? barisMedanSemua.map(b => ({
        id: b.id, label: b.namaPapar, role: b.role,
        value: (previewRecipe.prompts[`set${curPreviewSet}`] || {})[b.kunci] || '',
      }))
    : [];
  /* Tarikh Configure mengikut bahasa yang dipilih. Agent lama (tiada cap
     masa) kekal memapar teks Melayu yang tersimpan — itu lebih baik
     daripada memaparkan tarikh kosong. */
  const tarikhConfigure = agent?.configuredAtTs
    ? new Date(agent.configuredAtTs).toLocaleDateString(lang === 'en' ? 'en-GB' : 'ms-MY',
      { day: 'numeric', month: 'long', year: 'numeric' })
    : agent?.configuredAt;
  /* Bar status v3.9 (2026-09-27): tarikh + JAM supaya pelanggan boleh padankan dengan
     perbualan ChatGPT/Gemini. `larianBaharu` = Configure dijalankan selepas simpanan
     terakhir (jawapan di skrin ialah yang baharu, belum/sudah disimpan). */
  const masaBar = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    const lokal = lang === 'en' ? 'en-GB' : 'ms-MY';
    const jam = d.toLocaleTimeString(lokal, { hour: 'numeric', minute: '2-digit' });
    return d.toDateString() === new Date().toDateString()
      ? T('prostudio.cfg.hariIni', `Hari ini, ${jam}`, { jam })
      : `${d.toLocaleDateString(lokal, { day: 'numeric', month: 'long', year: 'numeric' })}, ${jam}`;
  };
  const larianBaharu = !!agent?.runAtTs && agent.runAtTs !== agent.configuredAtTs;
  const tarikhBar = larianBaharu ? masaBar(agent.runAtTs) : (agent?.configuredAtTs ? masaBar(agent.configuredAtTs) : (tarikhConfigure || ''));

  /* ══════════════════════════════════════════════════════════
     LANGKAH 4 — DATA UNTUK RUPA v3.9  (arahan user 2026-08-20)
     ══════════════════════════════════════════════════════════
     Reka bentuk baharu dibina dahulu sebagai lakaran di
     /prostudio-v3.9/agent, kemudian dipindahkan ke sini. Komponen
     ProStudioKonfigurV39 ialah RUPA sahaja — semua logik (Firestore,
     jambatan extension, applyRecipe) kekal di fail ini, dan blok di
     bawah hanya menyusun semula data sedia ada ke dalam bentuk prop.

     ⛔ RUPA LAMA (v39 = false) TIDAK DISENTUH. Ia laluan pelanggan
     sebenar hari ini; markup asalnya kekal huruf demi huruf di bawah,
     dipagar `!v39`. Blok ini dilangkau sepenuhnya bila v39 mati. */
  /* Kod blok (@...) daripada petaSlug — DIJAMIN unik, formula yang SAMA seperti
     enjin larian. ⛔ Jangan hantar `agent.sources` mentah — lihat nota pada prop
     `sumber`; dan jangan kira slug sendiri di sini, kerana dua blok yang serupa
     akan menghasilkan kod yang sama dan cip palet berhenti menuding ke blok yang
     betul. */
  const { kodBagiSumber: kodBlok, sumberBagiKod: sumberBagiKodV39 } = petaSlug(sumberSemua);
  /* kod → teks blok, untuk tooltip cip palet: bila dua blok serupa, kod kedua
     dinomborkan (@hook2) dan nombor itu sendiri tidak memberitahu apa-apa. */
  const labelBlokV39 = Object.fromEntries(Object.entries(kodBlok).map(([teks, kod]) => [kod, teks]));
  /* Blok sintetik @copy_box (2026-09-27) hanya dipapar bila jawapan di skrin
     MEMANG ada kotak copy — cip yang sentiasa kosong hanya mengelirukan. */
  const adaKotakCopy = cariKotakKod(shownRaw).length > 0;
  const sumberSlugV39 = Object.entries(kodBlok)
    .filter(([teks]) => teks !== SUMBER_KOTAK || adaKotakCopy)
    .map(([, kod]) => kod);

  /* Kiraan sebenar setiap blok + berapa kali ia SEPATUTNYA muncul. Kedua-duanya
     datang daripada enjin — kiraan yang dikira semula oleh skrin akan terpesong
     daripada apa yang larian sebenar buat. */
  const jangkaV39 = agent ? jangkaanSumber(agent) : {};
  const nilaiBlokV39 = (shownRaw && agent)
    ? (() => { try { return kumpulNilai(shownRaw, agent); } catch { return {}; } })()
    : {};

  /* Amaran per baris. Ia menjawab satu soalan yang skrin dahulu SENYAP
     mengenainya: "blok ini muncul cukup kali untuk mengisi semua set?"
     Contoh sebenar: blok muncul 3 kali sedangkan agent perlu 6 → set 2 dan 3
     menerima teks milik set lain, dan tiada sesiapa perasan sehingga video
     keluar kosong dua minggu kemudian. */
  const notaBaris = (b) => {
    if (!shownRaw) return null;
    const kod = [...String(deriveTemplate(b, kodBlok)).matchAll(/@([a-zA-Z0-9_]+)/g)]
      .map(m => m[1].toLowerCase());
    const sumberBaris = [...new Set(kod.map(k => sumberBagiKodV39[k]).filter(Boolean))];
    if (!sumberBaris.length) return null;
    for (const s of sumberBaris) {
      const n = (nilaiBlokV39[s] || []).length;
      if (n === 0) return { jenis: 'kosong', blok: s };
      const exp = jangkaV39[s];
      if (Array.isArray(exp) && exp.length && !exp.includes(n)) {
        return { jenis: 'takcukup', blok: s, kira: n, perlu: exp[exp.length - 1] };
      }
    }
    return null;
  };

  const kumpulanV39 = barisMedanSemua.length
    ? [{
      id: 'semua',
      tajuk: '',   // satu senarai rata — tiada tajuk kumpulan
      medan: barisMedanSemua.map(b => ({
        id: b.id, nama: b.namaPapar, ikon: kadMeta(b)?.ikon || 'teks', nota: notaBaris(b),
      })),
    }]
    : [];
  const padananV39 = Object.fromEntries(barisMedanSemua.map(b => [b.id, deriveTemplate(b, kodBlok)]));

  /* Pratonton: satu lajur setiap set, sama seperti kad produk. Nilai
     datang daripada resipi yang SAMA (`previewRecipe`) yang menyuap kad
     pratonton rupa lama — bukan salinan kedua enjin itu. */
  const pratontonV39 = (v39 && previewRecipe && agent)
    ? Array.from({ length: previewSetCount }, (_, i) => ({
      id: `set${i + 1}`,
      tajuk: T('prostudio.cfg.previewSet', `Set ${i + 1}`, { n: i + 1 }),
      baris: barisMedanSemua.map(b => ({
        id: b.id,
        label: b.namaPapar,
        warna: kadMeta(b)?.warna || 'var(--s-ink-3)',
        panjang: b.role !== 'text',
        nilai: (previewRecipe.prompts[`set${i + 1}`] || {})[b.kunci] || '',
      })),
    }))
    : [];

  /* Label pusingan — ayat SAMA seperti rupa lama, cuma dicantum di sini
     supaya komponen rupa hanya menerima senarai siap. */
  const pusinganV39 = rawTurns.map((turn, i) => ({
    nilai: i,
    label: (i === 0
      ? T('prostudio.agentsec.turnFirst', 'Jawapan pertama')
      : T('prostudio.agentsec.turnAfter', `Selepas Balasan ${i}`, { n: i }))
      + (turn.trim().length < 40
        ? T('prostudio.agentsec.turnEmpty', ' — kosong')
        : T('prostudio.agentsec.turnChars', ` — ${turn.trim().length.toLocaleString()} aksara`,
          { n: turn.trim().length.toLocaleString() })),
  }));

  const modelSenaraiV39 = Array.from(new Set([
    ...(Array.isArray(agent?.geminiModels) ? agent.geminiModels : []),
    ...(agent?.geminiModel ? [agent.geminiModel] : []),
  ]));
  /* Nota bawah pemilih. Rupa v3.9 ada butang "baca senarai model" sendiri, jadi
     ayat lamanya ("jalankan Configure dahulu") tidak lagi betul di sini — ia
     menghantar pelanggan membuat larian penuh untuk sesuatu yang kini satu
     tekanan butang. Rupa LAMA kekal dengan ayat asalnya. */
  const modelNotaV39 = (Array.isArray(agent?.geminiModels) && agent.geminiModels.length)
    ? T('prostudio.agentsec.geminiModelHint', 'Menukar model memadam status Configured — jalankan Configure semula selepas menukar.')
    : T('prostudio.cfg.modelEmpty', 'Tekan butang di bawah — SESAAT akan membuka Gem anda, menyalin senarai model akaun, dan menutupnya semula.');


  /* ══════════════════════════════════════════════════════════
     BLOK BUATAN PELANGGAN
     ══════════════════════════════════════════════════════════
     Satu "blok" hanyalah sepotong teks TAJUK. Semasa larian, enjin mencari
     setiap kemunculan tajuk itu dan mengambil ayat selepasnya sehingga tajuk
     berikutnya. Jadi membenarkan pelanggan mencipta blok = membenarkan dia
     menaip/menyerlah tajuknya sendiri. Tiada perubahan enjin diperlukan.

     ⚠️ PERANGKAP YANG MESTI DITUNJUKKAN: pelanggan mesti memilih LABEL
     ("HOOK:"), bukan JAWAPAN ("Konon Nak Rasa Sikit"). Label muncul pada
     setiap set dan pada setiap produk akan datang; jawapan hanya muncul
     sekali, pada produk itu sahaja. Sebab itu setiap blok memapar kiraan
     padanan + nilai pertama — pilihan yang salah membaca "Jumpa 1 kali"
     serta-merta, bukan dua minggu kemudian bila video keluar kosong. */
  const blokSendiriV39 = (agent?.customSources || []).map((teks) => {
    /* Dikira dengan enjin YANG SAMA seperti larian sebenar, dan dengan SEMUA
       tajuk lain disertakan — kalau tidak, nilai akan memanjang sampai
       kemunculan seterusnya tajuk itu sendiri, bukan sampai tajuk berikutnya. */
    /* Tanpa jawapan mentah pada skrin (agent dibuka semula, larian tidak
       disimpan), padanan TIDAK BOLEH disemak. null bermakna "tidak diketahui"
       — berbeza daripada 0 yang bermakna "benar-benar tiada jumpa". Melaporkan
       0 di sini akan menuduh blok yang mungkin betul.  */
    let kira = shownRaw ? 0 : null; let nilai = '';
    try {
      if (!shownRaw) throw new Error('tiada jawapan');
      // Arg ke-3 = blok pelanggan MENANG bila bertindih dengan tajuk auto.
      /* Enjin YANG SAMA seperti larian (JSON atau teks dipilih di dalamnya).
         Dahulu ia memanggil collectFromText terus, jadi agent yang membalas JSON
         sentiasa memapar "0 kali" pada setiap blok walaupun padanan berjaya. */
      const semua = kumpulNilai(shownRaw, agent);
      const senarai = semua[teks] || [];
      kira = senarai.length;
      nilai = senarai[0] || '';
    } catch { /* jawapan mentah tiada — biarkan kosong */ }
    return { teks, slug: kodBlok[teks] || slugifySource(teks), kira, nilai: nilai.slice(0, 160) };
  });

  /* Pulangkan SEBAB bila ia gagal, bukan senyap. Versi pertama hanya `return`
     kosong — pelanggan menyerlah teks, menekan butang, dan tiada apa berlaku
     sama sekali (aduan user 2026-08-20). Butang yang menolak tanpa memberitahu
     sebabnya dibaca sebagai butang rosak. */
  const tambahBlok = (teksMentah) => {
    const teks = String(teksMentah || '').replace(/\s+/g, ' ').trim();
    if (!teks) return 'kosong';
    if (teks.length < 2) return 'pendek';
    /* Tajuk yang terlalu panjang hampir pasti keseluruhan baris termasuk
       jawapannya — ia takkan berpadan pada produk seterusnya. */
    if (teks.length > 120) return 'panjang';
    const sendiri = agent.customSources || [];
    const auto = agent.sources || [];
    /* ⚠️ Semakan pendua PEKA HURUF BESAR/KECIL — sama seperti cara enjin
       memadankan blok buatan pelanggan. "HOOK:" (tajuk set) dan "Hook:"
       (baris dialog) ialah DUA benda berlainan dalam jawapan yang sama, dan
       pelanggan memang perlu kedua-duanya. Menyamakannya di sini akan menolak
       blok kedua atas sebab yang tidak wujud. */
    if (sendiri.includes(teks)) return 'sudah';
    /* ⚠️ BEZAKAN dua senarai. Versi pertama memulangkan "sudah wujud" untuk
       KEDUA-DUANYA — jadi bila blok itu sebenarnya blok yang DIKESAN AI,
       pelanggan memandang senarai "Blok anda sendiri" yang KOSONG dan
       membaca mesej itu sebagai pembohongan (aduan user 2026-08-20). */
    if (auto.includes(teks)) return 'dikesan';
    /* ⛔ TIADA lagi penolakan "kod bertembung". Versi pertama menolak "HOOK"
       apabila "HOOK:" sudah wujud kerana kedua-duanya menjadi @hook — tetapi
       user menunjukkan (2026-08-20) bahawa label yang hampir serupa MEMANG
       merujuk bahagian berlainan dalam jawapan. Penyelesaiannya bukan menolak
       blok itu, tetapi memberi setiap blok kod yang UNIK — lihat petaSlug()
       dalam agentRecipe. */
    patchAgent({ customSources: [...sendiri, teks].slice(0, 20) });
    return 'ok';
  };
  const buangBlok = (teks) => patchAgent({
    customSources: (agent.customSources || []).filter(x => x !== teks),
  });

  /* Pelanggan menekan "Configure semula" pada jalur hijau: kembali ke skrin
     persediaan supaya produk ujian, cip Extended (ChatGPT) dan model (Gemini)
     boleh dilihat dan ditukar SEBELUM larian bermula. Ia keadaan paparan
     semata-mata — tiada apa disimpan, dan larian yang bermula membatalkannya. */
  /* Kedudukan setiap padanan blok BUATAN SENDIRI dalam jawapan — untuk
     diserlahkan pada teks. Diambil daripada enjin (cariPenanda), BUKAN
     dikira semula oleh UI: serlahan yang tidak sepadan dengan penanda
     sebenar akan menunjukkan tempat yang enjin tidak guna, dan itu lebih
     mengelirukan daripada tiada serlahan langsung. */
  const penandaBlokV39 = shownRaw && (agent?.customSources || []).length
    ? cariPenanda(shownRaw, sumberSemua, agent.customSources, jangkaV39)
      .filter(m => agent.customSources.some(c => String(c).trim().toLowerCase() === String(m.heading).trim().toLowerCase()))
      .map(m => ({ pos: m.pos, len: m.len }))
    : [];

  const larianV39 = runState === 'running' ? 'jalan' : (showMatch && !ubahTetapan) ? 'siap' : 'idle';
  /* Agent ChatGPT WAJIB memilih keadaan cip Extended dahulu (arahan user
     2026-08-20). Tanpa pagar ini, "belum pilih" berkelakuan sama seperti
     "biar sahaja" — pilihan dibuat secara senyap bagi pihak pelanggan. */
  /* 2026-09-26: kini WAJIB memilih TAHAP Thinking (dibaca dari akaun). Nilai lama
     `chatgptExtended` hanya dipakai larian Workspace bagi agent yang belum dikonfigurasi
     semula — Configure baharu mesti memilih tahap. */
  const perluPilihExt = agent?.platform !== 'gemini' && !agent?.chatgptTahap && !agent?.chatgptTahapTiada;
  /* Agent Gemini WAJIB memilih model DAN tahap Thinking dahulu — kedua-duanya
     mengubah bentuk jawapan, jadi larian sebenar mesti sepadan dengan kalibrasi
     (peraturan sama seperti tahap Thinking ChatGPT). */
  const perluPilihGemini = agent?.platform === 'gemini' && (!agent?.geminiModel || !agent?.geminiExtended);
  const bolehJalanV39 = !!agent?.url?.trim() && !!testProductId && !perluPilihExt && !perluPilihGemini;

  // ══════════════════════════════════════════════════════════
  return (
    /* Palet dipasang DI SINI, pada div paling luar seksyen. Semua
       sub-komponen dalam fail ini adalah keturunannya, jadi mereka
       mewarisi pemboleh ubah ini tanpa perlu menerima sebarang prop.
       (Tiada portal dalam fail ini — kalau satu ditambah kemudian,
       ia akan terkeluar daripada skop ini dan hilang warnanya.) */
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, ...(v39 ? PALET_V39 : PALET_LAMA) }}>

      {/* Kunci disemak SEBELUM apa-apa lagi dirender — termasuk sebelum
          senarai agent dan borang. Pelanggan tanpa akses tidak sepatutnya
          nampak rangka yang dia tidak boleh guna. */}
      {!aksesSmart ? <AgentTerkunci onNaikTaraf={onNaikTaraf} v39={v39} /> : <>

      {/* ── Penerangan seksyen — DISOROK masa edit agent (arahan user 2026-08-20):
          ini penerangan landing "Agent Saya", jadi ia hanya muncul di skrin senarai
          agent, bukan bila pelanggan dah masuk stepper edit satu agent. ── */}
      {!paparEditor && (
      <div style={{ ...card(v39), display: 'flex', gap: 10, alignItems: 'flex-start', padding: '12px 14px' }}>
        <span className="material-symbols-outlined" style={{ fontSize: 20, color: 'var(--ps-accent-ink)', marginTop: 1 }}>smart_toy</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12.5, fontWeight: 800, color: 'var(--ps-ink)', marginBottom: 3 }}>
            {T('prostudio.agentsec.introTitle', 'Sambungkan custom GPT anda sendiri')}
          </div>
          <div style={{ fontSize: v39 ? 13 : 11, color: 'var(--ps-ink-2)', lineHeight: 1.6 }}>
            {T('prostudio.agentsec.introBody', 'Jika anda memiliki custom GPT yang dibeli daripada penjual lain, sambungkannya di sini. Tetapkan hasil yang anda mahu, dan SESAAT akan menghantar produk anda kepada GPT tersebut secara berkelompok, mengambil jawapannya, dan menjalankan automation Flow mengikut tetapan anda.')}
            <b style={{ color: 'var(--ps-ink-strong)' }}> {T('prostudio.agentsec.introStrong', 'Configure sekali sahaja bagi setiap agent.')}</b>
          </div>
        </div>
      </div>
      )}

      <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' }}>

        {/* ═══ Senarai agent ═══
            Rangka stepper: senarai ialah SKRIN SENDIRI. Bila satu agent
            dibuka, senarai disorok supaya langkah dapat lebar penuh —
            pelanggan kembali melalui pautan "Agent anda" di atas. */}
        <div style={{
          ...card(v39), flex: paparEditor ? '0 0 240px' : '1 1 100%',
          display: paparEditor ? 'none' : 'flex', flexDirection: 'column', gap: 8,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: v39 ? 12.5 : 10, fontWeight: 800, color: 'var(--ps-ink-2)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{T('prostudio.wizard.listTitle', 'Agent Anda')}</span>
            {/* Bilangan sahaja — tiada lagi "N/5". Lihat nota had di atas. */}
            <span style={{
              fontSize: v39 ? 11 : 9, fontWeight: 800, padding: '2px 6px', borderRadius: 4,
              color: 'var(--ps-accent-ink)',
              background: 'var(--ps-accent-soft)',
              border: '1px solid var(--ps-accent-soft-2)',
            }}>{agents.length}</span>
          </div>

          {loading && (
            <div style={{ fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-ink-3)', textAlign: 'center', padding: '14px 0', fontWeight: 600 }}>
              {T('prostudio.agentsec.listLoading', 'Memuatkan senarai agent...')}
            </div>
          )}
          {!loading && loadError && (
            <div style={{
              fontSize: v39 ? 12.5 : 10, color: 'var(--ps-warn-ink)', background: 'var(--ps-warn-soft)', border: '1px solid var(--ps-warn-line)',
              borderRadius: 8, padding: '8px 10px', lineHeight: 1.5,
            }}>{loadError}</div>
          )}
          {!loading && !loadError && agents.length === 0 && (
            <div style={{ fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-ink-3)', textAlign: 'center', padding: '14px 6px', lineHeight: 1.6 }}>
              {T('prostudio.agentsec.listEmpty', 'Belum ada agent.')}<br />
              {sisip(
                T('prostudio.agentsec.listEmptyCta', 'Klik {b} untuk bermula.'),
                <b style={{ color: 'var(--ps-accent-ink)' }}>{T('prostudio.agentsec.newAgent', 'Agent Baru')}</b>,
              )}
            </div>
          )}

          {agents.map((a, i) => {
            const active = selectedId === a.id;
            /* Satu agent tidak boleh disusun — pemegang dan anak panah mati
               pada senarai satu baris hanyalah kawalan yang tidak berfungsi. */
            const bolehSusun = agents.length > 1;
            const ditarik = tarikId === a.id;
            const tandaJatuh = !!tarikId && tarikId !== a.id && sasar?.id === a.id;
            return (
              <div
                key={a.id}
                onClick={() => selectAgent(a.id)}
                draggable={bolehSusun && adaTetikus}
                onDragStart={(e) => {
                  setTarikId(a.id);
                  e.dataTransfer.effectAllowed = 'move';
                  // Sebahagian browser membatalkan tarikan yang tiada data.
                  try { e.dataTransfer.setData('text/plain', a.id); } catch { /* abaikan */ }
                }}
                onDragEnd={() => { setTarikId(null); setSasar(null); }}
                onDragOver={(e) => {
                  if (!tarikId || tarikId === a.id) return;
                  // preventDefault WAJIB — tanpanya onDrop tidak pernah dipanggil.
                  e.preventDefault();
                  e.dataTransfer.dropEffect = 'move';
                  const r = e.currentTarget.getBoundingClientRect();
                  const bawah = e.clientY > r.top + r.height / 2;
                  setSasar(prev => (prev?.id === a.id && prev.bawah === bawah ? prev : { id: a.id, bawah }));
                }}
                onDrop={(e) => {
                  if (!tarikId || tarikId === a.id) return;
                  e.preventDefault();
                  const r = e.currentTarget.getBoundingClientRect();
                  lepasAgent(a.id, e.clientY > r.top + r.height / 2);
                }}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: 7, padding: '9px 9px',
                  borderRadius: 9, cursor: 'pointer',
                  background: active ? 'var(--ps-accent-soft-3)' : 'var(--ps-fill)',
                  border: `1.5px solid ${active ? 'var(--ps-accent)' : 'var(--ps-line-soft)'}`,
                  transition: 'all 0.15s',
                  opacity: ditarik ? 0.45 : 1,
                  /* Garis pendaratan sebagai bayang DALAM: border akan menambah
                     tinggi baris, jadi seluruh senarai teranjak semasa tarikan. */
                  boxShadow: tandaJatuh ? `inset 0 ${sasar.bawah ? -2 : 2}px 0 var(--ps-accent)` : undefined,
                }}
              >
                {bolehSusun && adaTetikus && (
                  <span
                    className="material-symbols-outlined"
                    title={T('prostudio.wizard.dragHandle', 'Tarik untuk susun')}
                    onClick={(e) => e.stopPropagation()}
                    style={{ fontSize: 16, color: 'var(--ps-ink-4)', marginTop: 1, cursor: 'grab', flex: '0 0 auto' }}
                  >drag_indicator</span>
                )}
                <span className="material-symbols-outlined" style={{ fontSize: 16, color: 'var(--ps-gpt-ink)', marginTop: 1 }}>smart_toy</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    fontSize: v39 ? 13 : 11, fontWeight: 700, color: active ? 'var(--ps-accent-deep)' : 'var(--ps-ink-strong)',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: 3,
                  }}>{a.name}</div>
                  <div style={{ fontSize: v39 ? 11 : 8.5, color: 'var(--ps-ink-3)', fontWeight: 700, marginBottom: 4 }}>
                    {T('prostudio.agentsec.rowMeta', `${a.setCount} set · ${a.sceneCount} babak · ${a.output === 'image' ? 'gambar' : 'gambar + video'}`, {
                      set: a.setCount,
                      babak: a.sceneCount,
                      hasil: a.output === 'image'
                        ? T('prostudio.agentsec.hasilImage', 'gambar')
                        : T('prostudio.agentsec.hasilImageVideo', 'gambar + video'),
                    })}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: 3,
                      fontSize: v39 ? 11 : 8, fontWeight: 900, letterSpacing: '0.05em',
                      padding: '2px 6px', borderRadius: 999,
                      color: a.configured ? 'var(--ps-ok-deep)' : 'var(--ps-warn-ink)',
                      background: a.configured ? 'var(--ps-ok-soft)' : 'var(--ps-warn-soft)',
                      border: `1px solid ${a.configured ? 'var(--ps-ok-line)' : 'var(--ps-warn-line)'}`,
                    }}>
                      <span className="material-symbols-outlined" style={{ fontSize: 10 }}>
                        {a.configured ? 'check_circle' : 'error'}
                      </span>
                      {a.configured ? 'READY' : 'NOT CONFIGURED'}
                    </span>
                    {/* Label platform — ChatGPT / Gemini. Nama jenama, TIDAK
                        diterjemah (kekal sama EN/BM). */}
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: 3,
                      fontSize: v39 ? 11 : 8, fontWeight: 800, letterSpacing: '0.03em',
                      padding: '2px 7px', borderRadius: 999,
                      color: 'var(--ps-ink-2)', background: 'var(--ps-fill)', border: '1px solid var(--ps-line)',
                    }}>
                      <span className="material-symbols-outlined" style={{ fontSize: 11 }}>
                        {a.platform === 'gemini' ? 'auto_awesome' : 'chat'}
                      </span>
                      {a.platform === 'gemini' ? 'Gemini' : 'ChatGPT'}
                    </span>
                    {dirtyIds[a.id] && (
                      <span
                        title={T('prostudio.agentsec.unsavedDot', 'Ada perubahan yang belum disimpan')}
                        style={{ width: 6, height: 6, borderRadius: 999, background: 'var(--ps-warn)', flex: '0 0 auto' }}
                      ></span>
                    )}
                  </div>
                </div>
                {/* Anak panah HANYA pada peranti sentuh (arahan user
                    2026-08-19) — pada komputer tarik-lepas sudah cukup. Pada
                    telefon ia satu-satunya laluan susun, jadi jangan gugurkan. */}
                {bolehSusun && !adaTetikus && (
                  <div style={{ display: 'flex', flexDirection: 'column', flex: '0 0 auto' }}>
                    <button
                      type="button"
                      disabled={i === 0}
                      onClick={(e) => { e.stopPropagation(); naikTurunAgent(i, i - 1); }}
                      title={T('prostudio.wizard.moveUp', 'Naik')}
                      style={{
                        background: 'none', border: 'none', padding: '3px 5px', display: 'flex', borderRadius: 6,
                        color: 'var(--ps-ink-4)', cursor: i === 0 ? 'default' : 'pointer',
                        opacity: i === 0 ? 0.35 : 1,
                      }}
                    >
                      <span className="material-symbols-outlined" style={{ fontSize: 18 }}>keyboard_arrow_up</span>
                    </button>
                    <button
                      type="button"
                      disabled={i === agents.length - 1}
                      onClick={(e) => { e.stopPropagation(); naikTurunAgent(i, i + 1); }}
                      title={T('prostudio.wizard.moveDown', 'Turun')}
                      style={{
                        background: 'none', border: 'none', padding: '3px 5px', display: 'flex', borderRadius: 6,
                        color: 'var(--ps-ink-4)', cursor: i === agents.length - 1 ? 'default' : 'pointer',
                        opacity: i === agents.length - 1 ? 0.35 : 1,
                      }}
                    >
                      <span className="material-symbols-outlined" style={{ fontSize: 18 }}>keyboard_arrow_down</span>
                    </button>
                  </div>
                )}
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); deleteAgent(a.id); }}
                  title={T('prostudio.wizard.deleteAgent', 'Padam agent')}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, color: 'var(--ps-ink-4)', display: 'flex' }}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: 14 }}>delete</span>
                </button>
              </div>
            );
          })}

          <button
            type="button"
            onClick={newAgent}
            style={{
              padding: '8px 10px', borderRadius: 9, fontSize: v39 ? 13 : 11, fontWeight: 800,
              cursor: 'pointer', background: 'var(--ps-card)',
              border: '1px dashed var(--ps-accent-line)',
              color: 'var(--ps-accent-ink)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
            }}
          >
            <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
            {T('prostudio.agentsec.newAgent', 'Agent Baru')}
          </button>

          <div style={{ fontSize: v39 ? 11 : 9, color: 'var(--ps-ink-3)', lineHeight: 1.5, paddingTop: 6, borderTop: '1px solid var(--ps-line-soft)' }}>
            {sisip(
              T('prostudio.agentsec.railNote', 'Agent berstatus {b} tidak boleh dijalankan di Workspace — sila lengkapkan Langkah 5 terlebih dahulu.'),
              /* ⛔ "NOT CONFIGURED" kekal English — ia lencana pada kad,
                 jadi ayat ini mesti menyebut perkataan yang SAMA seperti
                 yang pelanggan nampak di sebelah. */
              <b style={{ color: 'var(--ps-warn-ink)' }}>NOT CONFIGURED</b>,
            )}
          </div>
        </div>

        {/* ═══ Editor (kanan) ═══ */}
        <div style={{ flex: '1 1 500px', minWidth: 0, display: paparEditor ? 'flex' : 'none', flexDirection: 'column', gap: 12 }}>

          {!agent && (
            <div style={{ ...card(v39), border: '1px dashed var(--ps-line)', padding: '48px 24px', textAlign: 'center' }}>
              <span className="material-symbols-outlined" style={{ fontSize: 40, color: 'var(--ps-ink-4)' }}>smart_toy</span>
              <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--ps-ink-2)', marginTop: 8 }}>{T('prostudio.agentsec.nonePickedTitle', 'Tiada agent dipilih')}</div>
              <div style={{ fontSize: v39 ? 13 : 11, color: 'var(--ps-ink-3)', marginTop: 4 }}>{T('prostudio.agentsec.nonePickedBody', 'Pilih agent di sebelah kiri, atau klik "Agent Baru".')}</div>
            </div>
          )}

          {agent && (
            <>
              {/* ── Pautan kembali ke senarai — RUPA LAMA SAHAJA ──
                  ⛔ Sengaja TIADA dalam rupa v3.9. Di sana senarai agent hidup
                     di hub PRO Studio, dan halaman ini sudah membawa pautan
                     "← PRO Studio" pada kepalanya — dua pautan ke destinasi
                     yang sama hanya menyesakkan skrin. (Arahan user 2026-08-21:
                     buang halaman senarai agent, biar senarai dalam halaman
                     PRO Studio sahaja.)

                     Kesan yang disengajakan: `lihatSenarai` tidak pernah
                     menjadi benar dalam v3.9, jadi kad senarai di sebelah kekal
                     tersorok selagi ada agent dipilih. Ia masih muncul bila
                     pelanggan LANGSUNG tiada agent — itu skrin kosong
                     ("Belum ada agent" + Agent Baru), bukan senarai.

                  ⚠️ Rupa LAMA wajib mengekalkannya: di sana setiap agent TIADA
                     alamat sendiri, jadi skrin senarai inilah satu-satunya cara
                     pelanggan bertukar agent. Buang di sana = pelanggan terkunci
                     pada satu agent. */}
              {!v39 && (
              <button
                type="button"
                onClick={() => setLihatSenarai(true)}
                style={{
                  alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 5,
                  padding: 0, background: 'none', border: 0, cursor: 'pointer',
                  fontFamily: 'inherit', fontSize: v39 ? 13 : 11.5, fontWeight: 700, color: 'var(--ps-ink-3)',
                }}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 15 }}>arrow_back</span>
                {T('prostudio.wizard.listTitle', 'Agent anda')}
              </button>
              )}

              {/* ── BAR SIMPAN (melekat semasa skrol) ── */}
              <div style={{
                position: 'sticky', top: 0, zIndex: 5,
                display: 'flex', alignItems: 'center', gap: 9, flexWrap: 'wrap',
                background: 'var(--ps-card)', border: `1px solid ${isDirty ? 'var(--ps-warn-line)' : 'var(--ps-line-2)'}`,
                borderRadius: 12, padding: '10px 12px',
                boxShadow: v39 ? 'var(--s-shadow-pop)' : '0 2px 8px rgba(15,23,42,0.06)',
              }}>
                <span className="material-symbols-outlined" style={{ fontSize: 17, color: 'var(--ps-accent-ink)' }}>smart_toy</span>
                <span style={{
                  fontSize: 12.5, fontWeight: 800, color: 'var(--ps-ink)',
                  maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                }}>{agent.name || T('prostudio.agentsec.unnamed', 'Agent tanpa nama')}</span>

                <span style={{
                  fontSize: v39 ? 11 : 8, fontWeight: 900, letterSpacing: '0.05em', padding: '2px 7px', borderRadius: 999,
                  color: agent.configured ? 'var(--ps-ok-deep)' : 'var(--ps-warn-ink)',
                  background: agent.configured ? 'var(--ps-ok-soft)' : 'var(--ps-warn-soft)',
                  border: `1px solid ${agent.configured ? 'var(--ps-ok-line)' : 'var(--ps-warn-line)'}`,
                }}>{agent.configured ? 'READY' : 'NOT CONFIGURED'}</span>

                {isDirty && (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: v39 ? 12.5 : 10, fontWeight: 700, color: 'var(--ps-warn-ink)' }}>
                    <span style={{ width: 6, height: 6, borderRadius: 999, background: 'var(--ps-warn)' }}></span>
                    {T('prostudio.agentsec.unsaved', 'Belum disimpan')}
                  </span>
                )}

                <div style={{ flex: 1, minWidth: 8 }}></div>

                {savedFlash && <span style={{ fontSize: v39 ? 12.5 : 10.5, fontWeight: 700, color: 'var(--ps-ok-deep)' }}>✓ {T('prostudio.agentsec.saved', 'Disimpan')}</span>}
                <button
                  type="button"
                  disabled={(!isDirty && !savedFlash) || saving}
                  onClick={saveAgent}
                  title={isDirty
                    ? T('prostudio.agentsec.saveTitleOn', 'Simpan semua perubahan pada agent ini')
                    : T('prostudio.agentsec.saveTitleOff', 'Tiada perubahan untuk disimpan')}
                  style={{
                    padding: '8px 18px', borderRadius: 9, fontSize: v39 ? 13 : 11.5, fontWeight: 800,
                    cursor: isDirty ? 'pointer' : savedFlash ? 'default' : 'not-allowed',
                    background: savedFlash ? 'var(--ps-ok)' : isDirty ? 'var(--ps-accent)' : 'var(--ps-fill-2)',
                    border: 'none', color: isDirty || savedFlash ? 'var(--ps-on-accent)' : 'var(--ps-ink-3)',
                    display: 'flex', alignItems: 'center', gap: 5, transition: 'background 0.2s',
                  }}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: 15 }}>{savedFlash ? 'check' : 'save'}</span>
                  {saving ? T('prostudio.agentsec.saving', 'Menyimpan...')
                    : savedFlash ? T('prostudio.agentsec.saved', 'Disimpan')
                      : T('prostudio.agentsec.save', 'Simpan')}
                </button>
              </div>

              {/* ── Bar kemajuan ──
                  Segmen langkah yang SUDAH dilalui boleh diklik untuk patah
                  balik. Ke hadapan hanya melalui butang "Seterusnya", supaya
                  pelanggan tidak melompat ke Borang Output sebelum Langkah 3
                  menentukan bentuk borang itu. */}
              <div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: v39 ? 13 : 11, fontWeight: 800, color: 'var(--ps-ink-2)' }}>
                    {T('prostudio.wizard.stepOf', `Langkah ${langkah} daripada 4`, { n: langkah })}
                  </span>
                  <span style={{ fontSize: v39 ? 13 : 11, color: 'var(--ps-ink-3)' }}>· {T(...TAJUK_LANGKAH[langkah - 1])}</span>
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  {TAJUK_LANGKAH.map(([kunci, lalai], i) => {
                    const n = i + 1;
                    const lepas = n < langkah;
                    return (
                      <button
                        key={kunci}
                        type="button"
                        title={T(kunci, lalai)}
                        onClick={() => { if (lepas) setLangkah(n); }}
                        style={{
                          flex: 1, height: 5, padding: 0, borderRadius: 3, border: 0,
                          cursor: lepas ? 'pointer' : 'default',
                          background: n <= langkah ? 'var(--ps-accent)' : 'var(--ps-fill-2)',
                          opacity: lepas ? 0.55 : 1,
                        }}
                      />
                    );
                  })}
                </div>
              </div>

              <PembungkusLangkah v39={v39} langkah={langkah} t={t} setLangkah={setLangkah}>
              {/* ══ LANGKAH 1 — AGENT ANDA ══ */}
              {langkah === 1 && (
              <div style={v39 ? { display: 'contents' } : card(false)}>
                <StepHead v39={v39} n={1} title={T('prostudio.wizard.s1.name', 'Agent Anda')} sub={T('prostudio.agentsec.s1sub', 'Maklumat asas custom GPT yang anda miliki.')} />

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginTop: 12 }}>
                  <div>
                    <label style={lbl(v39)}>{T('prostudio.wizard.agentName', 'Nama Agent')}</label>
                    <input
                      type="text" value={agent.name}
                      onChange={(e) => patchAgent({ name: e.target.value })}
                      placeholder={T('prostudio.agentsec.agentNamePh', 'cth: Storyboard GPT (Cikgu Ali)')} style={inp(v39)}
                    />
                    <div style={hint(v39)}>{T('prostudio.wizard.agentNameHint', 'Nama ini akan muncul dalam senarai pilihan di Workspace.')}</div>
                  </div>

                  <div>
                    <label style={lbl(v39)}>{T('prostudio.wizard.platform', 'Platform')}</label>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {[{ id: 'chatgpt', label: 'ChatGPT' }, { id: 'gemini', label: 'Gemini' }].map((p) => {
                        /* ⚠️ Tukar platform = kalibrasi lama TIDAK sah lagi. Jawapan ChatGPT
                           dan Gem berbeza bentuk, jadi pemetaan yang dikalibrasi pada satu
                           platform akan salah baca pada satu lagi. `configured: false`
                           direset di sini atas sebab yang sama seperti bila URL ditukar. */
                        const dipilih = (agent.platform || 'chatgpt') === p.id;
                        return (
                          <button
                            key={p.id}
                            type="button"
                            onClick={() => patchAgent({ platform: p.id, configured: false })}
                            style={{
                              flex: 1, padding: '8px 10px', borderRadius: 8, fontSize: v39 ? 13 : 11, fontWeight: 800,
                              background: dipilih ? 'var(--ps-gpt)' : 'var(--ps-card)',
                              border: '1.5px solid ' + (dipilih ? 'var(--ps-gpt)' : 'var(--ps-line)'),
                              color: dipilih ? 'var(--ps-on-accent)' : 'var(--ps-ink-3)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, cursor: 'pointer',
                            }}
                          >
                            {dipilih && <span className="material-symbols-outlined" style={{ fontSize: 14 }}>check</span>}
                            {p.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 12 }}>
                  <label style={lbl(v39)}>{agent.platform === 'gemini' ? T('prostudio.wizard.gemUrl', 'URL Gem') : T('prostudio.wizard.gptUrl', 'URL Custom GPT')}</label>
                  <input
                    type="text" value={agent.url}
                    onChange={(e) => patchAgent({ url: e.target.value, configured: false })}
                    placeholder={agent.platform === 'gemini' ? 'https://gemini.google.com/gem/xxxxxxxxxxxx' : 'https://chatgpt.com/g/g-xxxxxx-nama-gpt'}
                    style={{ ...inp(v39), fontFamily: 'monospace', fontSize: v39 ? 12.5 : 11 }}
                  />
                  <div style={hint(v39)}>
                    {agent.platform === 'gemini'
                      ? T('prostudio.wizard.gemUrlHint', 'Buka Gem tersebut di pelayar anda, kemudian salin URL dari bar alamat dan tampal di sini.')
                      : T('prostudio.wizard.gptUrlHint', 'Buka GPT tersebut di pelayar anda, kemudian salin URL dari bar alamat dan tampal di sini.')}
                  </div>
                </div>
              </div>
              )}

              {/* ══ LANGKAH 2 — PERBUALAN DENGAN AGENT ══ */}
              {langkah === 2 && (
              <div style={v39 ? { display: 'contents' } : card(false)}>
                <StepHead v39={v39}
                  n={2} title={T('prostudio.wizard.s2.name', 'Perbualan Dengan Agent')}
                  sub={T('prostudio.agentsec.s2sub', 'Apa yang SESAAT hantar kepada agent anda setiap kali ia dijalankan.')}
                />

                {/* Dua lajur: KIRI = tetapan perbualan · KANAN = contoh perbualan langsung.
                    auto-fit → lajur kanan turun ke bawah pada skrin sempit (telefon). */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginTop: 12, alignItems: 'start' }}>

                  {/* ── KIRI: tetapan ── */}
                  <div>
                    {/* ★ DATA PRODUK — nota SAHAJA, tiada kawalan.
                        ⛔ Kotak tanda per-medan DICUBA 2026-08-21 dan DIBUANG pada
                        hari yang sama: data produk tidak disimpan sebagai medan
                        berasingan pada kad, jadi kotak itu hanya boleh menapis
                        sebahagian kad dan gagal SENYAP pada yang lain — kawalan
                        yang berbohong. Bina semula HANYA selepas simpanan data
                        diasingkan ikut medan (lihat nota blokDataAgent). */}
                    <div style={{ marginBottom: 16 }}>
                      <span style={{ ...lbl(v39), marginBottom: 6 }}>{T('prostudio.agentsec.dataLabel', 'Data produk yang SESAAT hantar')}</span>
                      <div style={{ ...hint(v39), marginTop: 0 }}>
                        {T('prostudio.agentsec.dataHint', 'Semua data produk yang ada pada kad — harga, kategori, spesifikasi, ulasan pelanggan dan lain-lain — ditampal sekali dengan nama dan link. Untuk mengubah data itu, gunakan borang Edit Data Produk pada halaman Products.')}
                      </div>
                    </div>

                    <div>
                      <label style={lbl(v39)}>{T('prostudio.wizard.extraLine', 'Ayat arahan tambahan (pilihan)')}</label>
                      <textarea
                        value={agent.extraInstruction}
                        onChange={(e) => patchAgent({ extraInstruction: e.target.value })}
                        rows={3}
                        placeholder={T('prostudio.wizard.extraLinePh', 'Contoh: Gunakan gaya bahasa santai. Hasilkan 5 babak. Fokus kepada masalah kulit berminyak.')}
                        style={ta(v39)}
                      />
                      <div style={hint(v39)}>
                        {sisip(
                          T('prostudio.agentsec.extraLineHint', 'Ayat ini ditampal di hujung mesej pertama, selepas nama dan link produk. Ia digunakan untuk {b} produk yang anda jalankan dengan agent ini — tidak perlu menaipnya semula pada setiap kad produk.'),
                          <b>{T('prostudio.agentsec.extraLineHintEvery', 'setiap')}</b>,
                        )}
                      </div>
                      {/* ★ Simpan gambar daripada JAWAPAN PERTAMA (2026-09-11) — ada agent
                          yang terus mengeluarkan gambar tanpa perlu balasan. */}
                      <SuisGambar
                        v39={v39} on={!!agent.firstImage} onClick={toggleFirstImage} mati={gambarPenuh}
                        tip={gambarPenuh && !agent.firstImage ? T('prostudio.agentsec.imgFull', 'Had dicapai — matikan satu suis dahulu untuk menanda yang lain.') : ''}
                        label={T('prostudio.agentsec.imgFirstToggle', 'Simpan gambar daripada jawapan pertama')}
                      />
                    </div>

                    {/* Balasan berturutan */}
                    <div style={{ marginTop: 16 }}>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: 7, marginBottom: 6, flexWrap: 'wrap' }}>
                        <span style={{ ...lbl(v39), marginBottom: 0 }}>{T('prostudio.agentsec.repliesLabel', 'Balasan berturutan (pilihan)')}</span>
                        <span style={{ fontSize: v39 ? 12.5 : 9.5, color: 'var(--ps-ink-3)', fontWeight: 600 }}>
                          {agent.replies.length}/{MAX_REPLIES}
                        </span>
                      </div>

                      <div style={{
                        fontSize: v39 ? 12.5 : 10, color: 'var(--ps-accent-deep)', background: 'var(--ps-accent-soft)',
                        border: '1px dashed var(--ps-accent-line)', borderRadius: 9, padding: '9px 11px',
                        lineHeight: 1.6, marginBottom: 8,
                      }}>
                        {sisip(
                          T('prostudio.agentsec.repliesNote', 'Sesetengah agent {b1} sebelum menghasilkan output. Taipkan jawapan anda di sini mengikut urutan. SESAAT akan menghantarnya satu persatu dan menunggu agent selesai membalas setiap kali, kemudian mengambil {b2} sebagai output. Biarkan kosong jika agent anda terus memberikan output pada mesej pertama.'),
                          <b>{T('prostudio.agentsec.repliesNoteAsk', 'bertanya soalan dahulu')}</b>,
                          <b>{T('prostudio.agentsec.repliesNoteLast', 'jawapan terakhir')}</b>,
                        )}
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {agent.replies.map((r, i) => (
                          <div key={i} style={{
                            display: 'flex', gap: 8, alignItems: 'flex-start',
                            padding: '9px 10px', background: 'var(--ps-fill)',
                            border: '1px solid var(--ps-line-soft)', borderRadius: 9,
                          }}>
                            <span style={{
                              flex: '0 0 auto', width: 20, height: 20, borderRadius: 999, marginTop: 2,
                              background: 'var(--ps-accent-soft-2)', color: 'var(--ps-accent-deep)',
                              fontSize: v39 ? 12.5 : 10, fontWeight: 900,
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>{i + 1}</span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <textarea
                                value={r}
                                onChange={(e) => setReply(i, e.target.value)}
                                rows={2}
                                placeholder={i === 0
                                  ? T('prostudio.agentsec.replyPh1', 'Jawapan anda kepada soalan pertama agent')
                                  : T('prostudio.agentsec.replyPhN', `Jawapan anda kepada soalan ke-${i + 1}`, { n: i + 1 })}
                                style={{ ...ta(v39), background: 'var(--ps-card)' }}
                              />
                              {/* ★ Suis gambar pusingan ini = jawapan agent SELEPAS balasan ke-(i+1). */}
                              <SuisGambar
                                v39={v39} on={!!(agent.replyImages || [])[i]} onClick={() => toggleReplyImage(i)} mati={gambarPenuh}
                                tip={gambarPenuh && !(agent.replyImages || [])[i] ? T('prostudio.agentsec.imgFull', 'Had dicapai — matikan satu suis dahulu untuk menanda yang lain.') : ''}
                                label={T('prostudio.agentsec.imgReplyToggle', 'Simpan gambar daripada jawapan ini')}
                              />
                            </div>
                            <button
                              type="button" onClick={() => removeReply(i)} title={T('prostudio.agentsec.removeReply', 'Buang balasan ini')}
                              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, color: 'var(--ps-ink-4)', display: 'flex', marginTop: 2 }}
                            >
                              <span className="material-symbols-outlined" style={{ fontSize: 15 }}>close</span>
                            </button>
                          </div>
                        ))}

                        {agent.replies.length < MAX_REPLIES && (
                          <button
                            type="button" onClick={addReply}
                            style={{
                              padding: '8px 10px', borderRadius: 9, fontSize: v39 ? 13 : 11, fontWeight: 800, cursor: 'pointer',
                              background: 'var(--ps-card)', border: '1px dashed var(--ps-accent-line)', color: 'var(--ps-accent-ink)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                            }}
                          >
                            <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add_comment</span>
                            {T('prostudio.agentsec.addReply', 'Tambah Balasan')}
                          </button>
                        )}
                      </div>

                      {agent.replies.length > 0 && (
                        <div style={{ ...hint(v39), marginTop: 8 }}>
                          {T('prostudio.agentsec.repliesTimeHint', 'Setiap balasan menambah lebih kurang satu minit kepada masa larian bagi setiap produk.')}
                        </div>
                      )}

                      {/* ★ Nota gambar (2026-09-11): kiraan suis bertanda + had kad. Dipapar
                          sentiasa — pelanggan perlu tahu suis itu wujud walaupun belum ada
                          balasan; dan bila had dicapai, ayatnya yang menerangkan, bukan suis
                          yang mati senyap. */}
                      <div style={{ ...hint(v39), marginTop: 10, display: 'flex', gap: 6, alignItems: 'flex-start' }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 15, marginTop: 1, color: jumlahGambarDitanda ? 'var(--ps-accent-deep)' : 'var(--ps-ink-4)' }}>image</span>
                        <span>
                          <b>{T('prostudio.agentsec.imgCount', `${jumlahGambarDitanda}/${MAKS_GAMBAR_TAMBAHAN} gambar ditanda`, { n: jumlahGambarDitanda, max: MAKS_GAMBAR_TAMBAHAN })}</b>
                          {' — '}
                          {T('prostudio.agentsec.imgNote', 'Hidupkan suis "Simpan gambar" pada jawapan yang agent anda keluarkan gambar (contoh: product sheet atau storyboard). SESAAT tunggu gambar itu siap, muat turun, dan simpan ke kad sebagai gambar tambahan — sehingga 5 gambar setiap kad termasuk gambar utama. Larian kedua menambah, bukan mengganti.')}
                          {gambarPenuh ? ` ${T('prostudio.agentsec.imgFull', 'Had dicapai — matikan satu suis dahulu untuk menanda yang lain.')}` : ''}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* ── KANAN: contoh perbualan (pratonton langsung) ──
                      Membaca terus `agent.extraInstruction` + `agent.replies`, jadi ia
                      dikemas kini serta-merta bila pelanggan menaip. Balasan agent hanya
                      PLACEHOLDER (kita tidak tahu jawapan sebenar) — dilorekkan kelabu. */}
                  {(() => {
                    const contohProduk = products.find(p => p.id === testProductId) || products[0] || null;
                    const contohNama = (contohProduk?.name || '').trim() || T('prostudio.agentsec.previewProduct', 'Nama produk anda');
                    const contohLink = (contohProduk?.link || '').trim() || 'tiktok.com/view/product/…';
                    const namaAgent = (agent.name || '').trim() || T('prostudio.agentsec.previewAgentFallback', 'Agent anda');
                    const extra = (agent.extraInstruction || '').trim();
                    /* Dikira setiap render — jadi ia berubah serta-merta bila pelanggan
                       menanda kotak atau bertukar produk ujian. */
                    const blokData = blokDataAgent(produkDenganData(contohProduk));
                    const balasanWord = T('prostudio.agentsec.previewReplyWord', 'balasan');
                    const labelKecil = { fontSize: 10.5, color: 'var(--ps-ink-3)', marginBottom: 3 };
                    /* ⭐ `pre-wrap` — pelanggan menaip ayat arahan + setiap balasan dalam
                       textarea, jadi baris baharu yang dia tekan MEMANG sebahagian daripada
                       mesej (senarai tetapan, blok [FORMAT OUTPUT], contoh JSON). Tanpa ia
                       pratonton meleburkan semuanya menjadi satu perenggan panjang dan
                       pelanggan tidak dapat menyemak susunan mesej yang akan dihantar
                       (aduan user 2026-08-22). Blok DATA PRODUK di dalam gelembung yang sama
                       sudah lama ada pre-wrapnya sendiri — itulah sebabnya data kelihatan
                       kemas sedangkan balasan kelihatan seperti satu blok. */
                    const bubbleSesaat = { background: 'var(--ps-ink)', color: 'var(--ps-card)', fontSize: 12.5, lineHeight: 1.5, padding: '8px 10px', borderRadius: '12px 12px 3px 12px', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' };
                    /* Balasan boleh sangat panjang (blok [FORMAT OUTPUT] + contoh JSON).
                       Sekali baris baharu dikekalkan, satu balasan diukur 1,160px tinggi —
                       ia menolak seluruh panel pratonton keluar skrin. Ditutup tingginya
                       dengan skrol dalaman, corak SAMA seperti blok DATA PRODUK di dalam
                       gelembung pertama. Teks penuh kekal ada, cuma perlu diskrol. */
                    const bubbleBalasan = { ...bubbleSesaat, maxHeight: 260, overflowY: 'auto' };
                    const bubbleAgent = { background: 'var(--ps-fill)', border: '1px solid var(--ps-line)', color: 'var(--ps-ink-3)', fontSize: 12.5, lineHeight: 1.5, padding: '8px 10px', borderRadius: '12px 12px 12px 3px', fontStyle: 'italic' };
                    /* ★ Penanda "gambar disimpan" pada pusingan yang ditanda (2026-09-11).
                       Pusingan 0 = jawapan pertama (gelembung agent SEBELUM balasan 1, atau
                       gelembung akhir bila tiada balasan); pusingan k = jawapan selepas
                       balasan ke-k. Nombor pusingan di sini sama dengan yang extension kira. */
                    const gambarPusingan = (turn) => (turn === 0 ? !!agent.firstImage : !!(agent.replyImages || [])[turn - 1]);
                    const tandaGambar = (turn) => (gambarPusingan(turn) ? (
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 10.5, color: 'var(--ps-accent-deep)', marginTop: 4, lineHeight: 1.4 }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 13 }}>image</span>
                        {T('prostudio.agentsec.previewImgMark', 'SESAAT simpan gambar daripada jawapan ini ke dalam kad')}
                      </div>
                    ) : null);
                    const bubbleFinal = (
                      <div style={{ alignSelf: 'flex-start', maxWidth: '94%' }}>
                        <div style={labelKecil}>{namaAgent}</div>
                        <div style={{ ...bubbleAgent, fontStyle: 'normal', border: '1px solid var(--ps-ok-line)' }}>
                          {T('prostudio.agentsec.previewLastReply', 'Balasan terakhir agent anda')}
                        </div>
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 10.5, color: 'var(--ps-ok-deep)', marginTop: 4, lineHeight: 1.4 }}>
                          <span className="material-symbols-outlined" style={{ fontSize: 13 }}>check_circle</span>
                          {T('prostudio.agentsec.previewOutputBadge', 'SESAAT ambil balasan terakhir ini sebagai output')}
                        </div>
                        {tandaGambar(agent.replies.length)}
                      </div>
                    );
                    return (
                      <div style={{ background: 'var(--ps-card)', border: '1px solid var(--ps-line)', borderRadius: 12, padding: 12, alignSelf: 'start' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
                          <span className="material-symbols-outlined" style={{ fontSize: 16, color: 'var(--ps-ink-3)' }}>forum</span>
                          <span style={{ fontSize: v39 ? 13.5 : 12, fontWeight: 800, color: 'var(--ps-ink)' }}>
                            {T('prostudio.agentsec.previewTitle', 'Contoh perbualan')}
                          </span>
                        </div>

                        {/* ★ Pemilih produk (2026-08-21) — SAMA nilai seperti pemilih di
                            Langkah 4, bukan salinan kedua. Sebabnya: produk ini bukan
                            sekadar untuk pratonton — ia produk SEBENAR yang dihantar
                            semasa Configure. Dua nilai berasingan bermakna pelanggan
                            melihat pratonton satu produk dan mengkalibrasi atas produk
                            yang lain.
                            Ia diletak di sini kerana pratonton di bawahnya berubah ikut
                            produk: tanpa pemilih, kad yang kebetulan kosong dibaca
                            sebagai ciri yang rosak (aduan user 2026-08-21). */}
                        <div style={{ marginBottom: 12 }}>
                          <label style={{ ...lbl(v39), marginBottom: 5 }}>{T('prostudio.wizard.testProduct', 'Produk untuk ujian')}</label>
                          <PemilihProduk
                            v39={v39} T={T} produk={products} nilai={testProductId}
                            onPilih={setTestProductId} memuat={productsLoading}
                          />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                          {/* Mesej pertama: nama + link produk + ayat arahan tambahan */}
                          <div style={{ alignSelf: 'flex-end', maxWidth: '92%' }}>
                            <div style={{ ...labelKecil, textAlign: 'right' }}>SESAAT</div>
                            <div style={bubbleSesaat}>
                              <span style={{ display: 'block', fontWeight: 700 }}>{contohNama}</span>
                              <span style={{ display: 'block', fontSize: 11, textDecoration: 'underline', margin: '1px 0 4px', wordBreak: 'break-all' }}>{contohLink}</span>
                              {/* ★ Blok data — dijana oleh pembina yang SAMA seperti larian
                                  sebenar, jadi pratonton ini mustahil menunjukkan sesuatu
                                  yang berbeza daripada apa yang ditaip ke dalam agent. */}
                              {blokData
                                ? (
                                  <span style={{
                                    display: 'block', whiteSpace: 'pre-wrap', fontSize: 11.5,
                                    margin: '0 0 6px', paddingBottom: 6,
                                    borderBottom: '1px solid rgba(255,255,255,.18)', opacity: 0.92,
                                    maxHeight: 190, overflowY: 'auto',
                                  }}>{blokData}</span>
                                )
                                : (
                                  /* Produk ujian ini memang tiada data. Ayat ini menuding
                                     kepada punca sebenar — kalau tidak, pelanggan membaca
                                     pratonton yang tiada data sebagai ciri yang rosak. */
                                  <span style={{ display: 'block', opacity: 0.65, fontSize: 11.5, margin: '0 0 6px' }}>
                                    {T('prostudio.agentsec.previewDataEmpty', '(produk ujian ini belum ada data diisi)')}
                                  </span>
                                )}
                              {extra
                                ? <span style={{ display: 'block', maxHeight: 260, overflowY: 'auto' }}>{extra}</span>
                                : <span style={{ opacity: 0.7 }}>{T('prostudio.agentsec.previewNoExtra', '(tiada ayat arahan tambahan)')}</span>}
                            </div>
                          </div>

                          {agent.replies.length === 0 ? bubbleFinal : (
                            <>
                              {agent.replies.map((r, i) => (
                                <Fragment key={i}>
                                  <div style={{ alignSelf: 'flex-start', maxWidth: '92%' }}>
                                    <div style={labelKecil}>{namaAgent}</div>
                                    <div style={bubbleAgent}>{T('prostudio.agentsec.previewAsk', 'Agent anda bertanya soalan…')}</div>
                                    {tandaGambar(i)}
                                  </div>
                                  <div style={{ alignSelf: 'flex-end', maxWidth: '92%' }}>
                                    <div style={{ ...labelKecil, textAlign: 'right' }}>SESAAT · {balasanWord} {i + 1}</div>
                                    <div style={bubbleBalasan}>
                                      {(r || '').trim() || <span style={{ opacity: 0.65 }}>{`(${balasanWord} ${i + 1})`}</span>}
                                    </div>
                                  </div>
                                </Fragment>
                              ))}
                              {bubbleFinal}
                            </>
                          )}
                        </div>

                        <div style={{ fontSize: 11, color: 'var(--ps-ink-4)', marginTop: 12, lineHeight: 1.5 }}>
                          {T('prostudio.agentsec.previewFoot', 'Contoh sahaja — nama dan link produk sebenar diisi masa larian.')}
                        </div>
                      </div>
                    );
                  })()}

                </div>
              </div>
              )}

              {/* ══ LANGKAH 3 — HASIL YANG ANDA MAHU ══ */}
              {langkah === 3 && (
              <div style={v39 ? { display: 'contents' } : card(false)}>
                <StepHead v39={v39} n={3} title={T('prostudio.wizard.s3.name', 'Hasil Yang Anda Mahu')} sub={T('prostudio.agentsec.s3sub', 'Tetapkan apa yang SESAAT patut hasilkan untuk setiap produk.')} />

                {/* Set + Babak */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14, marginTop: 12 }}>
                  <div>
                    <label style={lbl(v39)}>{T('prostudio.wizard.setsPerProduct', 'Berapa set setiap produk?')}</label>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {Array.from({ length: MAX_SETS }, (_, i) => i + 1).map(n => (
                        <Pill v39={v39} key={n} on={agent.setCount === n} onClick={() => patchAgent({ setCount: n })}>{n}</Pill>
                      ))}
                    </div>
                    <div style={hint(v39)}>{T('prostudio.agentsec.setsHint', 'Satu set = satu hasil lengkap. Tiga set = tiga versi berbeza bagi produk yang sama.')}</div>
                  </div>

                  <div>
                    {/* ⛔ TIADA mangga di sini (arahan user 2026-08-21: "keliru").
                        Babak 1 dan 2 MEMANG boleh dijalankan — hanya 3 ke atas
                        yang berkunci. Mangga pada nama seksyen membaca seolah-olah
                        SELURUH seksyen mati, jadi ia menipu. Pil 3/4/5 yang pudar
                        + nota di bawah sudah cukup menerangkannya. */}
                    <label style={lbl(v39)}>{T('prostudio.wizard.scenesPerSet', 'Berapa babak setiap set?')}</label>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {Array.from({ length: MAX_SCENES }, (_, i) => i + 1).map(n => {
                        const belumSedia = n > BABAK_SIAP_MAX;
                        return (
                          <Pill
                            v39={v39} key={n} kunci={belumSedia}
                            title={belumSedia
                              ? T('prostudio.agentsec.kunciTip', 'Belum tersedia — perlukan extension versi baharu')
                              : undefined}
                            on={agent.sceneCount === n}
                            onClick={() => { if (!belumSedia) changeSceneCount(n); }}
                          >{n}</Pill>
                        );
                      })}
                    </div>
                    <div style={hint(v39)}>{T('prostudio.agentsec.scenesHint', `Babak = potongan cerita di dalam satu set. Maksimum ${MAX_SCENES} babak.`, { n: MAX_SCENES })}</div>
                    <div style={hint(v39)}>
                      {T('prostudio.agentsec.babakKunciNota',
                        `Buat masa ini 1 hingga ${BABAK_SIAP_MAX} babak sahaja boleh dijalankan. Pilihan ${BABAK_SIAP_MAX + 1} ke atas akan dibuka apabila extension versi baharu dikeluarkan.`,
                        { siap: BABAK_SIAP_MAX, seterusnya: BABAK_SIAP_MAX + 1 })}
                    </div>
                  </div>
                </div>

                {/* Hasil akhir */}
                <div style={{ marginTop: 16 }}>
                  <Lbl v39={v39} kunci tip={T('prostudio.agentsec.kunciTip', 'Belum tersedia — perlukan extension versi baharu')}>
                    {T('prostudio.wizard.finalOutput', 'Hasil akhir')}
                  </Lbl>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', gap: 8 }}>
                    {/* ⛔ DIKUNCI (arahan user 2026-08-21) — corak sama seperti
                        babak 3+: pilihan kekal kelihatan supaya pelanggan tahu ia
                        akan datang, tetapi tidak boleh dipilih. Agent LAMA yang
                        sudah memilihnya kekal seperti sedia ada dan boleh bertukar
                        ke Gambar + Video bila-bila masa — tiada tetapan pelanggan
                        ditulis semula tanpa dia menekan Simpan. */}
                    <Choice v39={v39} kunci
                      tip={T('prostudio.agentsec.kunciTip', 'Belum tersedia — perlukan extension versi baharu')}
                      on={agent.output === 'image'} icon="image"
                      title={T('prostudio.wizard.outImageOnly', 'Gambar sahaja')}
                      sub={T('prostudio.wizard.outImageOnlySub', 'Jana gambar, berhenti di situ. Sesuai untuk poster dan carousel.')}
                      onClick={() => patchAgent({ output: 'image' })}
                    />
                    <Choice v39={v39}
                      on={agent.output === 'imagevideo'} icon="movie"
                      title={T('prostudio.wizard.outImageVideo', 'Gambar + Video')}
                      sub={T('prostudio.wizard.outImageVideoSub', 'Jana gambar, kemudian animasikan menjadi video.')}
                      onClick={() => patchAgent({ output: 'imagevideo' })}
                    />
                  </div>
                  <div style={hint(v39)}>
                    {T('prostudio.agentsec.hasilKunciNota', 'Buat masa ini setiap larian menjana gambar dan video. Pilihan gambar sahaja akan dibuka bersama extension versi baharu.')}
                  </div>
                </div>

                {/* ⛔ Suis "Gabungkan semua babak menjadi satu video" (agent.combine)
                    DIBUANG 2026-09-12 (arahan user). Ia hanya disimpan + dipapar —
                    TIADA laluan larian membacanya (Run Flow memilih skrip ikut
                    sceneCount sahaja: 2 babak = AI16SAAT yang SENTIASA gabung),
                    jadi ia kawalan palsu. Jangan pasang semula tanpa membina
                    laluan "babak berasingan" sebenar dahulu. */}

                {/* Gambar produk + Avatar */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14, marginTop: 16 }}>
                  <div>
                    <Lbl v39={v39} kunci tip={T('prostudio.agentsec.kunciTip', 'Belum tersedia — perlukan extension versi baharu')}>
                      {T('prostudio.wizard.productPhoto', 'Gambar produk dimasukkan pada')}
                    </Lbl>
                    <SceneSelect
                      T={T} v39={v39} kunciKe="all"
                      value={agent.productPhoto} sceneCount={agent.sceneCount}
                      onChange={(v) => patchAgent({ productPhoto: v })}
                      noneLabel={T('prostudio.wizard.photoNone', 'Tidak dimasukkan')}
                    />
                    <div style={hint(v39)}>
                      {T('prostudio.agentsec.productPhotoHint', 'Gambar produk sebenar dimuat naik ke Flow sebagai rujukan — supaya produk kelihatan tepat, bukan rekaan AI.')}
                    </div>
                    <div style={hint(v39)}>
                      {T('prostudio.agentsec.produkKunciNota', 'Buat masa ini gambar produk sentiasa digunakan pada setiap babak. Memilih babak tertentu akan dibuka bersama extension versi baharu.')}
                    </div>
                  </div>

                  <div>
                    <Lbl v39={v39} kunci tip={T('prostudio.agentsec.kunciTip', 'Belum tersedia — perlukan extension versi baharu')}>
                      {T('prostudio.agentsec.avatarLabel', 'Gambar avatar digunakan pada')}
                    </Lbl>
                    <SceneSelect
                      T={T} v39={v39} kunciKe="all"
                      value={agent.avatar} sceneCount={agent.sceneCount}
                      onChange={(v) => patchAgent({ avatar: v })}
                      noneLabel={T('prostudio.wizard.avatarNone', 'Tidak digunakan')}
                    />
                    <div style={hint(v39)}>
                      {T('prostudio.agentsec.avatarHint', 'Avatar ialah wajah model tetap anda. Gunakannya supaya semua video kelihatan datang daripada orang yang sama.')}
                    </div>
                    <div style={hint(v39)}>
                      {T('prostudio.agentsec.avatarKunciNota', 'Buat masa ini pilihannya ialah guna avatar pada semua babak, atau tidak guna langsung. Memilih babak tertentu akan dibuka bersama extension versi baharu.')}
                    </div>
                  </div>
                </div>

                {/* Ringkasan bahasa manusia */}
                <div style={{
                  marginTop: 16, padding: '11px 13px', background: 'var(--ps-accent-soft)',
                  border: '1px solid var(--ps-accent-soft-2)', borderRadius: 10,
                  display: 'flex', gap: 9, alignItems: 'flex-start',
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: 17, color: 'var(--ps-accent-ink)', marginTop: 1 }}>lightbulb</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: v39 ? 12.5 : 9.5, fontWeight: 900, color: 'var(--ps-accent-ink)', letterSpacing: '0.06em', marginBottom: 3 }}>{T('prostudio.agentsec.summary', 'RINGKASAN')}</div>
                    <div style={{ fontSize: v39 ? 13 : 11, color: 'var(--ps-accent-deep)', lineHeight: 1.65, fontWeight: 600 }}>
                      {/* Ringkasan pakai nilai terkunci 'all' untuk gambar produk
                          + avatar — sepadan dengan dropdown yang dikunci. */}
                      {buildSummary({ ...agent, productPhoto: 'all', avatar: 'all' }, T)}
                    </div>
                  </div>
                </div>
              </div>
              )}

              {/* ══ LANGKAH 4 — CONFIGURE ══ (Borang Output dibuang 2026-08-19 — field tetap 3) */}
              {langkah === 4 && (
              <div style={v39 ? { display: 'contents' } : card(false)}>
                <StepHead v39={v39}
                  n={4} title={T('prostudio.wizard.s4.name', 'Configure')}
                  sub={T('prostudio.agentsec.s4sub', 'Jalankan sekali dengan satu produk supaya SESAAT belajar membaca output agent anda.')}
                  /* ⛔ "READY" kekal English — ia lencana status yang sama
                     seperti pada senarai agent dan pemilih di Workspace. */
                  badge={agent.configured ? { text: 'READY', color: 'var(--ps-ok-deep)', bg: 'var(--ps-ok-soft)', border: 'var(--ps-ok-line)' } : null}
                />

                {/* ── RUPA v3.9: reka bentuk baharu (lihat blok data di atas) ── */}
                {v39 && (
                  <ProStudioKonfigurV39
                    t={t}
                    larian={larianV39} barisLarian={runStep} saatLuar={runElapsed}
                    onJalan={runConfigure} ralat={runError}
                    onUbahTetapan={() => setUbahTetapan(true)}
                    /* ★ Gambar daripada jawapan agent (2026-09-11) — pratonton sahaja. */
                    gambar={gambarLarian} gambarDijangka={imageTurnsDaripadaAgent(agent).length}
                    /* ★ Laporan gambar PRODUK yang dihantar kepada agent (2026-09-13). */
                    gambarProduk={gambarProdukLarian}
                    /* ★ Tetapan larian (Thinking / Extended thinking / model) yang tidak menjadi (2026-09-13). */
                    amaranTetapan={amaranTetapanLarian}
                    /* Diberi hanya apabila memang ada hasil untuk dikembalikan. */
                    onKembaliHasil={showMatch ? () => setUbahTetapan(false) : undefined}
                    produkSenarai={products.map(p => ({ id: p.id, nama: p.name }))}
                    produkUjian={testProductId} produkNama={previewProduct?.name || ''}
                    onProduk={setTestProductId} memuatProduk={productsLoading}
                    /* ⭐ Pemilih produk = komponen yang SAMA seperti Langkah 2, bukan
                       salinan kedua (arahan user 2026-08-26: "jangan copy code, biar
                       sync je"). Ia dihantar sebagai nod supaya ProStudioKonfigurV39
                       kekal RUPA sahaja — senarai READY, gambar dan carian semuanya
                       hidup di sini, satu takrifan.
                       ⚠️ `produkSenarai` di atas SENGAJA dikekalkan: lakaran
                          /prostudio-v3.9/agent tidak menghantar nod ini, jadi ia
                          jatuh ke `<select>` biasa di sana. */
                    pemilihProduk={(
                      <PemilihProduk
                        v39={v39} T={T} produk={products} nilai={testProductId}
                        onPilih={setTestProductId} memuat={productsLoading}
                      />
                    )}
                    bolehJalan={bolehJalanV39}
                    notaJalan={!agent.url.trim() ? t('prostudio.agentsec.runBlockedUrl')
                      : !testProductId ? t('prostudio.agentsec.runBlockedProduct')
                        : perluPilihExt ? t('prostudio.cfg.tahapBlocked')
                          : (perluPilihGemini && !agent.geminiModel) ? t('prostudio.cfg.geminiModelBlocked')
                            : perluPilihGemini ? t('prostudio.cfg.geminiExtBlocked')
                              : t('prostudio.agentsec.runReady')}
                    set={agent.setsDetected || agent.setCount || 1}
                    babak={agent.scenesDetected || agent.sceneCount || 1}
                    tarikh={tarikhBar}
                    larianBaharu={larianBaharu}
                    belumSimpan={!!dirtyIds[selectedId]}
                    chatUrl={agent.chatUrl || ''}
                    /* ⚠️ SLUG, bukan `agent.sources` mentah. `sources` ialah tajuk
                       penuh dalam jawapan agent ("=== SET A — POV: #1 ==="); token
                       dalam templat pula ialah slug-nya. Menghantar yang mentah
                       membuatkan setiap medan dikira TIDAK berpadan walaupun ia
                       berpadan, dan palet memapar tajuk penuh sebagai nama blok. */
                    kumpulan={kumpulanV39} sumber={sumberSlugV39}
                    sumberLabel={labelBlokV39} padanan={padananV39}
                    /* Baris per-babak menulis ke babaknya sendiri — lihat
                       tulisPadanan(). Menulis ke `template` terus akan menukar
                       SEMUA babak sekali gus. */
                    onPadanan={tulisPadanan}
                    platform={agent.platform}
                    modelGemini={agent.geminiModel || ''}
                    /* Tukar model = kalibrasi lama tidak sah lagi — peraturan
                       SAMA seperti rupa lama, jangan pisahkan. */
                    onModelGemini={(v) => patchAgent({ geminiModel: v, configured: false })}
                    modelSenarai={modelSenaraiV39} modelNota={modelNotaV39}
                    onBacaModel={bacaSenaraiModel} bacaModelSibuk={bacaModel} modelRalat={modelError}
                    /* Menukar kawalan larian = kalibrasi lama tidak sah lagi
                       (peraturan sama seperti menukar model Gemini). */
                    extended={agent.platform === 'gemini' ? null : (agent.chatgptExtended || '')}
                    onExtended={(v) => patchAgent({ chatgptExtended: v, configured: false })}
                    /* ★ Tahap Thinking ChatGPT (2026-09-26) — pilihan dibaca dari akaun. */
                    tahap={agent.platform === 'gemini' ? null : (agent.chatgptTahap || '')}
                    tahapPilihan={agent.chatgptTahapPilihan || []}
                    akaunChatgpt={agent.chatgptAkaun || ''}
                    tahapTiada={!!agent.chatgptTahapTiada}
                    onTahap={(v) => patchAgent({ chatgptTahap: v, configured: false })}
                    onBacaTahap={bacaPilihanThinking}
                    /* ⭐ Gemini: tahap Thinking (Low/Medium/High) prominent + wajib (padanan
                       tahap ChatGPT). null = agent ChatGPT (kawalan tak berkenaan). */
                    geminiExtended={agent.platform === 'gemini' ? (agent.geminiExtended || '') : null}
                    onGeminiExtended={(v) => patchAgent({ geminiExtended: v, configured: false })}
                    pusingan={pusinganV39} pusinganPilih={agent.outputTurn || 0}
                    onPusingan={changeOutputTurn} pusinganSibuk={matching}
                    jawapanPenuh={shownRaw}
                    blokSendiri={blokSendiriV39} onTambahBlok={tambahBlok} onBuangBlok={buangBlok}
                    penandaBlok={penandaBlokV39}
                    pratonton={pratontonV39}
                  />
                )}

                {/* ⛔ SEMUA DI BAWAH INI = RUPA LAMA, huruf demi huruf seperti
                    sebelum 2026-08-20. Ia laluan pelanggan sebenar hari ini. */}
                {!v39 && (<>

                <div style={{
                  marginTop: 10, fontSize: v39 ? 12.5 : 10, color: 'var(--ps-accent-deep)', background: 'var(--ps-accent-soft)',
                  border: '1px dashed var(--ps-accent-line)', borderRadius: 9, padding: '9px 11px', lineHeight: 1.6,
                  display: 'flex', gap: 7, alignItems: 'flex-start',
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: 15, marginTop: 1 }}>info</span>
                  <div>
                    {sisip(
                      T('prostudio.agentsec.runNote', 'Satu produk sebenar akan dihantar kepada agent anda melalui Extension SESAAT. Satu tab ChatGPT akan dibuka — {b} (lebih kurang satu hingga dua minit).'),
                      <b>{T('prostudio.agentsec.runNoteStrong', 'biarkan ia berjalan sehingga selesai')}</b>,
                    )}
                  </div>
                </div>

                {agent.configured && runState === 'idle' && !runError && (
                  <div style={{ fontSize: v39 ? 12.5 : 10, color: 'var(--ps-ok-deep)', fontWeight: 700, marginTop: 8 }}>
                    ✓ {T('prostudio.agentsec.configuredOn', `Agent ini telah dikonfigurasi pada ${agent.configuredAt}. Anda boleh menjalankannya di Workspace.`, { tarikh: tarikhConfigure })}
                  </div>
                )}

                {runError && (
                  <div style={{
                    marginTop: 10, fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-stop-ink)', background: 'var(--ps-stop-soft)',
                    border: '1px solid var(--ps-stop-line)', borderRadius: 9, padding: '9px 11px', lineHeight: 1.6,
                    display: 'flex', gap: 7, alignItems: 'flex-start',
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 15, marginTop: 1 }}>error</span>
                    <div>{runError}</div>
                  </div>
                )}

                <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginTop: 12 }}>
                  <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                    <label style={lbl(v39)}>{T('prostudio.wizard.testProduct', 'Produk untuk ujian')}</label>
                    <select
                      value={testProductId}
                      onChange={(e) => setTestProductId(e.target.value)}
                      disabled={productsLoading || products.length === 0}
                      style={{ ...sel(v39), cursor: products.length ? 'pointer' : 'not-allowed' }}
                    >
                      {productsLoading && <option value="">{T('prostudio.agentsec.productsLoading', 'Memuatkan produk...')}</option>}
                      {!productsLoading && products.length === 0 && <option value="">{T('prostudio.agentsec.productsEmpty', 'Tiada produk dalam Workspace')}</option>}
                      {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                    </select>
                    {!productsLoading && products.length === 0 && (
                      <div style={hint(v39)}>{T('prostudio.agentsec.productsEmptyHint', 'Tambah sekurang-kurangnya satu produk di Workspace sebelum menjalankan Configure.')}</div>
                    )}
                  </div>
                  {(() => {
                    const blocked = runState === 'running' || !agent.url.trim() || !testProductId;
                    return (
                      <button
                        type="button"
                        disabled={blocked}
                        onClick={runConfigure}
                        title={!agent.url.trim() ? T('prostudio.agentsec.runBlockedUrl', 'Isi URL Custom GPT terlebih dahulu')
                          : !testProductId ? T('prostudio.agentsec.runBlockedProduct', 'Pilih produk untuk ujian terlebih dahulu')
                            : T('prostudio.agentsec.runReady', 'Jalankan sekali untuk belajar format output')}
                        style={{
                          padding: '9px 18px', borderRadius: 9, fontSize: v39 ? 13 : 11.5, fontWeight: 800,
                          cursor: blocked ? 'not-allowed' : 'pointer',
                          background: blocked ? 'var(--ps-fill-2)' : 'var(--ps-grad)',
                          border: 'none', color: blocked ? 'var(--ps-ink-3)' : 'var(--ps-on-accent)',
                          display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
                        }}
                      >
                        <span className="material-symbols-outlined" style={{ fontSize: 15 }}>
                          {runState === 'running' ? 'hourglass_top' : agent.configured ? 'refresh' : 'play_arrow'}
                        </span>
                        {runState === 'running' ? T('prostudio.agentsec.running', 'Sedang menguji...')
                          : agent.configured ? T('prostudio.agentsec.configureAgain', 'Configure Semula')
                            : T('prostudio.agentsec.configureAgent', 'Configure Agent')}
                      </button>
                    );
                  })()}
                </div>
                {agent.platform === 'gemini' && (
                  <div style={{ marginTop: 12 }}>
                    <label style={lbl(v39)}>{T('prostudio.agentsec.geminiModel', 'Model Gemini')}</label>
                    <select
                      value={agent.geminiModel || ''}
                      /* Tukar model = kalibrasi lama tidak sah lagi (bentuk jawapan
                         Flash dan Pro boleh berbeza) — sama peraturan dgn tukar platform. */
                      onChange={(e) => patchAgent({ geminiModel: e.target.value, configured: false })}
                      style={{ ...sel(v39), cursor: 'pointer' }}
                    >
                      <option value="">{T('prostudio.agentsec.geminiModelDefault', 'Ikut tetapan Gemini')}</option>
                      {Array.from(new Set([
                        ...(Array.isArray(agent.geminiModels) ? agent.geminiModels : []),
                        ...(agent.geminiModel ? [agent.geminiModel] : []),
                      ])).map((m) => <option key={m} value={m}>{m}</option>)}
                    </select>
                    <div style={hint(v39)}>
                      {/* 3 keadaan — JANGAN gabungkan semula. "Belum pernah Configure" dan
                          "sudah Configure tetapi senarai gagal dibaca" memerlukan arahan yang
                          BERBEZA; satu ayat untuk kedua-duanya akan menyuruh pelanggan membuat
                          benda yang dia sudah buat. */}
                      {(Array.isArray(agent.geminiModels) && agent.geminiModels.length)
                        ? T('prostudio.agentsec.geminiModelHint', 'Menukar model memadam status Configured — jalankan Configure semula selepas menukar.')
                        : agent.configured
                          ? T('prostudio.agentsec.geminiModelFail', 'Senarai model akaun anda tidak dapat dibaca daripada Gemini. Tekan Configure Semula di atas untuk mencuba lagi.')
                          : T('prostudio.agentsec.geminiModelEmpty', 'Jalankan Configure di atas — selepas itu model akaun Gemini anda akan tersenarai di sini untuk dipilih.')}
                    </div>
                  </div>
                )}


                {runState === 'running' && (
                  <div style={{
                    marginTop: 12, padding: '11px 13px', background: 'var(--ps-accent-soft)',
                    border: '1px solid var(--ps-accent-soft-2)', borderRadius: 10,
                    display: 'flex', flexDirection: 'column', gap: 6,
                  }}>
                    {/* Ikon progress_activity ialah glyph STATIK — WAJIB diputar sendiri,
                        kalau tidak langkah aktif nampak beku (aduan user 2026-08-19). */}
                    <style>{'@keyframes ps-spin{to{transform:rotate(360deg)}}'}</style>
                    {RUN_STEPS.map(([kunci, lalai], i) => {
                      const done = runStep > i;
                      const now = runStep === i;
                      return (
                        <div key={kunci} style={{
                          display: 'flex', alignItems: 'center', gap: 7,
                          fontSize: v39 ? 12.5 : 10.5, fontWeight: done || now ? 700 : 500,
                          color: done ? 'var(--ps-ok-deep)' : now ? 'var(--ps-accent-deep)' : 'var(--ps-ink-4)',
                        }}>
                          <span className="material-symbols-outlined" style={{
                            fontSize: 14, display: 'inline-block',
                            animation: now ? 'ps-spin 0.9s linear infinite' : 'none',
                          }}>
                            {done ? 'check_circle' : now ? 'progress_activity' : 'radio_button_unchecked'}
                          </span>
                          <span>{T(kunci, lalai)}</span>
                          {/* Pemasa saat pada langkah aktif — bukti nyata ia sedang bekerja. */}
                          {now && (
                            <span style={{
                              marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 3,
                              fontVariantNumeric: 'tabular-nums', fontSize: v39 ? 12 : 10, fontWeight: 700,
                              color: 'var(--ps-accent-deep)',
                            }}>
                              <span className="material-symbols-outlined" style={{ fontSize: 13 }}>timer</span>
                              {runElapsed}s
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {runState === 'idle' && !agent.configured && (
                  <div style={{
                    marginTop: 12, padding: '22px 18px', textAlign: 'center',
                    background: 'var(--ps-fill)', border: '1px dashed var(--ps-line)', borderRadius: 10,
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 30, color: 'var(--ps-ink-4)' }}>science</span>
                    <div style={{ fontSize: v39 ? 13 : 11.5, fontWeight: 700, color: 'var(--ps-ink-2)', marginTop: 6 }}>
                      {T('prostudio.agentsec.notConfiguredTitle', 'Agent ini belum dikonfigurasi')}
                    </div>
                    <div style={{ fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-ink-3)', marginTop: 4, lineHeight: 1.6, maxWidth: 430, margin: '4px auto 0' }}>
                      {sisip(
                        T('prostudio.agentsec.notConfiguredBody', 'Klik {b} di atas. SESAAT akan menghantar satu produk kepada agent anda, kemudian memadankan jawapannya dengan borang di Langkah 4 secara automatik. Anda hanya perlu menyemak dan mengesahkan.'),
                        <b>{T('prostudio.agentsec.configureAgent', 'Configure Agent')}</b>,
                      )}
                    </div>
                  </div>
                )}

                {showMatch && (
                  <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>

                    {/* ★ Gambar PRODUK yang dihantar kepada agent (2026-09-13) — hanya bila
                        produk ujian membawa gambar tambahan. */}
                    {gambarProdukLarian && (
                      <div style={{
                        padding: '11px 13px', borderRadius: 10,
                        background: gambarProdukLarian.status === 'lengkap' ? 'var(--ps-fill)' : 'var(--ps-warn-soft, #fffbeb)',
                        border: `1px solid ${gambarProdukLarian.status === 'lengkap' ? 'var(--ps-line-2)' : 'var(--ps-warn-line, #fcd34d)'}`,
                        color: gambarProdukLarian.status === 'lengkap' ? 'var(--ps-ink-2, inherit)' : 'var(--ps-warn-deep, #92400e)',
                        fontSize: 13, lineHeight: 1.55,
                      }}>
                        {gambarProdukLarian.status === 'lama'
                          ? T('prostudio.cfg.prodImgOld', 'Gambar tambahan produk ini tidak dihantar — pasang extension SESAAT terkini (3.9.4 ke atas), kemudian jalankan Configure semula.')
                          : gambarProdukLarian.status === 'kurang'
                            ? T('prostudio.cfg.prodImgShort', `Hanya ${gambarProdukLarian.dihantar} daripada ${gambarProdukLarian.dijangka} gambar produk sampai kepada agent — jawapan agent mungkin tidak merangkumi semua gambar.`, { dihantar: gambarProdukLarian.dihantar, dijangka: gambarProdukLarian.dijangka })
                            : T('prostudio.cfg.prodImgOk', `Gambar produk dihantar kepada agent: ${gambarProdukLarian.dihantar}.`, { n: gambarProdukLarian.dihantar })}
                        {gambarProdukLarian.amaran.length > 0 && (
                          <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                            {gambarProdukLarian.amaran.map((a, i) => <li key={i}>{a}</li>)}
                          </ul>
                        )}
                      </div>
                    )}

                    {/* ★ Gambar daripada jawapan agent — PRATONTON sahaja (2026-09-11). */}
                    {imageTurnsDaripadaAgent(agent).length > 0 && (
                      <div style={{ padding: '11px 13px', background: 'var(--ps-fill)', border: '1px solid var(--ps-line-2)', borderRadius: 10 }}>
                        <label style={lbl(v39)}>{T('prostudio.cfg.imgTitle', 'Gambar daripada jawapan agent')}</label>
                        {gambarLarian.length ? (
                          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {gambarLarian.map((g, i) => (
                              <img key={i} src={g.dataUrl} alt="" style={{ height: 150, width: 'auto', borderRadius: 8, border: '1px solid var(--ps-line)' }} />
                            ))}
                          </div>
                        ) : (
                          <div style={{ ...hint(v39), marginTop: 0, color: 'var(--ps-warn-deep, #92400e)' }}>
                            {T('prostudio.cfg.imgNone', 'Tiada gambar diterima pada larian ini. Pastikan extension SESAAT versi 3.9.4 ke atas dipasang, dan agent memang menjana gambar pada jawapan yang ditanda.')}
                          </div>
                        )}
                        <div style={hint(v39)}>{T('prostudio.cfg.imgHint', 'Pratonton sahaja — gambar disimpan ke kad hanya semasa larian sebenar di Workspace.')}</div>
                      </div>
                    )}

                    {/* ── Pilih pusingan mana menjadi output ── */}
                    {rawTurns.length > 1 && (
                      <div style={{
                        padding: '11px 13px', background: 'var(--ps-fill)',
                        border: '1px solid var(--ps-line-2)', borderRadius: 10,
                      }}>
                        <label style={lbl(v39)}>{T('prostudio.agentsec.outputFrom', 'Output diambil daripada')}</label>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                          <select
                            value={String(agent.outputTurn || 0)}
                            onChange={(e) => changeOutputTurn(Number(e.target.value))}
                            disabled={matching}
                            style={{ ...sel(v39), flex: '1 1 240px', width: 'auto', cursor: matching ? 'wait' : 'pointer' }}
                          >
                            {/* ⚠️ Pemboleh ubah gelung dinamakan `turn`, BUKAN `t` —
                                `t` ialah fungsi kamus dalam skop ini, dan menamakannya
                                `t` akan melindunginya secara senyap. */}
                            {rawTurns.map((turn, i) => (
                              <option key={i} value={String(i)}>
                                {i === 0
                                  ? T('prostudio.agentsec.turnFirst', 'Jawapan pertama')
                                  : T('prostudio.agentsec.turnAfter', `Selepas Balasan ${i}`, { n: i })}
                                {turn.trim().length < 40
                                  ? T('prostudio.agentsec.turnEmpty', ' — kosong')
                                  : T('prostudio.agentsec.turnChars', ` — ${turn.trim().length.toLocaleString()} aksara`, { n: turn.trim().length.toLocaleString() })}
                              </option>
                            ))}
                          </select>
                          {matching && (
                            <span style={{ fontSize: v39 ? 12.5 : 10.5, fontWeight: 700, color: 'var(--ps-accent-deep)', display: 'flex', alignItems: 'center', gap: 5 }}>
                              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>progress_activity</span>
                              {T('prostudio.agentsec.rematching', 'Memadankan semula...')}
                            </span>
                          )}
                        </div>
                        <div style={hint(v39)}>
                          {T('prostudio.agentsec.outputFromHint', 'Sesetengah agent memberikan output akhir hanya selepas beberapa balasan. Pilih pusingan yang mengandungi output sebenar — SESAAT akan memadankan semula serta-merta tanpa perlu menjalankan agent sekali lagi.')}
                        </div>
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: v39 ? 13 : 11, fontWeight: 800, color: 'var(--ps-ink)' }}>{T('prostudio.agentsec.matchTitle', 'Padanan yang dikesan')}</span>
                      <span style={{
                        fontSize: v39 ? 11 : 8.5, fontWeight: 900, letterSpacing: '0.05em', padding: '2px 7px', borderRadius: 999,
                        color: 'var(--ps-ok-deep)', background: 'var(--ps-ok-soft)', border: '1px solid var(--ps-ok-line)',
                      }}>
                        {T('prostudio.agentsec.matchBadge', `${agent.setsDetected || agent.setCount} SET · ${agent.scenesDetected || agent.sceneCount} BABAK DIKESAN`, {
                          set: agent.setsDetected || agent.setCount,
                          babak: agent.scenesDetected || agent.sceneCount,
                        })}
                      </span>
                      <span style={{ fontSize: v39 ? 12.5 : 9.5, color: 'var(--ps-ink-3)', fontWeight: 600 }}>
                        {T('prostudio.agentsec.matchCheck', 'Semak setiap baris. Tukar jika padanan tidak tepat.')}
                      </span>
                    </div>

                    {engineMissing.length > 0 && (
                      <div style={{
                        fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-warn-ink)', background: 'var(--ps-warn-soft)',
                        border: '1px solid var(--ps-warn-line)', borderRadius: 9, padding: '9px 11px', lineHeight: 1.6,
                        display: 'flex', gap: 7, alignItems: 'flex-start',
                      }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 15, marginTop: 1 }}>warning</span>
                        <div>
                          {sisip(
                            T('prostudio.agentsec.missingWarn', '{b} belum berpadan. Automation Flow tidak dapat dijalankan tanpa field ini. Sila pilih sumbernya secara manual di bawah, atau jalankan Configure semula.'),
                            <b>{engineMissing.map(f => fieldLabel(f, T)).join(T('prostudio.agentsec.missingAnd', ' dan '))}</b>,
                          )}
                        </div>
                      </div>
                    )}

                    {/* Rupa lama turut menerima baris per-babak — kalau tidak,
                        pelanggan yang jatuh ke rupa lama langsung tiada tempat
                        untuk menetapkan blok babak 2. Sumber baris = SATU senarai
                        (barisMedanSemua), jadi dua rupa mustahil terpesong. */}
                    <MatchTable
                      T={T} v39={v39}
                      groupTitle={T('prostudio.agentsec.matchScene', `Setiap babak — diulang ${agent.sceneCount}×`, { n: agent.sceneCount })}
                      fields={barisMedanSemua.filter(b => b._kump === 'sceneFields')}
                      sources={sumberSemua}
                      onChange={tulisPadanan}
                    />
                    <MatchTable
                      T={T} v39={v39}
                      groupTitle={T('prostudio.agentsec.perSetTitle', 'Sekali sahaja setiap set')}
                      fields={barisMedanSemua.filter(b => b._kump === 'setFields')}
                      sources={sumberSemua}
                      onChange={tulisPadanan}
                    />

                    {previewRows.length > 0 && (
                      <PratontonKad
                        v39={v39} T={T}
                        product={previewProduct}
                        rows={previewRows}
                        setNo={curPreviewSet}
                        setCount={previewSetCount}
                        onSet={setPreviewSet}
                      />
                    )}

                    {shownRaw && (
                      <details>
                        <summary style={{
                          fontSize: v39 ? 12.5 : 10.5, fontWeight: 700, color: 'var(--ps-accent-ink)', cursor: 'pointer',
                          padding: '4px 0', listStyle: 'none', display: 'flex', alignItems: 'center', gap: 4,
                        }}>
                          <span className="material-symbols-outlined" style={{ fontSize: 14 }}>code</span>
                          {T('prostudio.agentsec.seeRaw', 'Lihat jawapan penuh daripada agent')}
                          {rawTurns.length > 1 && (
                            <span style={{ fontWeight: 600, color: 'var(--ps-ink-3)' }}>
                              ({(agent.outputTurn || 0) === 0
                                ? T('prostudio.agentsec.seeRawFirst', 'jawapan pertama')
                                : T('prostudio.agentsec.seeRawAfter', `selepas Balasan ${agent.outputTurn}`, { n: agent.outputTurn })})
                            </span>
                          )}
                        </summary>
                        <pre style={{
                          marginTop: 6, maxHeight: 190, overflow: 'auto', padding: '10px 12px',
                          background: 'var(--ps-ink-deep)', color: 'var(--ps-ink-4)', borderRadius: 9,
                          fontSize: v39 ? 12.5 : 10, lineHeight: 1.6, fontFamily: 'monospace',
                          whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                        }}>{shownRaw}</pre>
                      </details>
                    )}

                    {/* TIADA butang Simpan di sini — bar Simpan di bahagian atas MELEKAT
                        semasa skrol, jadi butang kedua hanya mengelirukan (maklum balas
                        user 2026-08-05). Jangan tambah semula. */}
                    <div style={{
                      display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap',
                      fontSize: v39 ? 12.5 : 9.5, color: 'var(--ps-ink-3)', fontWeight: 600,
                    }}>
                      <span className="material-symbols-outlined" style={{ fontSize: 13 }}>arrow_upward</span>
                      <span>
                        {sisip(
                          T('prostudio.agentsec.saveHintTop', 'Semak padanan di atas, kemudian tekan {b} di bar atas — semua perubahan (Langkah 1 hingga 5) disimpan sekali.'),
                          <b style={{ color: 'var(--ps-accent-ink)' }}>{T('prostudio.agentsec.save', 'Simpan')}</b>,
                        )}
                      </span>
                    </div>
                  </div>
                )}
                </>)}
              </div>
              )}

              </PembungkusLangkah>

              {/* ── Navigasi langkah — RUPA LAMA SAHAJA ──
                  Rupa v3.9 meletakkan butang ini dalam jalur kaki Kad
                  (lihat PembungkusLangkah). Simpan kekal di bar atas
                  melekat pada kedua-dua rupa. */}
              {!v39 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {langkah > 1 ? (
                  <button type="button" onClick={() => setLangkah(langkah - 1)} style={btnNav(false, v39)}>
                    <span className="material-symbols-outlined" style={{ fontSize: 15 }}>arrow_back</span>
                    {T('prostudio.agentsec.prev', 'Sebelum')}
                  </button>
                ) : <span />}
                <div style={{ flex: 1 }} />
                {langkah < 4 && (
                  <button type="button" onClick={() => setLangkah(langkah + 1)} style={btnNav(true, v39)}>
                    {T('prostudio.wizard.next', 'Seterusnya')}
                    <span className="material-symbols-outlined" style={{ fontSize: 15 }}>arrow_forward</span>
                  </button>
                )}
              </div>
              )}

              {/* Kotak nota amber (footNote) dibuang atas arahan user 2026-08-18. */}
            </>
          )}
        </div>
      </div>
      </>}

      {/* ★ Modal "Extension Terputus Sambungan" — SAMA seperti Workspace Run Flow.
          Dipapar bila ping extension gagal semasa Configure (ganti amaran merah inline).
          Guna kunci teks ws.auto.* yang sama supaya rupa + ayat 100% padan. */}
      {extDisconnected && (
        <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
          <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-red-200 dark:border-red-900/50 shadow-red-500/10 overflow-hidden">
            {/* Header — merah */}
            <div className="px-6 py-4 bg-gradient-to-r from-red-500 to-rose-600">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur">
                  <span className="material-symbols-outlined text-white text-xl">wifi_off</span>
                </div>
                <div>
                  <h3 className="text-white font-bold text-sm">{T('ws.auto.disconnectedTitle', '🔴 Extension Terputus Sambungan')}</h3>
                  <p className="text-white/80 text-[11px]">{T('ws.auto.disconnectedSub', 'Tab ini perlu di-refresh dulu')}</p>
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="px-6 py-5 space-y-3">
              <p className="text-sm text-slate-700 dark:text-slate-200 leading-relaxed">
                {v39
                  ? t('ws.auto.disconnectedBody')
                  : <>Extension tidak merespons. Selalu berlaku selepas extension update — <strong>bukan masalah produk anda</strong>.</>}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
                {T('ws.auto.disconnectedHint', 'Klik butang di bawah untuk refresh tab ini. Selepas refresh, klik butang Run semula.')}
              </p>
            </div>
            {/* Footer */}
            <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-2">
              <button
                onClick={() => setExtDisconnected(false)}
                className="px-4 py-2 rounded-xl font-bold text-xs uppercase tracking-wide bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 transition-all"
              >
                {T('ws.auto.cancel', 'Batal')}
              </button>
              <button
                onClick={() => {
                  // Ingat langkah + agent semasa supaya selepas reload ia KEKAL di
                  // sini (bukan balik ke Langkah 1). sessionStorage — tiada kos Firebase.
                  try { sessionStorage.setItem('sesaat_prostudio_resume_step', JSON.stringify({ agentId: selectedId, langkah })); } catch { /* abaikan */ }
                  window.location.reload();
                }}
                className="px-5 py-2 rounded-xl font-bold text-xs uppercase tracking-wide bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/20 transition-all transform hover:scale-[1.02] active:scale-95"
              >
                <span className="flex items-center gap-1.5">
                  <span className="material-symbols-outlined text-sm">refresh</span>
                  {T('ws.auto.refreshNow', 'Refresh Tab Sekarang')}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* Tajuk setiap langkah — dipakai oleh bar kemajuan. Turutan MESTI sama
   dengan turutan blok LANGKAH dalam render. */
const TAJUK_LANGKAH = [
  ['prostudio.wizard.s1.name', 'Agent Anda'],
  ['prostudio.wizard.s2.name', 'Perbualan'],
  ['prostudio.wizard.s3.name', 'Hasil'],
  ['prostudio.wizard.s4.name', 'Configure'],
];

const btnNav = (utama, v39) => ({
  display: 'inline-flex', alignItems: 'center', gap: v39 ? 6 : 5,
  padding: v39 ? '0 16px' : '9px 16px', height: v39 ? 36 : undefined,
  borderRadius: v39 ? 8 : 9,
  border: utama ? 'none' : `1px solid var(--ps-${v39 ? 'line-strong' : 'line'})`,
  fontFamily: 'inherit', fontSize: v39 ? 13 : 11.5, fontWeight: v39 ? 600 : 800, cursor: 'pointer',
  background: utama ? 'var(--ps-accent)' : 'transparent',
  color: utama ? 'var(--ps-on-accent)' : 'var(--ps-ink-2)',
});

/* Pembungkus kawasan langkah. Rupa v3.9 = satu Kad berkepala (nombor +
   soalan + nama langkah) dengan butang navigasi dalam JALUR KAKI —
   struktur SAMA seperti prototaip. Rupa lama = telus: setiap blok langkah
   membawa kad + StepHead sendiri seperti sebelum ini, dan butang navigasi
   duduk di baris berasingan di bawah (dirender di tempat panggil). */
function PembungkusLangkah({ v39, langkah, t, setLangkah, children }) {
  if (!v39) return children;
  return (
    <KadV39
      tajuk={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 9 }}>
          <span style={{
            width: 22, height: 22, borderRadius: 999, flex: 'none',
            display: 'grid', placeItems: 'center',
            background: 'var(--s-select)', color: 'var(--s-select-ink)',
            fontSize: 12, fontWeight: 600, fontVariantNumeric: 'tabular-nums',
          }}>{langkah}</span>
          {t(`prostudio.wizard.s${langkah}.q`)}
        </span>
      }
      perihal={t(`prostudio.wizard.s${langkah}.name`)}
      /* Ikon robot hanya pada langkah pertama — sama seperti prototaip. */
      kanan={langkah === 1
        ? <span className="material-symbols-outlined" style={{ fontSize: 18, color: 'var(--s-ink-3)' }}>smart_toy</span>
        : null}
      kaki={
        <>
          {langkah > 1
            ? <BtnV39 variant="quiet" onClick={() => setLangkah(langkah - 1)}>
                <span className="material-symbols-outlined" style={{ fontSize: 15 }}>arrow_back</span>
                {t('prostudio.wizard.back')}
              </BtnV39>
            : <span />}
          <span style={{ flex: 1, minWidth: 0 }} />
          {langkah < 4 && (
            <BtnV39 onClick={() => setLangkah(langkah + 1)}>
              {t('prostudio.wizard.next')}
              <span className="material-symbols-outlined" style={{ fontSize: 15 }}>arrow_forward</span>
            </BtnV39>
          )}
        </>
      }
    >
      {children}
    </KadV39>
  );
}

// ══════════ Komponen kecil ══════════

function StepHead({ n, title, sub, badge, v39 }) {
  /* ⭐ KERJA B: rupa v3.9 memakai kepala Kad (nombor + SOALAN + nama
     langkah), jadi StepHead dalam-badan tidak dirender di sana. Ia kekal
     sepenuhnya untuk rupa lama. */
  if (v39) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: v39 ? 11 : 10 }}>
      <span style={{
        flex: '0 0 auto', width: v39 ? 24 : 22, height: v39 ? 24 : 22, borderRadius: 999,
        background: 'var(--ps-grad)', color: 'var(--ps-on-accent)',
        fontSize: v39 ? 12.5 : 11, fontWeight: v39 ? 700 : 900,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>{n}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap' }}>
          <span style={{ fontSize: v39 ? 15 : 13, fontWeight: v39 ? 600 : 800, color: 'var(--ps-ink)' }}>{title}</span>
          {badge && (
            <span style={{
              fontSize: v39 ? 11 : 8, fontWeight: v39 ? 600 : 900, letterSpacing: '0.05em',
              padding: v39 ? '3px 9px' : '2px 7px', borderRadius: 999,
              color: badge.color, background: badge.bg, border: `1px solid ${badge.border}`,
            }}>{badge.text}</span>
          )}
        </div>
        <div style={{
          fontSize: v39 ? 12.5 : 10.5, color: 'var(--ps-ink-3)', fontWeight: v39 ? 400 : 500,
          marginTop: v39 ? 3 : 2, lineHeight: 1.55,
        }}>{sub}</div>
      </div>
    </div>
  );
}

/* Label seksyen. `kunci` = ciri itu belum dibuka, jadi mangga kecil duduk
   di sebelah NAMA seksyen (arahan user 2026-08-21). Sebabnya: kawalan yang
   mati di tengah seksyen dibaca sebagai rosak — mangga pada nama memberitahu
   pelanggan ia SENGAJA dikunci, sebelum dia cuba menekannya. Nota panjang di
   bawah kawalan kekal; mangga hanya penanda pantas. */
function Lbl({ v39, kunci, tip, children }) {
  return (
    <label style={{ ...lbl(v39), display: 'flex', alignItems: 'center', gap: 6 }}>
      <span>{children}</span>
      {kunci && (
        <span className="material-symbols-outlined" title={tip}
          style={{ fontSize: v39 ? 14 : 12.5, color: 'var(--ps-ink-4)', lineHeight: 1, flex: 'none' }}>lock</span>
      )}
    </label>
  );
}

/* Nombor set / babak. Rupa v3.9 = cip bulat prostudioUI (Cip), rupa lama
   kekal petak. Bentuk sahaja yang berbeza — warna datang dari palet. */
function Pill({ on, onClick, children, v39, kunci, title }) {
  return (
    <button
      type="button" onClick={onClick} disabled={kunci} title={title}
      style={v39 ? {
        minWidth: 38, height: 32, padding: '0 12px', borderRadius: 999,
        fontFamily: 'inherit', fontSize: 13, fontWeight: 500, lineHeight: 1,
        cursor: kunci ? 'not-allowed' : 'pointer', opacity: kunci ? 0.45 : 1,
        background: on ? 'var(--ps-accent)' : 'transparent',
        border: `1px solid ${on ? 'var(--ps-accent)' : 'var(--ps-line-strong)'}`,
        color: on ? 'var(--ps-on-accent)' : 'var(--ps-ink-2)',
        transition: 'background .12s ease, border-color .12s ease, color .12s ease',
      } : {
        minWidth: 38, padding: '7px 12px', borderRadius: 8, fontSize: 11.5, fontWeight: 800,
        cursor: kunci ? 'not-allowed' : 'pointer', opacity: kunci ? 0.45 : 1,
        background: on ? 'var(--ps-accent)' : 'var(--ps-card)',
        border: `1.5px solid ${on ? 'var(--ps-accent)' : 'var(--ps-line)'}`,
        color: on ? 'var(--ps-on-accent)' : 'var(--ps-ink-2)',
      }}
    >{children}</button>
  );
}

function Choice({ on, icon, title, sub, onClick, v39, kunci, tip }) {
  return (
    <button
      type="button" onClick={kunci ? undefined : onClick} disabled={kunci} title={kunci ? tip : undefined}
      style={{
        display: 'flex', gap: 9, alignItems: 'flex-start', textAlign: 'left',
        cursor: kunci ? 'not-allowed' : 'pointer', opacity: kunci ? 0.5 : 1,
        padding: v39 ? '13px 14px' : '11px 12px', borderRadius: 10,
        background: on ? 'var(--ps-accent-soft-3)' : 'var(--ps-card)',
        border: `${v39 ? 1 : 1.5}px solid ${on ? 'var(--ps-accent)' : 'var(--ps-line' + (v39 ? '-strong' : '') + ')'}`,
      }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: v39 ? 18 : 19, color: on ? 'var(--ps-accent-ink)' : 'var(--ps-ink-4)', marginTop: 1 }}>{icon}</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: v39 ? 13.5 : 11.5, fontWeight: v39 ? 600 : 800, color: on ? 'var(--ps-accent-deep)' : 'var(--ps-ink-strong)', marginBottom: v39 ? 3 : 2 }}>{title}</span>
        <span style={{ display: 'block', fontSize: v39 ? 12.5 : 9.5, color: 'var(--ps-ink-3)', fontWeight: v39 ? 400 : 500, lineHeight: 1.55 }}>{sub}</span>
      </span>
      <span className="material-symbols-outlined" style={{ fontSize: 17, color: on ? 'var(--ps-accent-ink)' : 'var(--ps-ink-5)' }}>
        {kunci ? 'lock' : on ? 'radio_button_checked' : 'radio_button_unchecked'}
      </span>
    </button>
  );
}

/* ★ Suis padat "Simpan gambar daripada jawapan ini" (2026-09-11) — versi kecil
   `Toggle` untuk duduk di bawah setiap textarea perbualan Langkah 2. `mati` hanya
   menghalang MENGHIDUPKAN (had 4 pusingan bertanda); suis yang sudah hidup sentiasa
   boleh dimatikan supaya pelanggan tidak terperangkap. */
function SuisGambar({ on, onClick, label, v39, mati = false, tip = '' }) {
  const sekat = mati && !on;
  return (
    <button
      type="button" onClick={onClick} disabled={sekat} title={tip || ''}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 7, marginTop: 6,
        padding: '4px 9px 4px 4px', borderRadius: 999,
        cursor: sekat ? 'not-allowed' : 'pointer', opacity: sekat ? 0.5 : 1,
        background: on ? 'var(--ps-accent-soft-3)' : 'transparent',
        border: `1px solid ${on ? 'var(--ps-accent)' : 'var(--ps-line' + (v39 ? '-strong' : '') + ')'}`,
      }}
    >
      <span style={{
        width: 28, height: 16, borderRadius: 999, flex: '0 0 auto', position: 'relative',
        background: on ? 'var(--ps-accent)' : 'var(--ps-fill-2)', transition: 'background 0.15s',
      }}>
        <span style={{
          position: 'absolute', top: 2, left: on ? 14 : 2, width: 12, height: 12, borderRadius: 999,
          background: 'var(--ps-knob)', transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
        }} />
      </span>
      <span className="material-symbols-outlined" style={{ fontSize: 14, color: on ? 'var(--ps-accent-deep)' : 'var(--ps-ink-3)' }}>image</span>
      <span style={{ fontSize: v39 ? 12.5 : 10.5, fontWeight: 700, color: on ? 'var(--ps-accent-deep)' : 'var(--ps-ink-2)' }}>{label}</span>
    </button>
  );
}

/* ⚠️ `T` ialah prop PILIHAN — peraturan komponen dikongsi dua rupa.
   Tanpa `T`, ayat Melayu asal dipulangkan (rupa lama kekal Melayu). */
function SceneSelect({ T, v39, value, sceneCount, onChange, noneLabel, benarkan, kunciKe }) {
  const S = T || ((_k, lalai) => lalai);
  /* `benarkan` = senarai nilai yang BETUL-BETUL berkesan pada enjin semasa.
     Tiada senarai = semua dibenarkan (kelakuan asal). */
  const bolehPilih = (v) => !benarkan || benarkan.includes(v);
  /* `kunciKe` = kunci dropdown pada SATU nilai tetap (tak boleh tukar).
     Dipakai untuk "Every scene" sehingga engine dinamik menyokong per-babak.
     Ia paksa PAPARAN sahaja — tidak menulis apa-apa ke keadaan agent. */
  const terkunci = kunciKe != null;
  const raw = terkunci
    ? String(kunciKe)
    : (value === 'none' ? 'none' : value === 'all' ? 'all' : String(value));
  return (
    <select
      value={raw}
      disabled={terkunci}
      onChange={terkunci ? undefined : (e) => {
        const v = e.target.value;
        onChange(v === 'none' || v === 'all' ? v : Number(v));
      }}
      style={terkunci ? { ...sel(v39), opacity: 0.55, cursor: 'not-allowed' } : sel(v39)}
    >
      <option value="none" disabled={!bolehPilih('none')}>{noneLabel}</option>
      <option value="all" disabled={!bolehPilih('all')}>{S('prostudio.agentsec.sceneEvery', 'Setiap babak')}</option>
      {Array.from({ length: sceneCount }, (_, i) => i + 1).map(n => (
        <option key={n} value={String(n)} disabled={!bolehPilih(n)}>{S('prostudio.agentsec.sceneOnly', `Babak ${n} sahaja`, { n })}</option>
      ))}
    </select>
  );
}

/* Kad pratonton — rupa kad produk Workspace + teks SEBENAR (hasil applyRecipe).
   Dumb: parent kira `rows` + hantar; ia update automatik bila composer diedit
   kerana parent kira semula setiap render. ROLE_META (aras modul) beri ikon. */
function PratontonKad({ v39, T, product, rows, setNo, setCount, onSet }) {
  return (
    <div style={{ marginTop: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: v39 ? 13 : 11, fontWeight: 800, color: 'var(--ps-ink)' }}>
          {T('prostudio.agentsec.previewKadTitle', 'Pratonton kad produk')}
        </span>
        <span style={{ fontSize: v39 ? 12 : 9.5, color: 'var(--ps-ink-3)', fontWeight: v39 ? 400 : 600 }}>
          {T('prostudio.agentsec.previewHint', 'Beginilah rupa di Workspace. Teks datang dari output Gem semasa Configure.')}
        </span>
      </div>

      <div style={{ background: 'var(--ps-card)', border: '1px solid var(--ps-line)', borderRadius: 12, overflow: 'hidden' }}>
        {/* Kepala kad — gambar + nama produk + pemilih set */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 13px', borderBottom: '1px solid var(--ps-line-soft)', background: 'var(--ps-fill-3)' }}>
          {product?.image
            ? <img src={product.image} alt="" style={{ width: 34, height: 34, borderRadius: 8, objectFit: 'cover', flex: 'none' }} />
            : <span className="material-symbols-outlined" style={{ fontSize: 22, color: 'var(--ps-ink-4)', flex: 'none' }}>inventory_2</span>}
          <span style={{ flex: 1, minWidth: 0, fontSize: v39 ? 13 : 11.5, fontWeight: 700, color: 'var(--ps-ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {product?.name || T('prostudio.agentsec.previewKadProduk', 'Produk ujian')}
          </span>
          {setCount > 1 && (
            <div style={{ display: 'flex', gap: 4, flex: 'none' }}>
              {Array.from({ length: setCount }, (_, k) => k + 1).map(n => (
                <button key={n} type="button" onClick={() => onSet(n)} style={{
                  fontSize: v39 ? 11.5 : 10, fontWeight: 700, padding: '3px 9px', borderRadius: 999, cursor: 'pointer',
                  border: `1px solid ${n === setNo ? 'var(--ps-accent-line)' : 'var(--ps-line)'}`,
                  background: n === setNo ? 'var(--ps-accent-soft-3)' : 'transparent',
                  color: n === setNo ? 'var(--ps-accent-deep)' : 'var(--ps-ink-3)',
                }}>{T('prostudio.agentsec.previewSet', `Set ${n}`, { n })}</button>
              ))}
            </div>
          )}
        </div>

        {/* Medan yang sudah diselesaikan (teks sebenar) */}
        <div style={{ padding: '11px 13px', display: 'flex', flexDirection: 'column', gap: 11 }}>
          {rows.map(r => (
            <div key={r.id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <span className="material-symbols-outlined" style={{ fontSize: 14, color: r.role === 'text' ? 'var(--ps-ink-4)' : 'var(--ps-accent-ink)' }}>
                  {ROLE_META[r.role].icon}
                </span>
                <span style={{ fontSize: v39 ? 12.5 : 10.5, fontWeight: 700, color: 'var(--ps-ink-2)' }}>{r.label}</span>
              </div>
              <div style={{
                fontSize: v39 ? 12.5 : 10.5, lineHeight: 1.55, whiteSpace: 'pre-wrap',
                color: r.value ? 'var(--ps-ink)' : 'var(--ps-ink-4)',
                background: 'var(--ps-fill)', border: '1px solid var(--ps-line-soft)', borderRadius: 8,
                padding: '8px 10px', maxHeight: 150, overflowY: 'auto',
              }}>
                {r.value || T('prostudio.agentsec.previewEmpty', '— kosong (agent tidak keluarkan bahagian ini) —')}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* Composer sumber — Fasa 1: satu field boleh GABUNG beberapa blok output Gem.
   User taip teks biasa + selit token @slug (klik cip). Kotak kosong = warisi blok
   yang dipadan AI (deriveTemplate). ⛔ slugifySource dikongsi dengan enjin resipi. */
function SourceComposer({ T, v39, field, sources, onChange }) {
  const S = T || ((_k, lalai) => lalai);
  const taRef = useRef(null);
  const selRef = useRef(null);   // kedudukan kursor terakhir dlm textarea (disimpan masa select/blur)
  const val = deriveTemplate(field);
  const slugs = [...new Set((sources || []).map(slugifySource).filter(Boolean))];

  const saveSel = () => {
    const ta = taRef.current;
    if (ta) selRef.current = { start: ta.selectionStart, end: ta.selectionEnd };
  };
  const insertToken = (slug) => {
    const token = '@' + slug;
    // Klik cip melepaskan fokus textarea; guna kedudukan yang disimpan (bukan
    // baca selepas blur, yang tak boleh dipercayai merentas browser). Tiada
    // kedudukan tersimpan → selit di HUJUNG.
    const sel = selRef.current || {};
    const start = Math.min(Number.isFinite(sel.start) ? sel.start : val.length, val.length);
    const end = Math.min(Number.isFinite(sel.end) ? sel.end : val.length, val.length);
    const needSpace = start > 0 && !/\s$/.test(val.slice(0, start));
    const ins = (needSpace ? ' ' : '') + token;
    const next = val.slice(0, start) + ins + val.slice(end);
    const p = start + ins.length;
    selRef.current = { start: p, end: p };
    onChange(next);
    requestAnimationFrame(() => {
      try { const ta = taRef.current; if (ta) { ta.focus(); ta.setSelectionRange(p, p); } } catch { /* abai */ }
    });
  };

  return (
    <div>
      <textarea
        ref={taRef}
        value={val}
        onChange={(e) => onChange(e.target.value)}
        onSelect={saveSel}
        onBlur={saveSel}
        placeholder={S('prostudio.agentsec.composerPh', 'Susun output di sini — klik blok di bawah untuk selitkan.')}
        rows={2}
        style={{
          width: '100%', boxSizing: 'border-box', resize: 'vertical',
          minHeight: v39 ? 46 : 40, padding: v39 ? '8px 10px' : '7px 9px',
          fontSize: v39 ? 12.5 : 11, lineHeight: 1.5, fontFamily: 'inherit',
          border: '1px solid var(--ps-line)', borderRadius: 7,
          background: 'var(--ps-card)', color: 'var(--ps-ink)', outline: 'none',
        }}
      />
      {slugs.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 5, alignItems: 'center' }}>
          <span style={{ fontSize: v39 ? 11 : 9, color: 'var(--ps-ink-3)', fontWeight: v39 ? 400 : 700 }}>
            {S('prostudio.agentsec.composerInsert', 'Klik untuk selit:')}
          </span>
          {slugs.map(sl => (
            <button
              key={sl} type="button" onClick={() => insertToken(sl)} title={`@${sl}`}
              style={{
                fontSize: v39 ? 11.5 : 10, fontFamily: 'ui-monospace, SFMono-Regular, monospace', fontWeight: 500,
                padding: '2px 8px', borderRadius: 999, cursor: 'pointer',
                background: 'var(--ps-accent-soft-3)', color: 'var(--ps-accent-deep)',
                border: '1px solid var(--ps-accent-line)', whiteSpace: 'nowrap',
              }}
            >@{sl}</button>
          ))}
        </div>
      )}
    </div>
  );
}

function MatchTable({ T, v39, groupTitle, fields, sources = [], onChange }) {
  const S = T || ((_k, lalai) => lalai);
  if (!fields.length) return null;
  return (
    <div style={{ border: '1px solid var(--ps-line-2)', borderRadius: 10, overflow: 'hidden' }}>
      <div style={{ padding: '6px 11px', background: 'var(--ps-fill)', borderBottom: '1px solid var(--ps-line-2)' }}>
        <span style={v39
          ? { fontSize: 12.5, color: 'var(--ps-ink-2)' }
          : { fontSize: v39 ? 11 : 9, fontWeight: 900, color: 'var(--ps-ink-2)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{groupTitle}</span>
      </div>
      {fields.map((f, i) => {
        const ok = fieldIsMapped(f, sources);
        const isEngine = f.role !== 'text';
        return (
          <div key={f.id} style={{
            padding: '9px 11px',
            borderBottom: i === fields.length - 1 ? 'none' : '1px solid var(--ps-line-soft)',
            background: !ok && isEngine ? 'var(--ps-warn-soft-2)' : 'var(--ps-card)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6, minWidth: 0 }}>
              <span className="material-symbols-outlined" style={{ fontSize: 14, color: isEngine ? 'var(--ps-accent-ink)' : 'var(--ps-ink-4)' }}>
                {ROLE_META[f.role].icon}
              </span>
              <span style={{
                flex: 1, minWidth: 0, fontSize: v39 ? 13 : 11, fontWeight: v39 ? 500 : 700, color: 'var(--ps-ink-strong)',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>{f.namaPapar || fieldLabel(f, S)}</span>
              <span className="material-symbols-outlined" style={{
                fontSize: 16, color: ok ? 'var(--ps-ok)' : (isEngine ? 'var(--ps-warn)' : 'var(--ps-ink-4)'),
              }}>{ok ? 'check_circle' : (isEngine ? 'error' : 'remove')}</span>
            </div>
            <SourceComposer T={T} v39={v39} field={f} sources={sources} onChange={(tpl) => onChange(f.id, tpl)} />
          </div>
        );
      })}
    </div>
  );
}
